webpackJsonp([28313394369846],{

/***/ 139:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	/**
	 * Smooth scrolling onClick event handler
	 * @param {string} selector argument will be passed to `querySelector`, usually an HTML id
	 */
	var scrollTo = function scrollTo(selector) {
	  document.querySelector(selector).scrollIntoView({
	    behavior: 'smooth',
	    block: 'start'
	  });
	};
	
	var _default = scrollTo;
	exports["default"] = _default;

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.2.1
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		var registeredInModuleLoader;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			registeredInModuleLoader = true;
		}
		if (true) {
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function decode (s) {
			return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
		}
	
		function init (converter) {
			function api() {}
	
			function set (key, value, attributes) {
				if (typeof document === 'undefined') {
					return;
				}
	
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);
	
				if (typeof attributes.expires === 'number') {
					attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
				}
	
				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
	
				try {
					var result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}
	
				value = converter.write ?
					converter.write(value, key) :
					encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
	
				key = encodeURIComponent(String(key))
					.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
					.replace(/[\(\)]/g, escape);
	
				var stringifiedAttributes = '';
				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
	
					// Considers RFC 6265 section 5.2:
					// ...
					// 3.  If the remaining unparsed-attributes contains a %x3B (";")
					//     character:
					// Consume the characters of the unparsed-attributes up to,
					// not including, the first %x3B (";") character.
					// ...
					stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
				}
	
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}
	
			function get (key, json) {
				if (typeof document === 'undefined') {
					return;
				}
	
				var jar = {};
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all.
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');
	
					if (!json && cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						var name = decode(parts[0]);
						cookie = (converter.read || converter)(cookie, name) ||
							decode(cookie);
	
						if (json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						jar[name] = cookie;
	
						if (key === name) {
							break;
						}
					} catch (e) {}
				}
	
				return key ? jar[key] : jar;
			}
	
			api.set = set;
			api.get = function (key) {
				return get(key, false /* read as raw */);
			};
			api.getJSON = function (key) {
				return get(key, true /* read as json */);
			};
			api.remove = function (key, attributes) {
				set(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.defaults = {};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	}));


/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(13),
	    root = __webpack_require__(11);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(13),
	    root = __webpack_require__(11);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(13),
	    root = __webpack_require__(11);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(13),
	    root = __webpack_require__(11);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(11);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(13),
	    root = __webpack_require__(11);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(90),
	    isArguments = __webpack_require__(107),
	    isArray = __webpack_require__(108),
	    isBuffer = __webpack_require__(110),
	    isIndex = __webpack_require__(98),
	    isTypedArray = __webpack_require__(111);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),

/***/ 85:
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(35),
	    getRawTag = __webpack_require__(95),
	    objectToString = __webpack_require__(104);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(15),
	    isObjectLike = __webpack_require__(21);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(38),
	    isMasked = __webpack_require__(99),
	    isObject = __webpack_require__(40),
	    toSource = __webpack_require__(37);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(15),
	    isLength = __webpack_require__(39),
	    isObjectLike = __webpack_require__(21);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(100),
	    nativeKeys = __webpack_require__(102);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),

/***/ 90:
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(85);
	
	/**
	 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	 * of key-value pairs for `object` corresponding to the property names of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the key-value pairs.
	 */
	function baseToPairs(object, props) {
	  return arrayMap(props, function(key) {
	    return [key, object[key]];
	  });
	}
	
	module.exports = baseToPairs;


/***/ }),

/***/ 92:
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(11);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	var baseToPairs = __webpack_require__(91),
	    getTag = __webpack_require__(96),
	    mapToArray = __webpack_require__(101),
	    setToPairs = __webpack_require__(106);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/**
	 * Creates a `_.toPairs` or `_.toPairsIn` function.
	 *
	 * @private
	 * @param {Function} keysFunc The function to get the keys of a given object.
	 * @returns {Function} Returns the new pairs function.
	 */
	function createToPairs(keysFunc) {
	  return function(object) {
	    var tag = getTag(object);
	    if (tag == mapTag) {
	      return mapToArray(object);
	    }
	    if (tag == setTag) {
	      return setToPairs(object);
	    }
	    return baseToPairs(object, keysFunc(object));
	  };
	}
	
	module.exports = createToPairs;


/***/ }),

/***/ 36:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(87),
	    getValue = __webpack_require__(97);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(35);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(79),
	    Map = __webpack_require__(80),
	    Promise = __webpack_require__(81),
	    Set = __webpack_require__(82),
	    WeakMap = __webpack_require__(83),
	    baseGetTag = __webpack_require__(15),
	    toSource = __webpack_require__(37);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),

/***/ 97:
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),

/***/ 98:
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(93);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),

/***/ 100:
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),

/***/ 101:
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(105);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(36);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50)(module)))

/***/ }),

/***/ 104:
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),

/***/ 105:
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(36);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),

/***/ 106:
/***/ (function(module, exports) {

	/**
	 * Converts `set` to its value-value pairs.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the value-value pairs.
	 */
	function setToPairs(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = [value, value];
	  });
	  return result;
	}
	
	module.exports = setToPairs;


/***/ }),

/***/ 37:
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(86),
	    isObjectLike = __webpack_require__(21);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),

/***/ 108:
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(38),
	    isLength = __webpack_require__(39);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(11),
	    stubFalse = __webpack_require__(114);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50)(module)))

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(15),
	    isObject = __webpack_require__(40);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),

/***/ 39:
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),

/***/ 40:
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),

/***/ 21:
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(88),
	    baseUnary = __webpack_require__(92),
	    nodeUtil = __webpack_require__(103);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(84),
	    baseKeys = __webpack_require__(89),
	    isArrayLike = __webpack_require__(109);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),

/***/ 114:
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

	var createToPairs = __webpack_require__(94),
	    keys = __webpack_require__(112);
	
	/**
	 * Creates an array of own enumerable string keyed-value pairs for `object`
	 * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	 * entries are returned.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @alias entries
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the key-value pairs.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.toPairs(new Foo);
	 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	 */
	var toPairs = createToPairs(keys);
	
	module.exports = toPairs;


/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

	var querystring = __webpack_require__(119);
	var toPairs = __webpack_require__(115);
	
	var qp = {
	  toString: function (params) {
	    var str = '';
	    toPairs(params)
	      .sort()
	      .map(function(param) {
	          if (param[1] !== undefined) {
	              if (str !== '') str += '&';
	              str += param[0] + '=' + encodeURIComponent(param[1]);
	          }
	      });
	    return str;
	  },
	
	  toObject: function (str) {
	    return querystring.parse(str);
	  }
	};
	
	//
	module.exports = qp;


/***/ }),

/***/ 117:
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ }),

/***/ 118:
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(117);
	exports.encode = exports.stringify = __webpack_require__(118);


/***/ }),

/***/ 27:
/***/ (function(module, exports) {

	/*
	      The MIT License (MIT)
	
	Copyright (c) 2016 Shopify Inc.
	
	Permission is hereby granted, free of charge, to any person obtaining a
	copy of this software and associated documentation files (the
	"Software"), to deal in the Software without restriction, including
	without limitation the rights to use, copy, modify, merge, publish,
	distribute, sublicense, and/or sell copies of the Software, and to
	permit persons to whom the Software is furnished to do so, subject to
	the following conditions:
	
	The above copyright notice and this permission notice shall be included
	in all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	      */
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	
	
	
	
	
	
	
	
	
	
	var classCallCheck$1 = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass$1 = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	
	
	
	
	var inherits$1 = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	
	
	
	
	
	
	
	
	
	
	var possibleConstructorReturn$1 = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	/*
	The MIT License (MIT)
	Copyright (c) 2016 Shopify Inc.
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in all
	copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	OR OTHER DEALINGS IN THE SOFTWARE.
	
	
	*/
	function join() {
	  for (var _len = arguments.length, fields = Array(_len), _key = 0; _key < _len; _key++) {
	    fields[_key] = arguments[_key];
	  }
	
	  return fields.join(' ');
	}
	
	function isObject(value) {
	  return Boolean(value) && Object.prototype.toString.call(value.valueOf()) === '[object Object]';
	}
	
	function deepFreezeCopyExcept(predicate, structure) {
	  if (predicate(structure)) {
	    return structure;
	  } else if (isObject(structure)) {
	    return Object.freeze(Object.keys(structure).reduce(function (copy, key) {
	      copy[key] = deepFreezeCopyExcept(predicate, structure[key]);
	
	      return copy;
	    }, {}));
	  } else if (Array.isArray(structure)) {
	    return Object.freeze(structure.map(function (item) {
	      return deepFreezeCopyExcept(predicate, item);
	    }));
	  } else {
	    return structure;
	  }
	}
	
	function schemaForType(typeBundle, typeName) {
	  var typeSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var type = typeBundle.types[typeName];
	
	  if (type) {
	    return type;
	  } else if (typeSchema && typeSchema.kind === 'INTERFACE') {
	    return typeSchema;
	  }
	
	  throw new Error('No type of ' + typeName + ' found in schema');
	}
	
	var classCallCheck = function classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var inherits = function inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	};
	
	var slicedToArray = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if (Symbol.iterator in Object(arr)) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();
	
	var toConsumableArray = function toConsumableArray(arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }return arr2;
	  } else {
	    return Array.from(arr);
	  }
	};
	
	var VariableDefinition = function () {
	
	  /**
	   * This constructor should not be invoked directly.
	   * Use the factory function {@link Client#variable} to create a VariableDefinition.
	   *
	   * @param {String} name The name of the variable.
	   * @param {String} type The GraphQL type of the variable.
	   * @param {*} [defaultValue] The default value of the variable.
	   */
	  function VariableDefinition(name, type, defaultValue) {
	    classCallCheck(this, VariableDefinition);
	
	    this.name = name;
	    this.type = type;
	    this.defaultValue = defaultValue;
	    Object.freeze(this);
	  }
	
	  /**
	   * Returns the GraphQL query string for the variable as an input value (e.g. `$variableName`).
	   *
	   * @return {String} The GraphQL query string for the variable as an input value.
	   */
	
	  createClass(VariableDefinition, [{
	    key: 'toInputValueString',
	    value: function toInputValueString() {
	      return '$' + this.name;
	    }
	
	    /**
	     * Returns the GraphQL query string for the variable (e.g. `$variableName:VariableType = defaultValue`).
	     *
	     * @return {String} The GraphQL query string for the variable.
	     */
	
	  }, {
	    key: 'toString',
	    value: function toString() {
	      var defaultValueString = this.defaultValue ? ' = ' + formatInputValue(this.defaultValue) : '';
	
	      return '$' + this.name + ':' + this.type + defaultValueString;
	    }
	  }]);
	  return VariableDefinition;
	}();
	
	function isVariable(value) {
	  return VariableDefinition.prototype.isPrototypeOf(value);
	}
	
	function variable(name, type, defaultValue) {
	  return new VariableDefinition(name, type, defaultValue);
	}
	
	var Enum = function () {
	
	  /**
	   * This constructor should not be invoked directly.
	   * Use the factory function {@link Client#enum} to create an Enum.
	   *
	   * @param {String} key The key of the enum.
	   */
	  function Enum(key) {
	    classCallCheck(this, Enum);
	
	    this.key = key;
	  }
	
	  /**
	   * Returns the GraphQL query string for the enum (e.g. `enumKey`).
	   *
	   * @return {String} The GraphQL query string for the enum.
	   */
	
	  createClass(Enum, [{
	    key: "toString",
	    value: function toString() {
	      return this.key;
	    }
	  }, {
	    key: "valueOf",
	    value: function valueOf() {
	      return this.key.valueOf();
	    }
	  }]);
	  return Enum;
	}();
	
	var enumFunction = function enumFunction(key) {
	  return new Enum(key);
	};
	
	var Scalar = function () {
	  function Scalar(value) {
	    classCallCheck(this, Scalar);
	
	    this.value = value;
	  }
	
	  createClass(Scalar, [{
	    key: "toString",
	    value: function toString() {
	      return this.value.toString();
	    }
	  }, {
	    key: "valueOf",
	    value: function valueOf() {
	      return this.value.valueOf();
	    }
	  }, {
	    key: "unwrapped",
	    get: function get$$1() {
	      return this.value;
	    }
	  }]);
	  return Scalar;
	}();
	
	function formatInputValue(value) {
	  if (VariableDefinition.prototype.isPrototypeOf(value)) {
	    return value.toInputValueString();
	  } else if (Enum.prototype.isPrototypeOf(value)) {
	    return String(value);
	  } else if (Scalar.prototype.isPrototypeOf(value)) {
	    return JSON.stringify(value.valueOf());
	  } else if (Array.isArray(value)) {
	    return '[' + join.apply(undefined, toConsumableArray(value.map(formatInputValue))) + ']';
	  } else if (isObject(value)) {
	    return formatObject(value, '{', '}');
	  } else {
	    return JSON.stringify(value);
	  }
	}
	
	function formatObject(value) {
	  var openChar = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var closeChar = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	  var argPairs = Object.keys(value).map(function (key) {
	    return key + ': ' + formatInputValue(value[key]);
	  });
	
	  return '' + openChar + join.apply(undefined, toConsumableArray(argPairs)) + closeChar;
	}
	
	function formatArgs(args) {
	  if (!Object.keys(args).length) {
	    return '';
	  }
	
	  return ' (' + formatObject(args) + ')';
	}
	
	// eslint-disable-next-line no-empty-function
	var noop = function noop() {};
	
	var Profiler = {
	  trackTypeDependency: noop,
	  trackFieldDependency: noop
	};
	
	var trackTypeDependency = Profiler.trackTypeDependency;
	var trackFieldDependency = Profiler.trackFieldDependency;
	
	function parseFieldCreationArgs(creationArgs) {
	  var callback = noop;
	  var options = {};
	  var selectionSet = null;
	
	  if (creationArgs.length === 2) {
	    if (typeof creationArgs[1] === 'function') {
	      var _creationArgs = slicedToArray(creationArgs, 2);
	
	      options = _creationArgs[0];
	      callback = _creationArgs[1];
	    } else {
	      var _creationArgs2 = slicedToArray(creationArgs, 2);
	
	      options = _creationArgs2[0];
	      selectionSet = _creationArgs2[1];
	    }
	  } else if (creationArgs.length === 1) {
	    // SelectionSet is defined before this function is called since it's
	    // called by SelectionSet
	    // eslint-disable-next-line no-use-before-define
	    if (SelectionSet.prototype.isPrototypeOf(creationArgs[0])) {
	      selectionSet = creationArgs[0];
	    } else if (typeof creationArgs[0] === 'function') {
	      callback = creationArgs[0];
	    } else {
	      options = creationArgs[0];
	    }
	  }
	
	  return { options: options, selectionSet: selectionSet, callback: callback };
	}
	
	var emptyArgs = Object.freeze({});
	
	var Field = function () {
	
	  /**
	   * This constructor should not be invoked directly.
	   * Fields are added to a selection by {@link SelectionSetBuilder#add}, {@link SelectionSetBuilder#addConnection}
	   * and {@link SelectionSetBuilder#addInlineFragmentOn}.
	   *
	   * @param {String} name The name of the field.
	   * @param {Object} [options] An options object containing:
	   *   @param {Object} [options.args] Arguments for the field.
	   *   @param {String} [options.alias] An alias for the field.
	   * @param {SelectionSet} selectionSet The selection set on the field.
	   */
	  function Field(name, options, selectionSet) {
	    classCallCheck(this, Field);
	
	    this.name = name;
	    this.alias = options.alias || null;
	    this.responseKey = this.alias || this.name;
	    this.args = options.args ? deepFreezeCopyExcept(isVariable, options.args) : emptyArgs;
	    this.selectionSet = selectionSet;
	    Object.freeze(this);
	  }
	
	  /**
	   * Returns the GraphQL query string for the Field (e.g. `catAlias: cat(size: 'small') { name }` or `name`).
	   *
	   * @return {String} The GraphQL query string for the Field.
	   */
	
	  createClass(Field, [{
	    key: 'toString',
	    value: function toString() {
	      var aliasPrefix = this.alias ? this.alias + ': ' : '';
	
	      return '' + aliasPrefix + this.name + formatArgs(this.args) + this.selectionSet;
	    }
	  }]);
	  return Field;
	}();
	
	// This is an interface that defines a usage, and simplifies type checking
	var Spread = function Spread() {
	  classCallCheck(this, Spread);
	};
	
	var InlineFragment = function (_Spread) {
	  inherits(InlineFragment, _Spread);
	
	  /**
	   * This constructor should not be invoked directly.
	   * Use the factory function {@link SelectionSetBuilder#addInlineFragmentOn} to create an InlineFragment.
	   *
	   * @param {String} typeName The type of the fragment.
	   * @param {SelectionSet} selectionSet The selection set on the fragment.
	   */
	  function InlineFragment(typeName, selectionSet) {
	    classCallCheck(this, InlineFragment);
	
	    var _this = possibleConstructorReturn(this, (InlineFragment.__proto__ || Object.getPrototypeOf(InlineFragment)).call(this));
	
	    _this.typeName = typeName;
	    _this.selectionSet = selectionSet;
	    Object.freeze(_this);
	    return _this;
	  }
	
	  /**
	   * Returns the GraphQL query string for the InlineFragment (e.g. `... on Cat { name }`).
	   *
	   * @return {String} The GraphQL query string for the InlineFragment.
	   */
	
	  createClass(InlineFragment, [{
	    key: 'toString',
	    value: function toString() {
	      return '... on ' + this.typeName + this.selectionSet;
	    }
	  }]);
	  return InlineFragment;
	}(Spread);
	
	var FragmentSpread = function (_Spread2) {
	  inherits(FragmentSpread, _Spread2);
	
	  /**
	   * This constructor should not be invoked directly.
	   * Use the factory function {@link Document#defineFragment} to create a FragmentSpread.
	   *
	   * @param {FragmentDefinition} fragmentDefinition The corresponding fragment definition.
	   */
	  function FragmentSpread(fragmentDefinition) {
	    classCallCheck(this, FragmentSpread);
	
	    var _this2 = possibleConstructorReturn(this, (FragmentSpread.__proto__ || Object.getPrototypeOf(FragmentSpread)).call(this));
	
	    _this2.name = fragmentDefinition.name;
	    _this2.selectionSet = fragmentDefinition.selectionSet;
	    Object.freeze(_this2);
	    return _this2;
	  }
	
	  /**
	   * Returns the GraphQL query string for the FragmentSpread (e.g. `...catName`).
	   *
	   * @return {String} The GraphQL query string for the FragmentSpread.
	   */
	
	  createClass(FragmentSpread, [{
	    key: 'toString',
	    value: function toString() {
	      return '...' + this.name;
	    }
	  }, {
	    key: 'toDefinition',
	    value: function toDefinition() {
	      // eslint-disable-next-line no-use-before-define
	      return new FragmentDefinition(this.name, this.selectionSet.typeSchema.name, this.selectionSet);
	    }
	  }]);
	  return FragmentSpread;
	}(Spread);
	
	var FragmentDefinition = function () {
	
	  /**
	   * This constructor should not be invoked directly.
	   * Use the factory function {@link Document#defineFragment} to create a FragmentDefinition on a {@link Document}.
	   *
	   * @param {String} name The name of the fragment definition.
	   * @param {String} typeName The type of the fragment.
	   */
	  function FragmentDefinition(name, typeName, selectionSet) {
	    classCallCheck(this, FragmentDefinition);
	
	    this.name = name;
	    this.typeName = typeName;
	    this.selectionSet = selectionSet;
	    this.spread = new FragmentSpread(this);
	    Object.freeze(this);
	  }
	
	  /**
	   * Returns the GraphQL query string for the FragmentDefinition (e.g. `fragment catName on Cat { name }`).
	   *
	   * @return {String} The GraphQL query string for the FragmentDefinition.
	   */
	
	  createClass(FragmentDefinition, [{
	    key: 'toString',
	    value: function toString() {
	      return 'fragment ' + this.name + ' on ' + this.typeName + ' ' + this.selectionSet;
	    }
	  }]);
	  return FragmentDefinition;
	}();
	
	function selectionsHaveIdField(selections) {
	  return selections.some(function (fieldOrFragment) {
	    if (Field.prototype.isPrototypeOf(fieldOrFragment)) {
	      return fieldOrFragment.name === 'id';
	    } else if (Spread.prototype.isPrototypeOf(fieldOrFragment) && fieldOrFragment.selectionSet.typeSchema.implementsNode) {
	      return selectionsHaveIdField(fieldOrFragment.selectionSet.selections);
	    }
	
	    return false;
	  });
	}
	
	function selectionsHaveTypenameField(selections) {
	  return selections.some(function (fieldOrFragment) {
	    if (Field.prototype.isPrototypeOf(fieldOrFragment)) {
	      return fieldOrFragment.name === '__typename';
	    } else if (Spread.prototype.isPrototypeOf(fieldOrFragment) && fieldOrFragment.selectionSet.typeSchema.implementsNode) {
	      return selectionsHaveTypenameField(fieldOrFragment.selectionSet.selections);
	    }
	
	    return false;
	  });
	}
	
	function indexSelectionsByResponseKey(selections) {
	  function assignOrPush(obj, key, value) {
	    if (Array.isArray(obj[key])) {
	      obj[key].push(value);
	    } else {
	      obj[key] = [value];
	    }
	  }
	  var unfrozenObject = selections.reduce(function (acc, selection) {
	    if (selection.responseKey) {
	      assignOrPush(acc, selection.responseKey, selection);
	    } else {
	      var responseKeys = Object.keys(selection.selectionSet.selectionsByResponseKey);
	
	      responseKeys.forEach(function (responseKey) {
	        assignOrPush(acc, responseKey, selection);
	      });
	    }
	
	    return acc;
	  }, {});
	
	  Object.keys(unfrozenObject).forEach(function (key) {
	    Object.freeze(unfrozenObject[key]);
	  });
	
	  return Object.freeze(unfrozenObject);
	}
	
	/**
	 * Class that specifies the full selection of data to query.
	 */
	
	var SelectionSet = function () {
	
	  /**
	   * This constructor should not be invoked directly. SelectionSets are created when building queries/mutations.
	   *
	   * @param {Object} typeBundle A set of ES6 modules generated by {@link https://github.com/Shopify/graphql-js-schema|graphql-js-schema}.
	   * @param {(Object|String)} type The type of the current selection.
	   * @param {Function} builderFunction Callback function used to build the SelectionSet.
	   *   The callback takes a {@link SelectionSetBuilder} as its argument.
	   */
	  function SelectionSet(typeBundle, type, builderFunction) {
	    classCallCheck(this, SelectionSet);
	
	    if (typeof type === 'string') {
	      this.typeSchema = schemaForType(typeBundle, type);
	    } else {
	      this.typeSchema = type;
	    }
	
	    trackTypeDependency(this.typeSchema.name);
	
	    this.typeBundle = typeBundle;
	    this.selections = [];
	    if (builderFunction) {
	      // eslint-disable-next-line no-use-before-define
	      builderFunction(new SelectionSetBuilder(this.typeBundle, this.typeSchema, this.selections));
	    }
	
	    if (this.typeSchema.implementsNode || this.typeSchema.name === 'Node') {
	      if (!selectionsHaveIdField(this.selections)) {
	        this.selections.unshift(new Field('id', {}, new SelectionSet(typeBundle, 'ID')));
	      }
	    }
	
	    if (this.typeSchema.kind === 'INTERFACE') {
	      if (!selectionsHaveTypenameField(this.selections)) {
	        this.selections.unshift(new Field('__typename', {}, new SelectionSet(typeBundle, 'String')));
	      }
	    }
	
	    this.selectionsByResponseKey = indexSelectionsByResponseKey(this.selections);
	    Object.freeze(this.selections);
	    Object.freeze(this);
	  }
	
	  /**
	   * Returns the GraphQL query string for the SelectionSet (e.g. `{ cat { name } }`).
	   *
	   * @return {String} The GraphQL query string for the SelectionSet.
	   */
	
	  createClass(SelectionSet, [{
	    key: 'toString',
	    value: function toString() {
	      if (this.typeSchema.kind === 'SCALAR' || this.typeSchema.kind === 'ENUM') {
	        return '';
	      } else {
	        return ' { ' + join(this.selections) + ' }';
	      }
	    }
	  }]);
	  return SelectionSet;
	}();
	
	var SelectionSetBuilder = function () {
	
	  /**
	   * This constructor should not be invoked directly. SelectionSetBuilders are created when building queries/mutations.
	   *
	   * @param {Object} typeBundle A set of ES6 modules generated by {@link https://github.com/Shopify/graphql-js-schema|graphql-js-schema}.
	   * @param {Object} typeSchema The schema object for the type of the current selection.
	   * @param {Field[]} selections The fields on the current selection.
	   */
	  function SelectionSetBuilder(typeBundle, typeSchema, selections) {
	    classCallCheck(this, SelectionSetBuilder);
	
	    this.typeBundle = typeBundle;
	    this.typeSchema = typeSchema;
	    this.selections = selections;
	  }
	
	  createClass(SelectionSetBuilder, [{
	    key: 'hasSelectionWithResponseKey',
	    value: function hasSelectionWithResponseKey(responseKey) {
	      return this.selections.some(function (field) {
	        return field.responseKey === responseKey;
	      });
	    }
	
	    /**
	     * Adds a field to be queried on the current selection.
	     *
	     * @example
	     * client.query((root) => {
	     *   root.add('cat', {args: {id: '123456'}, alias: 'meow'}, (cat) => {
	     *     cat.add('name');
	     *   });
	     * });
	     *
	     * @param {SelectionSet|String} selectionOrFieldName The selection or name of the field to add.
	     * @param {Object} [options] Options on the query including:
	     *   @param {Object} [options.args] Arguments on the query (e.g. `{id: '123456'}`).
	     *   @param {String} [options.alias] Alias for the field being added.
	     * @param {Function|SelectionSet} [callbackOrSelectionSet] Either a callback which will be used to create a new {@link SelectionSet}, or an existing {@link SelectionSet}.
	     */
	
	  }, {
	    key: 'add',
	    value: function add(selectionOrFieldName) {
	      var selection = void 0;
	
	      if (Object.prototype.toString.call(selectionOrFieldName) === '[object String]') {
	        trackFieldDependency(this.typeSchema.name, selectionOrFieldName);
	
	        for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	          rest[_key - 1] = arguments[_key];
	        }
	
	        selection = this.field.apply(this, [selectionOrFieldName].concat(rest));
	      } else {
	        if (Field.prototype.isPrototypeOf(selectionOrFieldName)) {
	          trackFieldDependency(this.typeSchema.name, selectionOrFieldName.name);
	        }
	
	        selection = selectionOrFieldName;
	      }
	
	      if (selection.responseKey && this.hasSelectionWithResponseKey(selection.responseKey)) {
	        throw new Error('The field name or alias \'' + selection.responseKey + '\' has already been added.');
	      }
	      this.selections.push(selection);
	    }
	  }, {
	    key: 'field',
	    value: function field(name) {
	      for (var _len2 = arguments.length, creationArgs = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        creationArgs[_key2 - 1] = arguments[_key2];
	      }
	
	      var parsedArgs = parseFieldCreationArgs(creationArgs);
	      var options = parsedArgs.options,
	          callback = parsedArgs.callback;
	      var selectionSet = parsedArgs.selectionSet;
	
	      if (!selectionSet) {
	        if (!this.typeSchema.fieldBaseTypes[name]) {
	          throw new Error('No field of name "' + name + '" found on type "' + this.typeSchema.name + '" in schema');
	        }
	
	        var fieldBaseType = schemaForType(this.typeBundle, this.typeSchema.fieldBaseTypes[name]);
	
	        selectionSet = new SelectionSet(this.typeBundle, fieldBaseType, callback);
	      }
	
	      return new Field(name, options, selectionSet);
	    }
	
	    /**
	     * Creates an inline fragment.
	     *
	     * @access private
	     * @param {String} typeName The type  the inline fragment.
	     * @param {Function|SelectionSet}  [callbackOrSelectionSet] Either a callback which will be used to create a new {@link SelectionSet}, or an existing {@link SelectionSet}.
	     * @return {InlineFragment} An inline fragment.
	     */
	
	  }, {
	    key: 'inlineFragmentOn',
	    value: function inlineFragmentOn(typeName) {
	      var builderFunctionOrSelectionSet = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
	
	      var selectionSet = void 0;
	
	      if (SelectionSet.prototype.isPrototypeOf(builderFunctionOrSelectionSet)) {
	        selectionSet = builderFunctionOrSelectionSet;
	      } else {
	        selectionSet = new SelectionSet(this.typeBundle, schemaForType(this.typeBundle, typeName), builderFunctionOrSelectionSet);
	      }
	
	      return new InlineFragment(typeName, selectionSet);
	    }
	
	    /**
	     * Adds a field to be queried on the current selection.
	     *
	     * @access private
	     * @param {String}    name The name of the field to add to the query.
	     * @param {Object} [options] Options on the query including:
	     *   @param {Object} [options.args] Arguments on the query (e.g. `{id: '123456'}`).
	     *   @param {String} [options.alias] Alias for the field being added.
	     * @param {Function}  [callback] Callback which will be used to create a new {@link SelectionSet} for the field added.
	     */
	
	  }, {
	    key: 'addField',
	    value: function addField(name) {
	      for (var _len3 = arguments.length, creationArgs = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	        creationArgs[_key3 - 1] = arguments[_key3];
	      }
	
	      this.add.apply(this, [name].concat(creationArgs));
	    }
	
	    /**
	     * Adds a connection to be queried on the current selection.
	     * This adds all the fields necessary for pagination.
	     *
	     * @example
	     * client.query((root) => {
	     *   root.add('cat', (cat) => {
	     *     cat.addConnection('friends', {args: {first: 10}, alias: 'coolCats'}, (friends) => {
	     *       friends.add('name');
	     *     });
	     *   });
	     * });
	     *
	     * @param {String}    name The name of the connection to add to the query.
	     * @param {Object} [options] Options on the query including:
	     *   @param {Object} [options.args] Arguments on the query (e.g. `{first: 10}`).
	     *   @param {String} [options.alias] Alias for the field being added.
	     * @param {Function|SelectionSet}  [callbackOrSelectionSet] Either a callback which will be used to create a new {@link SelectionSet}, or an existing {@link SelectionSet}.
	     */
	
	  }, {
	    key: 'addConnection',
	    value: function addConnection(name) {
	      for (var _len4 = arguments.length, creationArgs = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	        creationArgs[_key4 - 1] = arguments[_key4];
	      }
	
	      var _parseFieldCreationAr = parseFieldCreationArgs(creationArgs),
	          options = _parseFieldCreationAr.options,
	          callback = _parseFieldCreationAr.callback,
	          selectionSet = _parseFieldCreationAr.selectionSet;
	
	      this.add(name, options, function (connection) {
	        connection.add('pageInfo', {}, function (pageInfo) {
	          pageInfo.add('hasNextPage');
	          pageInfo.add('hasPreviousPage');
	        });
	        connection.add('edges', {}, function (edges) {
	          edges.add('cursor');
	          edges.addField('node', {}, selectionSet || callback); // This is bad. Don't do this
	        });
	      });
	    }
	
	    /**
	     * Adds an inline fragment on the current selection.
	     *
	     * @example
	     * client.query((root) => {
	     *   root.add('animal', (animal) => {
	     *     animal.addInlineFragmentOn('cat', (cat) => {
	     *       cat.add('name');
	     *     });
	     *   });
	     * });
	     *
	     * @param {String} typeName The name of the type of the inline fragment.
	     * @param {Function|SelectionSet}  [callbackOrSelectionSet] Either a callback which will be used to create a new {@link SelectionSet}, or an existing {@link SelectionSet}.
	     */
	
	  }, {
	    key: 'addInlineFragmentOn',
	    value: function addInlineFragmentOn(typeName) {
	      var fieldTypeCb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
	
	      this.add(this.inlineFragmentOn(typeName, fieldTypeCb));
	    }
	
	    /**
	     * Adds a fragment spread on the current selection.
	     *
	     * @example
	     * client.query((root) => {
	     *   root.addFragment(catFragmentSpread);
	     * });
	     *
	     * @param {FragmentSpread} fragmentSpread The fragment spread to add.
	     */
	
	  }, {
	    key: 'addFragment',
	    value: function addFragment(fragmentSpread) {
	      this.add(fragmentSpread);
	    }
	  }]);
	  return SelectionSetBuilder;
	}();
	
	function parseArgs(args) {
	  var name = void 0;
	  var variables = void 0;
	  var selectionSetCallback = void 0;
	
	  if (args.length === 3) {
	    var _args = slicedToArray(args, 3);
	
	    name = _args[0];
	    variables = _args[1];
	    selectionSetCallback = _args[2];
	  } else if (args.length === 2) {
	    if (Object.prototype.toString.call(args[0]) === '[object String]') {
	      name = args[0];
	      variables = null;
	    } else if (Array.isArray(args[0])) {
	      variables = args[0];
	      name = null;
	    }
	
	    selectionSetCallback = args[1];
	  } else {
	    selectionSetCallback = args[0];
	    name = null;
	  }
	
	  return { name: name, variables: variables, selectionSetCallback: selectionSetCallback };
	}
	
	var VariableDefinitions = function () {
	  function VariableDefinitions(variableDefinitions) {
	    classCallCheck(this, VariableDefinitions);
	
	    this.variableDefinitions = variableDefinitions ? [].concat(toConsumableArray(variableDefinitions)) : [];
	    Object.freeze(this.variableDefinitions);
	    Object.freeze(this);
	  }
	
	  createClass(VariableDefinitions, [{
	    key: 'toString',
	    value: function toString() {
	      if (this.variableDefinitions.length === 0) {
	        return '';
	      }
	
	      return ' (' + join(this.variableDefinitions) + ') ';
	    }
	  }]);
	  return VariableDefinitions;
	}();
	
	/**
	 * Base class for {@link Query} and {@link Mutation}.
	 * @abstract
	 */
	
	var Operation = function () {
	
	  /**
	   * This constructor should not be invoked. The subclasses {@link Query} and {@link Mutation} should be used instead.
	   */
	  function Operation(typeBundle, operationType) {
	    classCallCheck(this, Operation);
	
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    var _parseArgs = parseArgs(args),
	        name = _parseArgs.name,
	        variables = _parseArgs.variables,
	        selectionSetCallback = _parseArgs.selectionSetCallback;
	
	    this.typeBundle = typeBundle;
	    this.name = name;
	    this.variableDefinitions = new VariableDefinitions(variables);
	    this.operationType = operationType;
	    if (operationType === 'query') {
	      this.selectionSet = new SelectionSet(typeBundle, typeBundle.queryType, selectionSetCallback);
	      this.typeSchema = schemaForType(typeBundle, typeBundle.queryType);
	    } else {
	      this.selectionSet = new SelectionSet(typeBundle, typeBundle.mutationType, selectionSetCallback);
	      this.typeSchema = schemaForType(typeBundle, typeBundle.mutationType);
	    }
	    Object.freeze(this);
	  }
	
	  /**
	   * Whether the operation is anonymous (i.e. has no name).
	   */
	
	  createClass(Operation, [{
	    key: 'toString',
	
	    /**
	     * Returns the GraphQL query or mutation string (e.g. `query myQuery { cat { name } }`).
	     *
	     * @return {String} The GraphQL query or mutation string.
	     */
	    value: function toString() {
	      var nameString = this.name ? ' ' + this.name : '';
	
	      return '' + this.operationType + nameString + this.variableDefinitions + this.selectionSet;
	    }
	  }, {
	    key: 'isAnonymous',
	    get: function get$$1() {
	      return !this.name;
	    }
	  }]);
	  return Operation;
	}();
	
	/**
	 * GraphQL Query class.
	 * @extends Operation
	 */
	
	var Query = function (_Operation) {
	  inherits(Query, _Operation);
	
	  /**
	   * This constructor should not be invoked directly.
	   * Use the factory functions {@link Client#query} or {@link Document#addQuery} to create a Query.
	   *
	   * @param {Object} typeBundle A set of ES6 modules generated by {@link https://github.com/Shopify/graphql-js-schema|graphql-js-schema}.
	   * @param {String} [name] A name for the query.
	   * @param {Object[]} [variables] A list of variables in the query. See {@link Client#variable}.
	   * @param {Function} selectionSetCallback The query builder callback.
	   *   A {@link SelectionSet} is created using this callback.
	   */
	  function Query(typeBundle) {
	    var _ref;
	
	    classCallCheck(this, Query);
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return possibleConstructorReturn(this, (_ref = Query.__proto__ || Object.getPrototypeOf(Query)).call.apply(_ref, [this, typeBundle, 'query'].concat(args)));
	  }
	
	  return Query;
	}(Operation);
	
	/**
	 * GraphQL Mutation class.
	 * @extends Operation
	 */
	
	var Mutation = function (_Operation) {
	  inherits(Mutation, _Operation);
	
	  /**
	   * This constructor should not be invoked directly.
	   * Use the factory functions {@link Client#mutation} or {@link Document#addMutation} to create a Mutation.
	   *
	   * @param {Object} typeBundle A set of ES6 modules generated by {@link https://github.com/Shopify/graphql-js-schema|graphql-js-schema}.
	   * @param {String} [name] A name for the mutation.
	   * @param {Object[]} [variables] A list of variables in the mutation. See {@link Client#variable}.
	   * @param {Function} selectionSetCallback The mutation builder callback.
	   *   A {@link SelectionSet} is created using this callback.
	   */
	  function Mutation(typeBundle) {
	    var _ref;
	
	    classCallCheck(this, Mutation);
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return possibleConstructorReturn(this, (_ref = Mutation.__proto__ || Object.getPrototypeOf(Mutation)).call.apply(_ref, [this, typeBundle, 'mutation'].concat(args)));
	  }
	
	  return Mutation;
	}(Operation);
	
	function isAnonymous(operation) {
	  return operation.isAnonymous;
	}
	
	function hasAnonymousOperations(operations) {
	  return operations.some(isAnonymous);
	}
	
	function hasDuplicateOperationNames(operations) {
	  var names = operations.map(function (operation) {
	    return operation.name;
	  });
	
	  return names.reduce(function (hasDuplicates, name, index) {
	    return hasDuplicates || names.indexOf(name) !== index;
	  }, false);
	}
	
	function extractOperation(typeBundle, operationType) {
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  if (Operation.prototype.isPrototypeOf(args[0])) {
	    return args[0];
	  }
	
	  if (operationType === 'query') {
	    return new (Function.prototype.bind.apply(Query, [null].concat([typeBundle], args)))();
	  } else {
	    return new (Function.prototype.bind.apply(Mutation, [null].concat([typeBundle], args)))();
	  }
	}
	
	function isInvalidOperationCombination(operations) {
	  if (operations.length === 1) {
	    return false;
	  }
	
	  return hasAnonymousOperations(operations) || hasDuplicateOperationNames(operations);
	}
	
	function fragmentNameIsNotUnique(existingDefinitions, name) {
	  return existingDefinitions.some(function (definition) {
	    return definition.name === name;
	  });
	}
	
	var Document = function () {
	
	  /**
	   * This constructor should not be invoked directly.
	   * Use the factory function {@link Client#document} to create a Document.
	   * @param {Object} typeBundle A set of ES6 modules generated by {@link https://github.com/Shopify/graphql-js-schema|graphql-js-schema}.
	   */
	  function Document(typeBundle) {
	    classCallCheck(this, Document);
	
	    this.typeBundle = typeBundle;
	    this.definitions = [];
	  }
	
	  /**
	   * Returns the GraphQL query string for the Document (e.g. `query queryOne { ... } query queryTwo { ... }`).
	   *
	   * @return {String} The GraphQL query string for the Document.
	   */
	
	  createClass(Document, [{
	    key: 'toString',
	    value: function toString() {
	      return join(this.definitions);
	    }
	
	    /**
	     * Adds an operation to the Document.
	     *
	     * @private
	     * @param {String} operationType The type of the operation. Either 'query' or 'mutation'.
	     * @param {(Operation|String)} [query|queryName] Either an instance of an operation
	     *   object, or the name of an operation. Both are optional.
	     * @param {Object[]} [variables] A list of variables in the operation. See {@link Client#variable}.
	     * @param {Function} [callback] The query builder callback. If an operation
	     *   instance is passed, this callback will be ignored.
	     *   A {@link SelectionSet} is created using this callback.
	      */
	
	  }, {
	    key: 'addOperation',
	    value: function addOperation(operationType) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }
	
	      var operation = extractOperation.apply(undefined, [this.typeBundle, operationType].concat(args));
	
	      if (isInvalidOperationCombination(this.operations.concat(operation))) {
	        throw new Error('All operations must be uniquely named on a multi-operation document');
	      }
	
	      this.definitions.push(operation);
	    }
	
	    /**
	     * Adds a query to the Document.
	     *
	     * @example
	     * document.addQuery('myQuery', (root) => {
	     *   root.add('cat', (cat) => {
	     *    cat.add('name');
	     *   });
	     * });
	     *
	     * @param {(Query|String)} [query|queryName] Either an instance of a query
	     *   object, or the name of a query. Both are optional.
	     * @param {Object[]} [variables] A list of variables in the query. See {@link Client#variable}.
	     * @param {Function} [callback] The query builder callback. If a query
	     *   instance is passed, this callback will be ignored.
	     *   A {@link SelectionSet} is created using this callback.
	     */
	
	  }, {
	    key: 'addQuery',
	    value: function addQuery() {
	      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      this.addOperation.apply(this, ['query'].concat(args));
	    }
	
	    /**
	     * Adds a mutation to the Document.
	     *
	     * @example
	     * const input = client.variable('input', 'CatCreateInput!');
	     *
	     * document.addMutation('myMutation', [input], (root) => {
	     *   root.add('catCreate', {args: {input}}, (catCreate) => {
	     *     catCreate.add('cat', (cat) => {
	     *       cat.add('name');
	     *     });
	     *   });
	     * });
	     *
	     * @param {(Mutation|String)} [mutation|mutationName] Either an instance of a mutation
	     *   object, or the name of a mutation. Both are optional.
	     * @param {Object[]} [variables] A list of variables in the mutation. See {@link Client#variable}.
	     * @param {Function} [callback] The mutation builder callback. If a mutation
	     *   instance is passed, this callback will be ignored.
	     *   A {@link SelectionSet} is created using this callback.
	     */
	
	  }, {
	    key: 'addMutation',
	    value: function addMutation() {
	      for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }
	
	      this.addOperation.apply(this, ['mutation'].concat(args));
	    }
	
	    /**
	     * Defines a fragment on the Document.
	     *
	     * @param {String} name The name of the fragment.
	     * @param {String} onType The type the fragment is on.
	     * @param {Function} [builderFunction] The query builder callback.
	     *   A {@link SelectionSet} is created using this callback.
	     * @return {FragmentSpread} A {@link FragmentSpread} to be used with {@link SelectionSetBuilder#addFragment}.
	     */
	
	  }, {
	    key: 'defineFragment',
	    value: function defineFragment(name, onType, builderFunction) {
	      if (fragmentNameIsNotUnique(this.fragmentDefinitions, name)) {
	        throw new Error('All fragments must be uniquely named on a multi-fragment document');
	      }
	
	      var selectionSet = new SelectionSet(this.typeBundle, onType, builderFunction);
	      var fragment = new FragmentDefinition(name, onType, selectionSet);
	
	      this.definitions.push(fragment);
	
	      return fragment.spread;
	    }
	
	    /**
	     * All operations ({@link Query} and {@link Mutation}) on the Document.
	     */
	
	  }, {
	    key: 'operations',
	    get: function get$$1() {
	      return this.definitions.filter(function (definition) {
	        return Operation.prototype.isPrototypeOf(definition);
	      });
	    }
	
	    /**
	     * All {@link FragmentDefinition}s on the Document.
	     */
	
	  }, {
	    key: 'fragmentDefinitions',
	    get: function get$$1() {
	      return this.definitions.filter(function (definition) {
	        return FragmentDefinition.prototype.isPrototypeOf(definition);
	      });
	    }
	  }]);
	  return Document;
	}();
	
	/**
	 * The base class used when deserializing response data.
	 * Provides rich features, like functions to generate queries to refetch a node or fetch the next page.
	 *
	 * @class
	 */
	var GraphModel =
	
	/**
	 * @param {Object} attrs Attributes on the GraphModel.
	 */
	function GraphModel(attrs) {
	  var _this = this;
	
	  classCallCheck(this, GraphModel);
	
	  Object.defineProperty(this, 'attrs', { value: attrs, enumerable: false });
	
	  Object.keys(this.attrs).filter(function (key) {
	    return !(key in _this);
	  }).forEach(function (key) {
	    var descriptor = void 0;
	
	    if (attrs[key] === null) {
	      descriptor = {
	        enumerable: true,
	        get: function get$$1() {
	          return null;
	        }
	      };
	    } else {
	      descriptor = {
	        enumerable: true,
	        get: function get$$1() {
	          return this.attrs[key].valueOf();
	        }
	      };
	    }
	    Object.defineProperty(_this, key, descriptor);
	  });
	};
	
	/**
	 * A registry of classes used to deserialize the response data. Uses {@link GraphModel} by default.
	 */
	
	var ClassRegistry = function () {
	  function ClassRegistry() {
	    classCallCheck(this, ClassRegistry);
	
	    this.classStore = {};
	  }
	
	  /**
	   * Registers a class for a GraphQL type in the registry.
	   *
	   * @param {Class} constructor The constructor of the class.
	   * @param {String} type The GraphQL type of the object to deserialize into the class.
	   */
	
	  createClass(ClassRegistry, [{
	    key: 'registerClassForType',
	    value: function registerClassForType(constructor, type) {
	      this.classStore[type] = constructor;
	    }
	
	    /**
	     * Unregisters a class for a GraphQL type in the registry.
	     *
	     * @param {String} type The GraphQL type to unregister.
	     */
	
	  }, {
	    key: 'unregisterClassForType',
	    value: function unregisterClassForType(type) {
	      delete this.classStore[type];
	    }
	
	    /**
	     * Returns the class for the given GraphQL type.
	     *
	     * @param {String} type The GraphQL type to look up.
	     * @return {Class|GraphModel} The class for the given GraphQL type. Defaults to {@link GraphModel} if no class is registered for the GraphQL type.
	     */
	
	  }, {
	    key: 'classForType',
	    value: function classForType(type) {
	      return this.classStore[type] || GraphModel;
	    }
	  }]);
	  return ClassRegistry;
	}();
	
	function isValue(arg) {
	  return Object.prototype.toString.call(arg) !== '[object Null]' && Object.prototype.toString.call(arg) !== '[object Undefined]';
	}
	
	function isNodeContext(context) {
	  return context.selection.selectionSet.typeSchema.implementsNode;
	}
	
	function isConnection(context) {
	  return context.selection.selectionSet.typeSchema.name.endsWith('Connection');
	}
	
	function nearestNode(context) {
	  if (context == null) {
	    return null;
	  } else if (isNodeContext(context)) {
	    return context;
	  } else {
	    return nearestNode(context.parent);
	  }
	}
	
	function contextsFromRoot(context) {
	  if (context.parent) {
	    return contextsFromRoot(context.parent).concat(context);
	  } else {
	    return [context];
	  }
	}
	
	function contextsFromNearestNode(context) {
	  if (context.selection.selectionSet.typeSchema.implementsNode) {
	    return [context];
	  } else {
	    return contextsFromNearestNode(context.parent).concat(context);
	  }
	}
	
	function initializeDocumentAndVars(currentContext, contextChain) {
	  var lastInChain = contextChain[contextChain.length - 1];
	  var first = lastInChain.selection.args.first;
	  var variableDefinitions = Object.keys(lastInChain.selection.args).filter(function (key) {
	    return isVariable(lastInChain.selection.args[key]);
	  }).map(function (key) {
	    return lastInChain.selection.args[key];
	  });
	
	  var firstVar = variableDefinitions.find(function (definition) {
	    return definition.name === 'first';
	  });
	
	  if (!firstVar) {
	    firstVar = variable('first', 'Int', first);
	    variableDefinitions.push(firstVar);
	  }
	
	  var document = new Document(currentContext.selection.selectionSet.typeBundle);
	
	  return [document, variableDefinitions, firstVar];
	}
	
	function addNextFieldTo(currentSelection, contextChain, path, cursor) {
	  // There are always at least two. When we start, it's the root context, and the first set
	  var nextContext = contextChain.shift();
	
	  path.push(nextContext.selection.responseKey);
	
	  if (contextChain.length) {
	    currentSelection.add(nextContext.selection.name, { alias: nextContext.selection.alias, args: nextContext.selection.args }, function (newSelection) {
	      addNextFieldTo(newSelection, contextChain, path, cursor);
	    });
	  } else {
	    var edgesField = nextContext.selection.selectionSet.selections.find(function (field) {
	      return field.name === 'edges';
	    });
	    var nodeField = edgesField.selectionSet.selections.find(function (field) {
	      return field.name === 'node';
	    });
	    var first = void 0;
	
	    if (isVariable(nextContext.selection.args.first)) {
	      first = nextContext.selection.args.first;
	    } else {
	      first = variable('first', 'Int', nextContext.selection.args.first);
	    }
	
	    var options = {
	      alias: nextContext.selection.alias,
	      args: Object.assign({}, nextContext.selection.args, { after: cursor, first: first })
	    };
	
	    currentSelection.addConnection(nextContext.selection.name, options, nodeField.selectionSet);
	  }
	}
	
	function collectFragments(selections) {
	  return selections.reduce(function (fragmentDefinitions, field) {
	    if (FragmentSpread.prototype.isPrototypeOf(field)) {
	      fragmentDefinitions.push(field.toDefinition());
	    }
	
	    fragmentDefinitions.push.apply(fragmentDefinitions, toConsumableArray(collectFragments(field.selectionSet.selections)));
	
	    return fragmentDefinitions;
	  }, []);
	}
	
	function nextPageQueryAndPath(context, cursor) {
	  var nearestNodeContext = nearestNode(context);
	
	  if (nearestNodeContext) {
	    return function () {
	      var _document$definitions;
	
	      var path = [];
	      var nodeType = nearestNodeContext.selection.selectionSet.typeSchema;
	      var nodeId = nearestNodeContext.responseData.id;
	      var contextChain = contextsFromNearestNode(context);
	
	      var _initializeDocumentAn = initializeDocumentAndVars(context, contextChain),
	          _initializeDocumentAn2 = slicedToArray(_initializeDocumentAn, 2),
	          document = _initializeDocumentAn2[0],
	          variableDefinitions = _initializeDocumentAn2[1];
	
	      document.addQuery(variableDefinitions, function (root) {
	        path.push('node');
	        root.add('node', { args: { id: nodeId } }, function (node) {
	          node.addInlineFragmentOn(nodeType.name, function (fragment) {
	            addNextFieldTo(fragment, contextChain.slice(1), path, cursor);
	          });
	        });
	      });
	
	      var fragments = collectFragments(document.operations[0].selectionSet.selections);
	
	      (_document$definitions = document.definitions).unshift.apply(_document$definitions, toConsumableArray(fragments));
	
	      return [document, path];
	    };
	  } else {
	    return function () {
	      var _document$definitions2;
	
	      var path = [];
	      var contextChain = contextsFromRoot(context);
	
	      var _initializeDocumentAn3 = initializeDocumentAndVars(context, contextChain),
	          _initializeDocumentAn4 = slicedToArray(_initializeDocumentAn3, 2),
	          document = _initializeDocumentAn4[0],
	          variableDefinitions = _initializeDocumentAn4[1];
	
	      document.addQuery(variableDefinitions, function (root) {
	        addNextFieldTo(root, contextChain.slice(1), path, cursor);
	      });
	
	      var fragments = collectFragments(document.operations[0].selectionSet.selections);
	
	      (_document$definitions2 = document.definitions).unshift.apply(_document$definitions2, toConsumableArray(fragments));
	
	      return [document, path];
	    };
	  }
	}
	
	function hasNextPage$1(connection, edge) {
	  if (edge !== connection.edges[connection.edges.length - 1]) {
	    return new Scalar(true);
	  }
	
	  return connection.pageInfo.hasNextPage;
	}
	
	function hasPreviousPage(connection, edge) {
	  if (edge !== connection.edges[0]) {
	    return new Scalar(true);
	  }
	
	  return connection.pageInfo.hasPreviousPage;
	}
	
	function transformConnections(variableValues) {
	  return function (context, value) {
	    if (isConnection(context)) {
	      if (!(value.pageInfo && value.pageInfo.hasOwnProperty('hasNextPage') && value.pageInfo.hasOwnProperty('hasPreviousPage'))) {
	        throw new Error('Connections must include the selections "pageInfo { hasNextPage, hasPreviousPage }".');
	      }
	
	      return value.edges.map(function (edge) {
	        return Object.assign(edge.node, {
	          nextPageQueryAndPath: nextPageQueryAndPath(context, edge.cursor),
	          hasNextPage: hasNextPage$1(value, edge),
	          hasPreviousPage: hasPreviousPage(value, edge),
	          variableValues: variableValues
	        });
	      });
	    } else {
	      return value;
	    }
	  };
	}
	
	/* eslint-disable no-warning-comments */
	var DecodingContext = function () {
	  function DecodingContext(selection, responseData) {
	    var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	    classCallCheck(this, DecodingContext);
	
	    this.selection = selection;
	    this.responseData = responseData;
	    this.parent = parent;
	    Object.freeze(this);
	  }
	
	  createClass(DecodingContext, [{
	    key: 'contextForObjectProperty',
	    value: function contextForObjectProperty(responseKey) {
	      var nestedSelections = this.selection.selectionSet.selectionsByResponseKey[responseKey];
	      var nextSelection = nestedSelections && nestedSelections[0];
	      var nextContext = void 0;
	
	      // fragment spreads operate inside the current context, so we recurse to get the proper
	      // selection set, but retain the current response context
	      if (Spread.prototype.isPrototypeOf(nextSelection)) {
	        nextContext = new DecodingContext(nextSelection, this.responseData, this.parent);
	      } else {
	        nextContext = new DecodingContext(nextSelection, this.responseData[responseKey], this);
	      }
	
	      if (!nextSelection) {
	        throw new Error('Unexpected response key "' + responseKey + '", not found in selection set: ' + this.selection.selectionSet);
	      }
	
	      if (Field.prototype.isPrototypeOf(nextSelection)) {
	        return nextContext;
	      } else {
	        return nextContext.contextForObjectProperty(responseKey);
	      }
	    }
	  }, {
	    key: 'contextForArrayItem',
	    value: function contextForArrayItem(item) {
	      return new DecodingContext(this.selection, item, this.parent);
	    }
	  }]);
	  return DecodingContext;
	}();
	
	function decodeArrayItems(context, transformers) {
	  return context.responseData.map(function (item) {
	    return decodeContext(context.contextForArrayItem(item), transformers);
	  });
	}
	
	function decodeObjectValues(context, transformers) {
	  return Object.keys(context.responseData).reduce(function (acc, responseKey) {
	    acc[responseKey] = decodeContext(context.contextForObjectProperty(responseKey), transformers);
	
	    return acc;
	  }, {});
	}
	
	function runTransformers(transformers, context, value) {
	  return transformers.reduce(function (acc, transformer) {
	    return transformer(context, acc);
	  }, value);
	}
	
	function decodeContext(context, transformers) {
	  var value = context.responseData;
	
	  if (Array.isArray(value)) {
	    value = decodeArrayItems(context, transformers);
	  } else if (isObject(value)) {
	    value = decodeObjectValues(context, transformers);
	  }
	
	  return runTransformers(transformers, context, value);
	}
	
	function generateRefetchQueries(context, value) {
	  if (isValue(value) && isNodeContext(context)) {
	    value.refetchQuery = function () {
	      return new Query(context.selection.selectionSet.typeBundle, function (root) {
	        root.add('node', { args: { id: context.responseData.id } }, function (node) {
	          node.addInlineFragmentOn(context.selection.selectionSet.typeSchema.name, context.selection.selectionSet);
	        });
	      });
	    };
	  }
	
	  return value;
	}
	
	function transformPojosToClassesWithRegistry(classRegistry) {
	  return function transformPojosToClasses(context, value) {
	    if (isObject(value)) {
	      var Klass = classRegistry.classForType(context.selection.selectionSet.typeSchema.name);
	
	      return new Klass(value);
	    } else {
	      return value;
	    }
	  };
	}
	
	function transformScalars(context, value) {
	  if (isValue(value)) {
	    if (context.selection.selectionSet.typeSchema.kind === 'SCALAR') {
	      return new Scalar(value);
	    } else if (context.selection.selectionSet.typeSchema.kind === 'ENUM') {
	      return new Enum(value);
	    }
	  }
	
	  return value;
	}
	
	function recordTypeInformation(context, value) {
	  var _context$selection$se = context.selection.selectionSet,
	      typeBundle = _context$selection$se.typeBundle,
	      typeSchema = _context$selection$se.typeSchema;
	
	  if (isValue(value)) {
	    if (value.__typename) {
	      value.type = schemaForType(typeBundle, value.__typename, typeSchema);
	    } else {
	      value.type = typeSchema;
	    }
	  }
	
	  return value;
	}
	
	function defaultTransformers(_ref) {
	  var _ref$classRegistry = _ref.classRegistry,
	      classRegistry = _ref$classRegistry === undefined ? new ClassRegistry() : _ref$classRegistry,
	      variableValues = _ref.variableValues;
	
	  return [transformScalars, generateRefetchQueries, transformConnections(variableValues), recordTypeInformation, transformPojosToClassesWithRegistry(classRegistry)];
	}
	
	/**
	 * A function used to decode the response data.
	 *
	 * @function decode
	 * @param {SelectionSet} selection The selection set used to query the response data.
	 * @param {Object} responseData The response data returned.
	 * @param {Object} [options] Options to use when decoding including:
	 *   @param {ClassRegistry} [options.classRegistry] A class registry to use when deserializing the data into classes.
	 * @return {GraphModel} The decoded response data.
	 */
	function decode(selection, responseData) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  var transformers = options.transformers || defaultTransformers(options);
	  var context = new DecodingContext(selection, responseData);
	
	  return decodeContext(context, transformers);
	}
	
	function httpFetcher(url) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  return function fetcher(graphQLParams, headers) {
	    return fetch(url, _extends({
	      body: JSON.stringify(graphQLParams),
	      method: 'POST',
	      mode: 'cors'
	    }, options, {
	      headers: _extends({
	        'Content-Type': 'application/json',
	        Accept: 'application/json'
	      }, options.headers, headers)
	    })).then(function (response) {
	      var contentType = response.headers.get('content-type');
	
	      if (contentType.indexOf('application/json') > -1) {
	        return response.json();
	      }
	
	      return response.text().then(function (text) {
	        return { text: text };
	      });
	    });
	  };
	}
	
	function hasNextPage(paginatedModels) {
	  return paginatedModels && paginatedModels.length && paginatedModels[paginatedModels.length - 1].hasNextPage;
	}
	
	/**
	 * The Client class used to create and send GraphQL documents, fragments, queries and mutations.
	 */
	
	var Client$2 = function () {
	
	  /**
	   * @param {Object} typeBundle A set of ES6 modules generated by {@link https://github.com/Shopify/graphql-js-schema|graphql-js-schema}.
	   * @param {Object} options An options object. Must include either `url` and optional `fetcherOptions` OR a `fetcher` function.
	   *   @param {(String|Function)} options.url|fetcher Either the URL of the GraphQL API endpoint, or a custom fetcher function for further customization.
	   *   @param {Object} [options.fetcherOptions] Additional options to use with `fetch`, like headers. Do not specify this argument if `fetcher` is specified.
	   *   @param {ClassRegistry} [options.registry=new ClassRegistry()] A {@link ClassRegistry} used to decode the response data.
	   */
	  function Client(typeBundle, _ref) {
	    var url = _ref.url,
	        fetcherOptions = _ref.fetcherOptions,
	        fetcher = _ref.fetcher,
	        _ref$registry = _ref.registry,
	        registry = _ref$registry === undefined ? new ClassRegistry() : _ref$registry;
	    classCallCheck(this, Client);
	
	    this.typeBundle = typeBundle;
	    this.classRegistry = registry;
	
	    if (url && fetcher) {
	      throw new Error('Arguments not supported: supply either `url` and optional `fetcherOptions` OR use a `fetcher` function for further customization.');
	    }
	
	    if (url) {
	      this.fetcher = httpFetcher(url, fetcherOptions);
	    } else if (fetcher) {
	      if (fetcherOptions) {
	        throw new Error('Arguments not supported: when specifying your own `fetcher`, set options through it and not with `fetcherOptions`');
	      }
	
	      this.fetcher = fetcher;
	    } else {
	      throw new Error('Invalid arguments: one of `url` or `fetcher` is needed.');
	    }
	  }
	
	  /**
	   * Creates a GraphQL document.
	   *
	   * @example
	   * const document = client.document();
	   *
	   * @return {Document} A GraphQL document.
	   */
	
	  createClass(Client, [{
	    key: 'document',
	    value: function document() {
	      return new Document(this.typeBundle);
	    }
	
	    /**
	     * Creates a GraphQL query.
	     *
	     * @example
	     * const query = client.query('myQuery', (root) => {
	     *   root.add('cat', (cat) => {
	     *    cat.add('name');
	     *   });
	     * });
	     *
	     * @param {String} [name] A name for the query.
	     * @param {VariableDefinition[]} [variables] A list of variables in the query. See {@link Client#variable}.
	     * @param {Function} selectionSetCallback The query builder callback.
	     *   A {@link SelectionSet} is created using this callback.
	     * @return {Query} A GraphQL query.
	     */
	
	  }, {
	    key: 'query',
	    value: function query() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return new (Function.prototype.bind.apply(Query, [null].concat([this.typeBundle], args)))();
	    }
	
	    /**
	     * Creates a GraphQL mutation.
	     *
	     * @example
	     * const input = client.variable('input', 'CatCreateInput!');
	     *
	     * const mutation = client.mutation('myMutation', [input], (root) => {
	     *   root.add('catCreate', {args: {input}}, (catCreate) => {
	     *     catCreate.add('cat', (cat) => {
	     *       cat.add('name');
	     *     });
	     *   });
	     * });
	     *
	     * @param {String} [name] A name for the mutation.
	     * @param {VariableDefinition[]} [variables] A list of variables in the mutation. See {@link Client#variable}.
	     * @param {Function} selectionSetCallback The mutation builder callback.
	     *   A {@link SelectionSet} is created using this callback.
	     * @return {Mutation} A GraphQL mutation.
	     */
	
	  }, {
	    key: 'mutation',
	    value: function mutation() {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return new (Function.prototype.bind.apply(Mutation, [null].concat([this.typeBundle], args)))();
	    }
	
	    /**
	     * Sends a GraphQL operation (query or mutation) or a document.
	     *
	     * @example
	     * client.send(query, {id: '12345'}).then((result) => {
	     *   // Do something with the returned result
	     *   console.log(result);
	     * });
	     *
	     * @param {(Query|Mutation|Document|Function)} request The operation or document to send. If represented
	     * as a function, it must return `Query`, `Mutation`, or `Document` and recieve the client as the only param.
	     * @param {Object} [variableValues] The values for variables in the operation or document.
	     * @param {Object} [otherProperties] Other properties to send with the query. For example, a custom operation name.
	     * @param {Object} [headers] Additional headers to be applied on a request by request basis.
	     * @return {Promise.<Object>} A promise resolving to an object containing the response data.
	     */
	
	  }, {
	    key: 'send',
	    value: function send(request) {
	      var variableValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      var _this = this;
	
	      var otherProperties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	      var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	      var operationOrDocument = void 0;
	
	      if (Function.prototype.isPrototypeOf(request)) {
	        operationOrDocument = request(this);
	      } else {
	        operationOrDocument = request;
	      }
	
	      var graphQLParams = { query: operationOrDocument.toString() };
	
	      if (variableValues) {
	        graphQLParams.variables = variableValues;
	      }
	
	      Object.assign(graphQLParams, otherProperties);
	
	      var operation = void 0;
	
	      if (Operation.prototype.isPrototypeOf(operationOrDocument)) {
	        operation = operationOrDocument;
	      } else {
	        var document = operationOrDocument;
	
	        if (document.operations.length === 1) {
	          operation = document.operations[0];
	        } else if (otherProperties.operationName) {
	          operation = document.operations.find(function (documentOperation) {
	            return documentOperation.name === otherProperties.operationName;
	          });
	        } else {
	          throw new Error('\n          A document must contain exactly one operation, or an operationName\n          must be specified. Example:\n\n            client.send(document, null, {operationName: \'myFancyQuery\'});\n        ');
	        }
	      }
	
	      return this.fetcher(graphQLParams, headers).then(function (response) {
	        if (response.data) {
	          response.model = decode(operation, response.data, {
	            classRegistry: _this.classRegistry,
	            variableValues: variableValues
	          });
	        }
	
	        return response;
	      });
	    }
	
	    /**
	     * Fetches the next page of a paginated node or array of nodes.
	     *
	     * @example
	     * client.fetchNextPage(node, {first: 10}).then((result) => {
	     *   // Do something with the next page
	     *   console.log(result);
	     * });
	     *
	     * @param {(GraphModel|GraphModel[])} nodeOrNodes The node or list of nodes on which to fetch the next page.
	     * @param {Object} [options] Options object containing:
	     *   @param {Integer} [options.first] The number of nodes to query on the next page. Defaults to the page size of the previous query.
	     * @return {Promise.<GraphModel[]>} A promise resolving with the next page of {@link GraphModel}s.
	     */
	
	  }, {
	    key: 'fetchNextPage',
	    value: function fetchNextPage(nodeOrNodes, options) {
	      var node = void 0;
	
	      if (Array.isArray(nodeOrNodes)) {
	        node = nodeOrNodes[nodeOrNodes.length - 1];
	      } else {
	        node = nodeOrNodes;
	      }
	
	      var _node$nextPageQueryAn = node.nextPageQueryAndPath(),
	          _node$nextPageQueryAn2 = slicedToArray(_node$nextPageQueryAn, 2),
	          query = _node$nextPageQueryAn2[0],
	          path = _node$nextPageQueryAn2[1];
	
	      var variableValues = void 0;
	
	      if (node.variableValues || options) {
	        variableValues = Object.assign({}, node.variableValues, options);
	      }
	
	      return this.send(query, variableValues).then(function (response) {
	        response.model = path.reduce(function (object, key) {
	          return object[key];
	        }, response.model);
	
	        return response;
	      });
	    }
	
	    /**
	     * Fetches all subsequent pages of a paginated array of nodes.
	     *
	     * @example
	     * client.fetchAllPages(nodes, {pageSize: 20}).then((result) => {
	     *   // Do something with all the models
	     *   console.log(result);
	     * });
	     *
	     * @param {GraphModel[]} paginatedModels The list of nodes on which to fetch all pages.
	     * @param {Object} options Options object containing:
	     *   @param {Integer} options.pageSize The number of nodes to query on each page.
	     * @return {Promise.<GraphModel[]>} A promise resolving with all pages of {@link GraphModel}s, including the original list.
	     */
	
	  }, {
	    key: 'fetchAllPages',
	    value: function fetchAllPages(paginatedModels, _ref2) {
	      var _this2 = this;
	
	      var pageSize = _ref2.pageSize;
	
	      if (hasNextPage(paginatedModels)) {
	        return this.fetchNextPage(paginatedModels, { first: pageSize }).then(function (_ref3) {
	          var model = _ref3.model;
	
	          var pages = paginatedModels.concat(model);
	
	          return _this2.fetchAllPages(pages, { pageSize: pageSize });
	        });
	      }
	
	      return Promise.resolve(paginatedModels);
	    }
	
	    /**
	     * Refetches a {@link GraphModel} whose type implements `Node`.
	     *
	     * @example
	     * client.refetch(node).then((result) => {
	     *   // Do something with the refetched node
	     *   console.log(result);
	     * });
	     *
	     * @param {GraphModel} nodeType A {@link GraphModel} whose type implements `Node`.
	     * @return {Promise.<GraphModel>} The refetched {@link GraphModel}.
	     */
	
	  }, {
	    key: 'refetch',
	    value: function refetch(nodeType) {
	      if (!nodeType) {
	        throw new Error('\'client#refetch\' must be called with a non-null instance of a Node.');
	      } else if (!nodeType.type.implementsNode) {
	        throw new Error('\'client#refetch\' must be called with a type that implements Node. Received ' + nodeType.type.name + '.');
	      }
	
	      return this.send(nodeType.refetchQuery()).then(function (_ref4) {
	        var model = _ref4.model;
	        return model.node;
	      });
	    }
	
	    /**
	     * Creates a variable to be used in a {@link Query} or {@link Mutation}.
	     *
	     * @example
	     * const idVariable = client.variable('id', 'ID!', '12345');
	     *
	     * @param {String} name The name of the variable.
	     * @param {String} type The GraphQL type of the variable.
	     * @param {*} [defaultValue] The default value of the variable.
	     * @return {VariableDefinition} A variable object that can be used in a {@link Query} or {@link Mutation}.
	     */
	
	  }, {
	    key: 'variable',
	    value: function variable$$1(name, type, defaultValue) {
	      return variable(name, type, defaultValue);
	    }
	
	    /**
	     * Creates an enum to be used in a {@link Query} or {@link Mutation}.
	     *
	     * @example
	     * const titleEnum = client.enum('TITLE');
	     *
	     * @param {String} key The key of the enum.
	     * @return {Enum} An enum object that can be used in a {@link Query} or {@link Mutation}.
	     */
	
	  }, {
	    key: 'enum',
	    value: function _enum(key) {
	      return enumFunction(key);
	    }
	  }]);
	  return Client;
	}();
	
	/**
	 * The class used to configure the JS Buy SDK Client.
	 * @class
	 */
	var Config = function () {
	  createClass$1(Config, [{
	    key: 'requiredProperties',
	
	
	    /**
	     * Properties that must be set on initializations
	     * @attribute requiredProperties
	     * @default ['storefrontAccessToken', 'domain']
	     * @type Array
	     * @private
	     */
	    get: function get$$1() {
	      return ['storefrontAccessToken', 'domain'];
	    }
	
	    /**
	     * Deprecated properties that map directly to required properties
	     * @attribute deprecatedProperties
	     * @default {'accessToken': 'storefrontAccessToken', 'apiKey': 'storefrontAccessToken'}
	     * @type Object
	     * @private
	     */
	
	  }, {
	    key: 'deprecatedProperties',
	    get: function get$$1() {
	      return {
	        accessToken: 'storefrontAccessToken',
	        apiKey: 'storefrontAccessToken'
	      };
	    }
	
	    /**
	     * @constructs Config
	     * @param {Object} attrs An object specifying the configuration. Requires the following properties:
	     *   @param {String} attrs.storefrontAccessToken The {@link https://help.shopify.com/api/reference/storefront_access_token|Storefront access token} for the shop.
	     *   @param {String} attrs.domain The `myshopify` domain for the shop (e.g. `graphql.myshopify.com`).
	     */
	
	  }]);
	
	  function Config(attrs) {
	    var _this = this;
	
	    classCallCheck$1(this, Config);
	
	    Object.keys(this.deprecatedProperties).forEach(function (key) {
	      if (!attrs.hasOwnProperty(key)) {
	        return;
	      }
	      // eslint-disable-next-line no-console
	      console.warn('[ShopifyBuy] Config property ' + key + ' is deprecated as of v1.0, please use ' + _this.deprecatedProperties[key] + ' instead.');
	      attrs[_this.deprecatedProperties[key]] = attrs[key];
	    });
	
	    this.requiredProperties.forEach(function (key) {
	      if (attrs.hasOwnProperty(key)) {
	        _this[key] = attrs[key];
	      } else {
	        throw new Error('new Config() requires the option \'' + key + '\'');
	      }
	    });
	
	    if (attrs.hasOwnProperty('apiVersion')) {
	      this.apiVersion = attrs.apiVersion;
	    } else {
	      this.apiVersion = '2019-10';
	    }
	
	    if (attrs.hasOwnProperty('source')) {
	      this.source = attrs.source;
	    }
	  }
	
	  return Config;
	}();
	
	var Resource = function Resource(client) {
	  classCallCheck$1(this, Resource);
	
	  this.graphQLClient = client;
	};
	
	var defaultErrors = [{ message: 'an unknown error has occured.' }];
	
	function defaultResolver(path) {
	  var keys = path.split('.');
	
	  return function (_ref) {
	    var model = _ref.model,
	        errors = _ref.errors;
	
	    return new Promise(function (resolve, reject) {
	      try {
	        var result = keys.reduce(function (ref, key) {
	          return ref[key];
	        }, model);
	
	        resolve(result);
	      } catch (_) {
	        if (errors) {
	          reject(errors);
	        } else {
	          reject(defaultErrors);
	        }
	      }
	    });
	  };
	}
	
	function fetchResourcesForProducts(productOrProduct, client) {
	  var products = [].concat(productOrProduct);
	
	  return Promise.all(products.reduce(function (promiseAcc, product) {
	
	    // If the graphql query doesn't find a match, skip fetching variants and images.
	    if (product === null) {
	      return promiseAcc;
	    }
	
	    // Fetch the rest of the images and variants for this product
	    promiseAcc.push(client.fetchAllPages(product.images, { pageSize: 250 }).then(function (images) {
	      product.attrs.images = images;
	    }));
	
	    promiseAcc.push(client.fetchAllPages(product.variants, { pageSize: 250 }).then(function (variants) {
	      product.attrs.variants = variants;
	    }));
	
	    return promiseAcc;
	  }, []));
	}
	
	function paginateProductConnectionsAndResolve(client) {
	  return function (products) {
	    return fetchResourcesForProducts(products, client).then(function () {
	      return products;
	    });
	  };
	}
	
	function paginateCollectionsProductConnectionsAndResolve(client) {
	  return function (collectionOrCollections) {
	    var collections = [].concat(collectionOrCollections);
	
	    return Promise.all(collections.reduce(function (promiseAcc, collection) {
	      return promiseAcc.concat(fetchResourcesForProducts(collection.products, client));
	    }, [])).then(function () {
	      return collectionOrCollections;
	    });
	  };
	}
	
	/**
	 * @namespace ProductHelpers
	 */
	var productHelpers = {
	
	  /**
	   * Returns the variant of a product corresponding to the options given.
	   *
	   * @example
	   * const selectedVariant = client.product.helpers.variantForOptions(product, {
	   *   size: "Small",
	   *   color: "Red"
	   * });
	   *
	   * @memberof ProductHelpers
	   * @method variantForOptions
	   * @param {GraphModel} product The product to find the variant on. Must include `variants`.
	   * @param {Object} options An object containing the options for the variant.
	   * @return {GraphModel} The variant corresponding to the options given.
	   */
	  variantForOptions: function variantForOptions(product, options) {
	    return product.variants.find(function (variant) {
	      return variant.selectedOptions.every(function (selectedOption) {
	        return options[selectedOption.name] === selectedOption.value.valueOf();
	      });
	    });
	  }
	};
	
	function query(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.id = client.variable("id", "ID!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price");
	    root.add("priceV2", function (priceV2) {
	      priceV2.add("amount");
	      priceV2.add("currencyCode");
	    });
	    root.add("presentmentPrices", {
	      args: {
	        first: 20
	      }
	    }, function (presentmentPrices) {
	      presentmentPrices.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      presentmentPrices.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.add("price", function (price) {
	            price.add("amount");
	            price.add("currencyCode");
	          });
	        });
	      });
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice");
	    root.add("compareAtPriceV2", function (compareAtPriceV2) {
	      compareAtPriceV2.add("amount");
	      compareAtPriceV2.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	  });
	  spreads.ProductFragment = document.defineFragment("ProductFragment", "Product", function (root) {
	    root.add("id");
	    root.add("availableForSale");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("descriptionHtml");
	    root.add("description");
	    root.add("handle");
	    root.add("productType");
	    root.add("title");
	    root.add("vendor");
	    root.add("publishedAt");
	    root.add("onlineStoreUrl");
	    root.add("options", function (options) {
	      options.add("name");
	      options.add("values");
	    });
	    root.add("images", {
	      args: {
	        first: 250
	      }
	    }, function (images) {
	      images.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      images.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("src");
	          node.add("altText");
	        });
	      });
	    });
	    root.add("variants", {
	      args: {
	        first: 250
	      }
	    }, function (variants) {
	      variants.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      variants.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.addFragment(spreads.VariantFragment);
	        });
	      });
	    });
	  });
	  document.addQuery([variables.__defaultOperation__.id], function (root) {
	    root.add("node", {
	      args: {
	        id: variables.__defaultOperation__.id
	      }
	    }, function (node) {
	      node.addFragment(spreads.ProductFragment);
	    });
	  });
	  return document;
	}
	
	function query$1(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.ids = client.variable("ids", "[ID!]!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price");
	    root.add("priceV2", function (priceV2) {
	      priceV2.add("amount");
	      priceV2.add("currencyCode");
	    });
	    root.add("presentmentPrices", {
	      args: {
	        first: 20
	      }
	    }, function (presentmentPrices) {
	      presentmentPrices.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      presentmentPrices.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.add("price", function (price) {
	            price.add("amount");
	            price.add("currencyCode");
	          });
	        });
	      });
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice");
	    root.add("compareAtPriceV2", function (compareAtPriceV2) {
	      compareAtPriceV2.add("amount");
	      compareAtPriceV2.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	  });
	  spreads.ProductFragment = document.defineFragment("ProductFragment", "Product", function (root) {
	    root.add("id");
	    root.add("availableForSale");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("descriptionHtml");
	    root.add("description");
	    root.add("handle");
	    root.add("productType");
	    root.add("title");
	    root.add("vendor");
	    root.add("publishedAt");
	    root.add("onlineStoreUrl");
	    root.add("options", function (options) {
	      options.add("name");
	      options.add("values");
	    });
	    root.add("images", {
	      args: {
	        first: 250
	      }
	    }, function (images) {
	      images.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      images.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("src");
	          node.add("altText");
	        });
	      });
	    });
	    root.add("variants", {
	      args: {
	        first: 250
	      }
	    }, function (variants) {
	      variants.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      variants.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.addFragment(spreads.VariantFragment);
	        });
	      });
	    });
	  });
	  document.addQuery([variables.__defaultOperation__.ids], function (root) {
	    root.add("nodes", {
	      args: {
	        ids: variables.__defaultOperation__.ids
	      }
	    }, function (nodes) {
	      nodes.addFragment(spreads.ProductFragment);
	    });
	  });
	  return document;
	}
	
	function query$2(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.first = client.variable("first", "Int!");
	  variables.__defaultOperation__.query = client.variable("query", "String");
	  variables.__defaultOperation__.sortKey = client.variable("sortKey", "ProductSortKeys");
	  variables.__defaultOperation__.reverse = client.variable("reverse", "Boolean");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price");
	    root.add("priceV2", function (priceV2) {
	      priceV2.add("amount");
	      priceV2.add("currencyCode");
	    });
	    root.add("presentmentPrices", {
	      args: {
	        first: 20
	      }
	    }, function (presentmentPrices) {
	      presentmentPrices.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      presentmentPrices.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.add("price", function (price) {
	            price.add("amount");
	            price.add("currencyCode");
	          });
	        });
	      });
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice");
	    root.add("compareAtPriceV2", function (compareAtPriceV2) {
	      compareAtPriceV2.add("amount");
	      compareAtPriceV2.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	  });
	  spreads.ProductFragment = document.defineFragment("ProductFragment", "Product", function (root) {
	    root.add("id");
	    root.add("availableForSale");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("descriptionHtml");
	    root.add("description");
	    root.add("handle");
	    root.add("productType");
	    root.add("title");
	    root.add("vendor");
	    root.add("publishedAt");
	    root.add("onlineStoreUrl");
	    root.add("options", function (options) {
	      options.add("name");
	      options.add("values");
	    });
	    root.add("images", {
	      args: {
	        first: 250
	      }
	    }, function (images) {
	      images.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      images.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("src");
	          node.add("altText");
	        });
	      });
	    });
	    root.add("variants", {
	      args: {
	        first: 250
	      }
	    }, function (variants) {
	      variants.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      variants.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.addFragment(spreads.VariantFragment);
	        });
	      });
	    });
	  });
	  document.addQuery([variables.__defaultOperation__.first, variables.__defaultOperation__.query, variables.__defaultOperation__.sortKey, variables.__defaultOperation__.reverse], function (root) {
	    root.add("products", {
	      args: {
	        first: variables.__defaultOperation__.first,
	        query: variables.__defaultOperation__.query,
	        sortKey: variables.__defaultOperation__.sortKey,
	        reverse: variables.__defaultOperation__.reverse
	      }
	    }, function (products) {
	      products.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      products.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.addFragment(spreads.ProductFragment);
	        });
	      });
	    });
	  });
	  return document;
	}
	
	function query$3(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.handle = client.variable("handle", "String!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price");
	    root.add("priceV2", function (priceV2) {
	      priceV2.add("amount");
	      priceV2.add("currencyCode");
	    });
	    root.add("presentmentPrices", {
	      args: {
	        first: 20
	      }
	    }, function (presentmentPrices) {
	      presentmentPrices.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      presentmentPrices.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.add("price", function (price) {
	            price.add("amount");
	            price.add("currencyCode");
	          });
	        });
	      });
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice");
	    root.add("compareAtPriceV2", function (compareAtPriceV2) {
	      compareAtPriceV2.add("amount");
	      compareAtPriceV2.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	  });
	  spreads.ProductFragment = document.defineFragment("ProductFragment", "Product", function (root) {
	    root.add("id");
	    root.add("availableForSale");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("descriptionHtml");
	    root.add("description");
	    root.add("handle");
	    root.add("productType");
	    root.add("title");
	    root.add("vendor");
	    root.add("publishedAt");
	    root.add("onlineStoreUrl");
	    root.add("options", function (options) {
	      options.add("name");
	      options.add("values");
	    });
	    root.add("images", {
	      args: {
	        first: 250
	      }
	    }, function (images) {
	      images.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      images.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("src");
	          node.add("altText");
	        });
	      });
	    });
	    root.add("variants", {
	      args: {
	        first: 250
	      }
	    }, function (variants) {
	      variants.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      variants.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.addFragment(spreads.VariantFragment);
	        });
	      });
	    });
	  });
	  document.addQuery([variables.__defaultOperation__.handle], function (root) {
	    root.add("productByHandle", {
	      args: {
	        handle: variables.__defaultOperation__.handle
	      }
	    }, function (productByHandle) {
	      productByHandle.addFragment(spreads.ProductFragment);
	    });
	  });
	  return document;
	}
	
	// GraphQL
	/**
	 * The JS Buy SDK product resource
	 * @class
	 */
	
	var ProductResource = function (_Resource) {
	  inherits$1(ProductResource, _Resource);
	
	  function ProductResource() {
	    classCallCheck$1(this, ProductResource);
	    return possibleConstructorReturn$1(this, (ProductResource.__proto__ || Object.getPrototypeOf(ProductResource)).apply(this, arguments));
	  }
	
	  createClass$1(ProductResource, [{
	    key: 'fetchAll',
	
	
	    /**
	     * Fetches all products on the shop.
	     *
	     * @example
	     * client.product.fetchAll().then((products) => {
	     *   // Do something with the products
	     * });
	     *
	     * @param {Int} [pageSize] The number of products to fetch per page
	     * @return {Promise|GraphModel[]} A promise resolving with an array of `GraphModel`s of the products.
	     */
	    value: function fetchAll() {
	      var first = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 20;
	
	      return this.graphQLClient.send(query$2, { first: first }).then(defaultResolver('products')).then(paginateProductConnectionsAndResolve(this.graphQLClient));
	    }
	
	    /**
	     * Fetches a single product by ID on the shop.
	     *
	     * @example
	     * client.product.fetch('Xk9lM2JkNzFmNzIQ4NTIY4ZDFi9DaGVja291dC9lM2JkN==').then((product) => {
	     *   // Do something with the product
	     * });
	     *
	     * @param {String} id The id of the product to fetch.
	     * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the product.
	     */
	
	  }, {
	    key: 'fetch',
	    value: function fetch(id) {
	      return this.graphQLClient.send(query, { id: id }).then(defaultResolver('node')).then(paginateProductConnectionsAndResolve(this.graphQLClient));
	    }
	
	    /**
	     * Fetches multiple products by ID on the shop.
	     *
	     * @example
	     * const ids = ['Xk9lM2JkNzFmNzIQ4NTIY4ZDFi9DaGVja291dC9lM2JkN==', 'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0Lzc4NTc5ODkzODQ='];
	     * client.product.fetchMultiple(ids).then((products) => {
	     *   // Do something with the products
	     * });
	     *
	     * @param {String[]} ids The ids of the products to fetch
	     * @return {Promise|GraphModel[]} A promise resolving with a `GraphModel` of the product.
	     */
	
	  }, {
	    key: 'fetchMultiple',
	    value: function fetchMultiple(ids) {
	      return this.graphQLClient.send(query$1, { ids: ids }).then(defaultResolver('nodes')).then(paginateProductConnectionsAndResolve(this.graphQLClient));
	    }
	
	    /**
	     * Fetches a single product by handle on the shop.
	     *
	     * @example
	     * client.product.fetchByHandle('my-product').then((product) => {
	     *   // Do something with the product
	     * });
	     *
	     * @param {String} handle The handle of the product to fetch.
	     * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the product.
	     */
	
	  }, {
	    key: 'fetchByHandle',
	    value: function fetchByHandle(handle) {
	      return this.graphQLClient.send(query$3, { handle: handle }).then(defaultResolver('productByHandle')).then(paginateProductConnectionsAndResolve(this.graphQLClient));
	    }
	
	    /**
	     * Fetches all products on the shop that match the query.
	     *
	     * @example
	     * client.product.fetchQuery({first: 20, sortKey: 'CREATED_AT', reverse: true}).then((products) => {
	     *   // Do something with the first 10 products sorted by title in ascending order
	     * });
	     *
	     * @param {Object} [args] An object specifying the query data containing zero or more of:
	     *   @param {Int} [args.first=20] The relay `first` param. This specifies page size.
	     *   @param {String} [args.sortKey=ID] The key to sort results by. Available values are
	     *   documented as {@link https://help.shopify.com/api/storefront-api/reference/enum/productsortkeys|Product Sort Keys}.
	     *   @param {String} [args.query] A query string. See full documentation {@link https://help.shopify.com/api/storefront-api/reference/object/shop#products|here}
	     *   @param {Boolean} [args.reverse] Whether or not to reverse the sort order of the results
	     * @return {Promise|GraphModel[]} A promise resolving with an array of `GraphModel`s of the products.
	     */
	
	  }, {
	    key: 'fetchQuery',
	    value: function fetchQuery() {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref$first = _ref.first,
	          first = _ref$first === undefined ? 20 : _ref$first,
	          _ref$sortKey = _ref.sortKey,
	          sortKey = _ref$sortKey === undefined ? 'ID' : _ref$sortKey,
	          query$$1 = _ref.query,
	          reverse = _ref.reverse;
	
	      return this.graphQLClient.send(query$2, {
	        first: first,
	        sortKey: sortKey,
	        query: query$$1,
	        reverse: reverse
	      }).then(defaultResolver('products')).then(paginateProductConnectionsAndResolve(this.graphQLClient));
	    }
	  }, {
	    key: 'helpers',
	    get: function get$$1() {
	      return productHelpers;
	    }
	  }]);
	  return ProductResource;
	}(Resource);
	
	function query$4(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.id = client.variable("id", "ID!");
	  spreads.CollectionFragment = document.defineFragment("CollectionFragment", "Collection", function (root) {
	    root.add("id");
	    root.add("handle");
	    root.add("description");
	    root.add("descriptionHtml");
	    root.add("updatedAt");
	    root.add("title");
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	  });
	  document.addQuery([variables.__defaultOperation__.id], function (root) {
	    root.add("node", {
	      args: {
	        id: variables.__defaultOperation__.id
	      }
	    }, function (node) {
	      node.addFragment(spreads.CollectionFragment);
	    });
	  });
	  return document;
	}
	
	function query$5(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.id = client.variable("id", "ID!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price");
	    root.add("priceV2", function (priceV2) {
	      priceV2.add("amount");
	      priceV2.add("currencyCode");
	    });
	    root.add("presentmentPrices", {
	      args: {
	        first: 20
	      }
	    }, function (presentmentPrices) {
	      presentmentPrices.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      presentmentPrices.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.add("price", function (price) {
	            price.add("amount");
	            price.add("currencyCode");
	          });
	        });
	      });
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice");
	    root.add("compareAtPriceV2", function (compareAtPriceV2) {
	      compareAtPriceV2.add("amount");
	      compareAtPriceV2.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	  });
	  spreads.ProductFragment = document.defineFragment("ProductFragment", "Product", function (root) {
	    root.add("id");
	    root.add("availableForSale");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("descriptionHtml");
	    root.add("description");
	    root.add("handle");
	    root.add("productType");
	    root.add("title");
	    root.add("vendor");
	    root.add("publishedAt");
	    root.add("onlineStoreUrl");
	    root.add("options", function (options) {
	      options.add("name");
	      options.add("values");
	    });
	    root.add("images", {
	      args: {
	        first: 250
	      }
	    }, function (images) {
	      images.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      images.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("src");
	          node.add("altText");
	        });
	      });
	    });
	    root.add("variants", {
	      args: {
	        first: 250
	      }
	    }, function (variants) {
	      variants.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      variants.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.addFragment(spreads.VariantFragment);
	        });
	      });
	    });
	  });
	  spreads.CollectionFragment = document.defineFragment("CollectionFragment", "Collection", function (root) {
	    root.add("id");
	    root.add("handle");
	    root.add("description");
	    root.add("descriptionHtml");
	    root.add("updatedAt");
	    root.add("title");
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	  });
	  spreads.CollectionsProductsFragment = document.defineFragment("CollectionsProductsFragment", "Collection", function (root) {
	    root.add("products", {
	      args: {
	        first: 20
	      }
	    }, function (products) {
	      products.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      products.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.addFragment(spreads.ProductFragment);
	        });
	      });
	    });
	  });
	  document.addQuery([variables.__defaultOperation__.id], function (root) {
	    root.add("node", {
	      args: {
	        id: variables.__defaultOperation__.id
	      }
	    }, function (node) {
	      node.addFragment(spreads.CollectionFragment);
	      node.addFragment(spreads.CollectionsProductsFragment);
	    });
	  });
	  return document;
	}
	
	function query$6(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.first = client.variable("first", "Int!");
	  variables.__defaultOperation__.query = client.variable("query", "String");
	  variables.__defaultOperation__.sortKey = client.variable("sortKey", "CollectionSortKeys");
	  variables.__defaultOperation__.reverse = client.variable("reverse", "Boolean");
	  spreads.CollectionFragment = document.defineFragment("CollectionFragment", "Collection", function (root) {
	    root.add("id");
	    root.add("handle");
	    root.add("description");
	    root.add("descriptionHtml");
	    root.add("updatedAt");
	    root.add("title");
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	  });
	  document.addQuery([variables.__defaultOperation__.first, variables.__defaultOperation__.query, variables.__defaultOperation__.sortKey, variables.__defaultOperation__.reverse], function (root) {
	    root.add("collections", {
	      args: {
	        first: variables.__defaultOperation__.first,
	        query: variables.__defaultOperation__.query,
	        sortKey: variables.__defaultOperation__.sortKey,
	        reverse: variables.__defaultOperation__.reverse
	      }
	    }, function (collections) {
	      collections.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      collections.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.addFragment(spreads.CollectionFragment);
	        });
	      });
	    });
	  });
	  return document;
	}
	
	function query$7(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.first = client.variable("first", "Int!");
	  variables.__defaultOperation__.query = client.variable("query", "String");
	  variables.__defaultOperation__.sortKey = client.variable("sortKey", "CollectionSortKeys");
	  variables.__defaultOperation__.reverse = client.variable("reverse", "Boolean");
	  variables.__defaultOperation__.productsFirst = client.variable("productsFirst", "Int!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price");
	    root.add("priceV2", function (priceV2) {
	      priceV2.add("amount");
	      priceV2.add("currencyCode");
	    });
	    root.add("presentmentPrices", {
	      args: {
	        first: 20
	      }
	    }, function (presentmentPrices) {
	      presentmentPrices.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      presentmentPrices.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.add("price", function (price) {
	            price.add("amount");
	            price.add("currencyCode");
	          });
	        });
	      });
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice");
	    root.add("compareAtPriceV2", function (compareAtPriceV2) {
	      compareAtPriceV2.add("amount");
	      compareAtPriceV2.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	  });
	  spreads.CollectionFragment = document.defineFragment("CollectionFragment", "Collection", function (root) {
	    root.add("id");
	    root.add("handle");
	    root.add("description");
	    root.add("descriptionHtml");
	    root.add("updatedAt");
	    root.add("title");
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	  });
	  spreads.ProductFragment = document.defineFragment("ProductFragment", "Product", function (root) {
	    root.add("id");
	    root.add("availableForSale");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("descriptionHtml");
	    root.add("description");
	    root.add("handle");
	    root.add("productType");
	    root.add("title");
	    root.add("vendor");
	    root.add("publishedAt");
	    root.add("onlineStoreUrl");
	    root.add("options", function (options) {
	      options.add("name");
	      options.add("values");
	    });
	    root.add("images", {
	      args: {
	        first: 250
	      }
	    }, function (images) {
	      images.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      images.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("src");
	          node.add("altText");
	        });
	      });
	    });
	    root.add("variants", {
	      args: {
	        first: 250
	      }
	    }, function (variants) {
	      variants.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      variants.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.addFragment(spreads.VariantFragment);
	        });
	      });
	    });
	  });
	  document.addQuery([variables.__defaultOperation__.first, variables.__defaultOperation__.query, variables.__defaultOperation__.sortKey, variables.__defaultOperation__.reverse, variables.__defaultOperation__.productsFirst], function (root) {
	    root.add("collections", {
	      args: {
	        first: variables.__defaultOperation__.first,
	        query: variables.__defaultOperation__.query,
	        sortKey: variables.__defaultOperation__.sortKey,
	        reverse: variables.__defaultOperation__.reverse
	      }
	    }, function (collections) {
	      collections.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      collections.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.addFragment(spreads.CollectionFragment);
	          node.add("products", {
	            args: {
	              first: variables.__defaultOperation__.productsFirst
	            }
	          }, function (products) {
	            products.add("pageInfo", function (pageInfo) {
	              pageInfo.add("hasNextPage");
	              pageInfo.add("hasPreviousPage");
	            });
	            products.add("edges", function (edges) {
	              edges.add("cursor");
	              edges.add("node", function (node) {
	                node.addFragment(spreads.ProductFragment);
	              });
	            });
	          });
	        });
	      });
	    });
	  });
	  return document;
	}
	
	function query$8(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.handle = client.variable("handle", "String!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price");
	    root.add("priceV2", function (priceV2) {
	      priceV2.add("amount");
	      priceV2.add("currencyCode");
	    });
	    root.add("presentmentPrices", {
	      args: {
	        first: 20
	      }
	    }, function (presentmentPrices) {
	      presentmentPrices.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      presentmentPrices.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.add("price", function (price) {
	            price.add("amount");
	            price.add("currencyCode");
	          });
	        });
	      });
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice");
	    root.add("compareAtPriceV2", function (compareAtPriceV2) {
	      compareAtPriceV2.add("amount");
	      compareAtPriceV2.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	  });
	  spreads.ProductFragment = document.defineFragment("ProductFragment", "Product", function (root) {
	    root.add("id");
	    root.add("availableForSale");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("descriptionHtml");
	    root.add("description");
	    root.add("handle");
	    root.add("productType");
	    root.add("title");
	    root.add("vendor");
	    root.add("publishedAt");
	    root.add("onlineStoreUrl");
	    root.add("options", function (options) {
	      options.add("name");
	      options.add("values");
	    });
	    root.add("images", {
	      args: {
	        first: 250
	      }
	    }, function (images) {
	      images.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      images.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("src");
	          node.add("altText");
	        });
	      });
	    });
	    root.add("variants", {
	      args: {
	        first: 250
	      }
	    }, function (variants) {
	      variants.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      variants.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.addFragment(spreads.VariantFragment);
	        });
	      });
	    });
	  });
	  spreads.CollectionFragment = document.defineFragment("CollectionFragment", "Collection", function (root) {
	    root.add("id");
	    root.add("handle");
	    root.add("description");
	    root.add("descriptionHtml");
	    root.add("updatedAt");
	    root.add("title");
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	  });
	  spreads.CollectionsProductsFragment = document.defineFragment("CollectionsProductsFragment", "Collection", function (root) {
	    root.add("products", {
	      args: {
	        first: 20
	      }
	    }, function (products) {
	      products.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      products.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.addFragment(spreads.ProductFragment);
	        });
	      });
	    });
	  });
	  document.addQuery([variables.__defaultOperation__.handle], function (root) {
	    root.add("collectionByHandle", {
	      args: {
	        handle: variables.__defaultOperation__.handle
	      }
	    }, function (collectionByHandle) {
	      collectionByHandle.addFragment(spreads.CollectionFragment);
	      collectionByHandle.addFragment(spreads.CollectionsProductsFragment);
	    });
	  });
	  return document;
	}
	
	// GraphQL
	/**
	 * The JS Buy SDK collection resource
	 * @class
	 */
	
	var CollectionResource = function (_Resource) {
	  inherits$1(CollectionResource, _Resource);
	
	  function CollectionResource() {
	    classCallCheck$1(this, CollectionResource);
	    return possibleConstructorReturn$1(this, (CollectionResource.__proto__ || Object.getPrototypeOf(CollectionResource)).apply(this, arguments));
	  }
	
	  createClass$1(CollectionResource, [{
	    key: 'fetchAll',
	
	
	    /**
	     * Fetches all collections on the shop, not including products.
	     * To fetch collections with products use [fetchAllsWithProducts]{@link Client#fetchAllsWithProducts}.
	     *
	     * @example
	     * client.collection.fetchAll().then((collections) => {
	     *   // Do something with the collections
	     * });
	     *
	     * @return {Promise|GraphModel[]} A promise resolving with an array of `GraphModel`s of the collections.
	     */
	    value: function fetchAll() {
	      var first = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 20;
	
	      return this.graphQLClient.send(query$6, { first: first }).then(defaultResolver('collections'));
	    }
	
	    /**
	     * Fetches all collections on the shop, including products.
	     *
	     * @example
	     * client.collection.fetchAllWithProducts().then((collections) => {
	     *   // Do something with the collections
	     * });
	     *
	     * @return {Promise|GraphModel[]} A promise resolving with an array of `GraphModel`s of the collections.
	     */
	
	  }, {
	    key: 'fetchAllWithProducts',
	    value: function fetchAllWithProducts() {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref$first = _ref.first,
	          first = _ref$first === undefined ? 20 : _ref$first,
	          _ref$productsFirst = _ref.productsFirst,
	          productsFirst = _ref$productsFirst === undefined ? 20 : _ref$productsFirst;
	
	      return this.graphQLClient.send(query$7, { first: first, productsFirst: productsFirst }).then(defaultResolver('collections')).then(paginateCollectionsProductConnectionsAndResolve(this.graphQLClient));
	    }
	
	    /**
	     * Fetches a single collection by ID on the shop, not including products.
	     * To fetch the collection with products use [fetchWithProducts]{@link Client#fetchWithProducts}.
	     *
	     * @example
	     * client.collection.fetch('Xk9lM2JkNzFmNzIQ4NTIY4ZDFiZTUyZTUwNTE2MDNhZjg==').then((collection) => {
	     *   // Do something with the collection
	     * });
	     *
	     * @param {String} id The id of the collection to fetch.
	     * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the collection.
	     */
	
	  }, {
	    key: 'fetch',
	    value: function fetch(id) {
	      return this.graphQLClient.send(query$4, { id: id }).then(defaultResolver('node'));
	    }
	
	    /**
	     * Fetches a single collection by ID on the shop, including products.
	     *
	     * @example
	     * client.collection.fetchWithProducts('Xk9lM2JkNzFmNzIQ4NTIY4ZDFiZTUyZTUwNTE2MDNhZjg==').then((collection) => {
	     *   // Do something with the collection
	     * });
	     *
	     * @param {String} id The id of the collection to fetch.
	     * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the collection.
	     */
	
	  }, {
	    key: 'fetchWithProducts',
	    value: function fetchWithProducts(id) {
	      return this.graphQLClient.send(query$5, { id: id }).then(defaultResolver('node')).then(paginateCollectionsProductConnectionsAndResolve(this.graphQLClient));
	    }
	
	    /**
	     * Fetches a collection by handle on the shop.
	     *
	     * @example
	     * client.collection.fetchByHandle('my-collection').then((collection) => {
	     *   // Do something with the collection
	     * });
	     *
	     * @param {String} handle The handle of the collection to fetch.
	     * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the collection.
	     */
	
	  }, {
	    key: 'fetchByHandle',
	    value: function fetchByHandle(handle) {
	      return this.graphQLClient.send(query$8, { handle: handle }).then(defaultResolver('collectionByHandle'));
	    }
	
	    /**
	     * Fetches all collections on the shop that match the query.
	     *
	     * @example
	     * client.collection.fetchQuery({first: 20, sortKey: 'CREATED_AT', reverse: true}).then((collections) => {
	     *   // Do something with the first 10 collections sorted by title in ascending order
	     * });
	     *
	     * @param {Object} [args] An object specifying the query data containing zero or more of:
	     *   @param {Int} [args.first=20] The relay `first` param. This specifies page size.
	     *   @param {String} [args.sortKey=ID] The key to sort results by. Available values are
	     *   documented as {@link https://help.shopify.com/api/storefront-api/reference/enum/collectionsortkeys|Collection Sort Keys}.
	     *   @param {String} [args.query] A query string. See full documentation {@link https://help.shopify.com/api/storefront-api/reference/object/shop#collections|here}
	     *   @param {Boolean} [args.reverse] Whether or not to reverse the sort order of the results
	     * @return {Promise|GraphModel[]} A promise resolving with an array of `GraphModel`s of the collections.
	     */
	
	  }, {
	    key: 'fetchQuery',
	    value: function fetchQuery() {
	      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref2$first = _ref2.first,
	          first = _ref2$first === undefined ? 20 : _ref2$first,
	          _ref2$sortKey = _ref2.sortKey,
	          sortKey = _ref2$sortKey === undefined ? 'ID' : _ref2$sortKey,
	          query = _ref2.query,
	          reverse = _ref2.reverse;
	
	      return this.graphQLClient.send(query$6, {
	        first: first,
	        sortKey: sortKey,
	        query: query,
	        reverse: reverse
	      }).then(defaultResolver('collections'));
	    }
	  }]);
	  return CollectionResource;
	}(Resource);
	
	function query$9(client) {
	  var document = client.document();
	  document.addQuery(function (root) {
	    root.add("shop", function (shop) {
	      shop.add("currencyCode");
	      shop.add("paymentSettings", function (paymentSettings) {
	        paymentSettings.add("enabledPresentmentCurrencies");
	      });
	      shop.add("description");
	      shop.add("moneyFormat");
	      shop.add("name");
	      shop.add("primaryDomain", function (primaryDomain) {
	        primaryDomain.add("host");
	        primaryDomain.add("sslEnabled");
	        primaryDomain.add("url");
	      });
	    });
	  });
	  return document;
	}
	
	function query$10(client) {
	  var document = client.document();
	  var spreads = {};
	  spreads.PolicyFragment = document.defineFragment("PolicyFragment", "ShopPolicy", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("url");
	    root.add("body");
	  });
	  document.addQuery(function (root) {
	    root.add("shop", function (shop) {
	      shop.add("privacyPolicy", function (privacyPolicy) {
	        privacyPolicy.addFragment(spreads.PolicyFragment);
	      });
	      shop.add("termsOfService", function (termsOfService) {
	        termsOfService.addFragment(spreads.PolicyFragment);
	      });
	      shop.add("refundPolicy", function (refundPolicy) {
	        refundPolicy.addFragment(spreads.PolicyFragment);
	      });
	    });
	  });
	  return document;
	}
	
	// GraphQL
	/**
	 * The JS Buy SDK shop resource
	 * @class
	 */
	
	var ShopResource = function (_Resource) {
	  inherits$1(ShopResource, _Resource);
	
	  function ShopResource() {
	    classCallCheck$1(this, ShopResource);
	    return possibleConstructorReturn$1(this, (ShopResource.__proto__ || Object.getPrototypeOf(ShopResource)).apply(this, arguments));
	  }
	
	  createClass$1(ShopResource, [{
	    key: 'fetchInfo',
	
	
	    /**
	     * Fetches shop information (`currencyCode`, `description`, `moneyFormat`, `name`, and `primaryDomain`).
	     * See the {@link https://help.shopify.com/api/storefront-api/reference/object/shop|Storefront API reference} for more information.
	     *
	     * @example
	     * client.shop.fetchInfo().then((shop) => {
	     *   // Do something with the shop
	     * });
	     *
	     * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the shop.
	     */
	    value: function fetchInfo() {
	      return this.graphQLClient.send(query$9).then(defaultResolver('shop'));
	    }
	
	    /**
	     * Fetches shop policies (privacy policy, terms of service and refund policy).
	     *
	     * @example
	     * client.shop.fetchPolicies().then((shop) => {
	     *   // Do something with the shop
	     * });
	     *
	     * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the shop.
	     */
	
	  }, {
	    key: 'fetchPolicies',
	    value: function fetchPolicies() {
	      return this.graphQLClient.send(query$10).then(defaultResolver('shop'));
	    }
	  }]);
	  return ShopResource;
	}(Resource);
	
	function handleCheckoutMutation(mutationRootKey, client) {
	  return function (_ref) {
	    var data = _ref.data,
	        errors = _ref.errors,
	        model = _ref.model;
	
	    var rootData = data[mutationRootKey];
	    var rootModel = model[mutationRootKey];
	
	    if (rootData && rootData.checkout) {
	      return client.fetchAllPages(rootModel.checkout.lineItems, { pageSize: 250 }).then(function (lineItems) {
	        rootModel.checkout.attrs.lineItems = lineItems;
	        rootModel.checkout.errors = errors;
	        rootModel.checkout.userErrors = rootModel.userErrors;
	
	        return rootModel.checkout;
	      });
	    }
	
	    if (errors && errors.length) {
	      return Promise.reject(new Error(JSON.stringify(errors)));
	    }
	
	    if (rootData && rootData.checkoutUserErrors && rootData.checkoutUserErrors.length) {
	      return Promise.reject(new Error(JSON.stringify(rootData.checkoutUserErrors)));
	    }
	
	    if (rootData && rootData.userErrors && rootData.userErrors.length) {
	      return Promise.reject(new Error(JSON.stringify(rootData.userErrors)));
	    }
	
	    return Promise.reject(new Error("The " + mutationRootKey + " mutation failed due to an unknown error."));
	  };
	}
	
	function query$11(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.id = client.variable("id", "ID!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price");
	    root.add("priceV2", function (priceV2) {
	      priceV2.add("amount");
	      priceV2.add("currencyCode");
	    });
	    root.add("presentmentPrices", {
	      args: {
	        first: 20
	      }
	    }, function (presentmentPrices) {
	      presentmentPrices.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      presentmentPrices.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.add("price", function (price) {
	            price.add("amount");
	            price.add("currencyCode");
	          });
	        });
	      });
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice");
	    root.add("compareAtPriceV2", function (compareAtPriceV2) {
	      compareAtPriceV2.add("amount");
	      compareAtPriceV2.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	  });
	  spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
	    root.add("targetSelection");
	    root.add("allocationMethod");
	    root.add("targetType");
	    root.add("value", function (value) {
	      value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
	        MoneyV2.add("amount");
	        MoneyV2.add("currencyCode");
	      });
	      value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
	        PricingPercentageValue.add("percentage");
	      });
	    });
	    root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
	      ManualDiscountApplication.add("title");
	      ManualDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
	      DiscountCodeApplication.add("code");
	      DiscountCodeApplication.add("applicable");
	    });
	    root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
	      ScriptDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
	      AutomaticDiscountApplication.add("title");
	    });
	  });
	  spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
	    root.add("amountUsedV2", function (amountUsedV2) {
	      amountUsedV2.add("amount");
	      amountUsedV2.add("currencyCode");
	    });
	    root.add("balanceV2", function (balanceV2) {
	      balanceV2.add("amount");
	      balanceV2.add("currencyCode");
	    });
	    root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
	      presentmentAmountUsed.add("amount");
	      presentmentAmountUsed.add("currencyCode");
	    });
	    root.add("id");
	    root.add("lastCharacters");
	  });
	  spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
	    root.addFragment(spreads.VariantFragment);
	    root.add("product", function (product) {
	      product.add("id");
	      product.add("handle");
	    });
	  });
	  spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
	    root.add("id");
	    root.add("address1");
	    root.add("address2");
	    root.add("city");
	    root.add("company");
	    root.add("country");
	    root.add("firstName");
	    root.add("formatted");
	    root.add("lastName");
	    root.add("latitude");
	    root.add("longitude");
	    root.add("phone");
	    root.add("province");
	    root.add("zip");
	    root.add("name");
	    root.add("countryCodeV2", {
	      alias: "countryCode"
	    });
	    root.add("provinceCode");
	  });
	  spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
	    root.add("id");
	    root.add("ready");
	    root.add("requiresShipping");
	    root.add("note");
	    root.add("paymentDue");
	    root.add("paymentDueV2", function (paymentDueV2) {
	      paymentDueV2.add("amount");
	      paymentDueV2.add("currencyCode");
	    });
	    root.add("webUrl");
	    root.add("orderStatusUrl");
	    root.add("taxExempt");
	    root.add("taxesIncluded");
	    root.add("currencyCode");
	    root.add("totalTax");
	    root.add("totalTaxV2", function (totalTaxV2) {
	      totalTaxV2.add("amount");
	      totalTaxV2.add("currencyCode");
	    });
	    root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
	      lineItemsSubtotalPrice.add("amount");
	      lineItemsSubtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice");
	    root.add("subtotalPriceV2", function (subtotalPriceV2) {
	      subtotalPriceV2.add("amount");
	      subtotalPriceV2.add("currencyCode");
	    });
	    root.add("totalPrice");
	    root.add("totalPriceV2", function (totalPriceV2) {
	      totalPriceV2.add("amount");
	      totalPriceV2.add("currencyCode");
	    });
	    root.add("completedAt");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("email");
	    root.add("discountApplications", {
	      args: {
	        first: 10
	      }
	    }, function (discountApplications) {
	      discountApplications.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      discountApplications.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.addFragment(spreads.DiscountApplicationFragment);
	        });
	      });
	    });
	    root.add("appliedGiftCards", function (appliedGiftCards) {
	      appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
	    });
	    root.add("shippingAddress", function (shippingAddress) {
	      shippingAddress.addFragment(spreads.MailingAddressFragment);
	    });
	    root.add("shippingLine", function (shippingLine) {
	      shippingLine.add("handle");
	      shippingLine.add("price");
	      shippingLine.add("title");
	    });
	    root.add("customAttributes", function (customAttributes) {
	      customAttributes.add("key");
	      customAttributes.add("value");
	    });
	    root.add("order", function (order) {
	      order.add("id");
	      order.add("processedAt");
	      order.add("orderNumber");
	      order.add("subtotalPrice");
	      order.add("subtotalPriceV2", function (subtotalPriceV2) {
	        subtotalPriceV2.add("amount");
	        subtotalPriceV2.add("currencyCode");
	      });
	      order.add("totalShippingPrice");
	      order.add("totalShippingPriceV2", function (totalShippingPriceV2) {
	        totalShippingPriceV2.add("amount");
	        totalShippingPriceV2.add("currencyCode");
	      });
	      order.add("totalTax");
	      order.add("totalTaxV2", function (totalTaxV2) {
	        totalTaxV2.add("amount");
	        totalTaxV2.add("currencyCode");
	      });
	      order.add("totalPrice");
	      order.add("totalPriceV2", function (totalPriceV2) {
	        totalPriceV2.add("amount");
	        totalPriceV2.add("currencyCode");
	      });
	      order.add("currencyCode");
	      order.add("totalRefunded");
	      order.add("totalRefundedV2", function (totalRefundedV2) {
	        totalRefundedV2.add("amount");
	        totalRefundedV2.add("currencyCode");
	      });
	      order.add("customerUrl");
	      order.add("shippingAddress", function (shippingAddress) {
	        shippingAddress.addFragment(spreads.MailingAddressFragment);
	      });
	      order.add("lineItems", {
	        args: {
	          first: 250
	        }
	      }, function (lineItems) {
	        lineItems.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        lineItems.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.add("title");
	            node.add("variant", function (variant) {
	              variant.addFragment(spreads.VariantWithProductFragment);
	            });
	            node.add("quantity");
	            node.add("customAttributes", function (customAttributes) {
	              customAttributes.add("key");
	              customAttributes.add("value");
	            });
	          });
	        });
	      });
	    });
	    root.add("lineItems", {
	      args: {
	        first: 250
	      }
	    }, function (lineItems) {
	      lineItems.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      lineItems.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("title");
	          node.add("variant", function (variant) {
	            variant.addFragment(spreads.VariantWithProductFragment);
	          });
	          node.add("quantity");
	          node.add("customAttributes", function (customAttributes) {
	            customAttributes.add("key");
	            customAttributes.add("value");
	          });
	          node.add("discountAllocations", function (discountAllocations) {
	            discountAllocations.add("allocatedAmount", function (allocatedAmount) {
	              allocatedAmount.add("amount");
	              allocatedAmount.add("currencyCode");
	            });
	            discountAllocations.add("discountApplication", function (discountApplication) {
	              discountApplication.addFragment(spreads.DiscountApplicationFragment);
	            });
	          });
	        });
	      });
	    });
	  });
	  document.addQuery([variables.__defaultOperation__.id], function (root) {
	    root.add("node", {
	      args: {
	        id: variables.__defaultOperation__.id
	      }
	    }, function (node) {
	      node.addFragment(spreads.CheckoutFragment);
	    });
	  });
	  return document;
	}
	
	function query$12(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.input = client.variable("input", "CheckoutCreateInput!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price");
	    root.add("priceV2", function (priceV2) {
	      priceV2.add("amount");
	      priceV2.add("currencyCode");
	    });
	    root.add("presentmentPrices", {
	      args: {
	        first: 20
	      }
	    }, function (presentmentPrices) {
	      presentmentPrices.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      presentmentPrices.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.add("price", function (price) {
	            price.add("amount");
	            price.add("currencyCode");
	          });
	        });
	      });
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice");
	    root.add("compareAtPriceV2", function (compareAtPriceV2) {
	      compareAtPriceV2.add("amount");
	      compareAtPriceV2.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	  });
	  spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
	    root.add("targetSelection");
	    root.add("allocationMethod");
	    root.add("targetType");
	    root.add("value", function (value) {
	      value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
	        MoneyV2.add("amount");
	        MoneyV2.add("currencyCode");
	      });
	      value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
	        PricingPercentageValue.add("percentage");
	      });
	    });
	    root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
	      ManualDiscountApplication.add("title");
	      ManualDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
	      DiscountCodeApplication.add("code");
	      DiscountCodeApplication.add("applicable");
	    });
	    root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
	      ScriptDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
	      AutomaticDiscountApplication.add("title");
	    });
	  });
	  spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
	    root.add("amountUsedV2", function (amountUsedV2) {
	      amountUsedV2.add("amount");
	      amountUsedV2.add("currencyCode");
	    });
	    root.add("balanceV2", function (balanceV2) {
	      balanceV2.add("amount");
	      balanceV2.add("currencyCode");
	    });
	    root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
	      presentmentAmountUsed.add("amount");
	      presentmentAmountUsed.add("currencyCode");
	    });
	    root.add("id");
	    root.add("lastCharacters");
	  });
	  spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
	    root.addFragment(spreads.VariantFragment);
	    root.add("product", function (product) {
	      product.add("id");
	      product.add("handle");
	    });
	  });
	  spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
	    root.add("field");
	    root.add("message");
	  });
	  spreads.CheckoutUserErrorFragment = document.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function (root) {
	    root.add("field");
	    root.add("message");
	    root.add("code");
	  });
	  spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
	    root.add("id");
	    root.add("address1");
	    root.add("address2");
	    root.add("city");
	    root.add("company");
	    root.add("country");
	    root.add("firstName");
	    root.add("formatted");
	    root.add("lastName");
	    root.add("latitude");
	    root.add("longitude");
	    root.add("phone");
	    root.add("province");
	    root.add("zip");
	    root.add("name");
	    root.add("countryCodeV2", {
	      alias: "countryCode"
	    });
	    root.add("provinceCode");
	  });
	  spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
	    root.add("id");
	    root.add("ready");
	    root.add("requiresShipping");
	    root.add("note");
	    root.add("paymentDue");
	    root.add("paymentDueV2", function (paymentDueV2) {
	      paymentDueV2.add("amount");
	      paymentDueV2.add("currencyCode");
	    });
	    root.add("webUrl");
	    root.add("orderStatusUrl");
	    root.add("taxExempt");
	    root.add("taxesIncluded");
	    root.add("currencyCode");
	    root.add("totalTax");
	    root.add("totalTaxV2", function (totalTaxV2) {
	      totalTaxV2.add("amount");
	      totalTaxV2.add("currencyCode");
	    });
	    root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
	      lineItemsSubtotalPrice.add("amount");
	      lineItemsSubtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice");
	    root.add("subtotalPriceV2", function (subtotalPriceV2) {
	      subtotalPriceV2.add("amount");
	      subtotalPriceV2.add("currencyCode");
	    });
	    root.add("totalPrice");
	    root.add("totalPriceV2", function (totalPriceV2) {
	      totalPriceV2.add("amount");
	      totalPriceV2.add("currencyCode");
	    });
	    root.add("completedAt");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("email");
	    root.add("discountApplications", {
	      args: {
	        first: 10
	      }
	    }, function (discountApplications) {
	      discountApplications.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      discountApplications.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.addFragment(spreads.DiscountApplicationFragment);
	        });
	      });
	    });
	    root.add("appliedGiftCards", function (appliedGiftCards) {
	      appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
	    });
	    root.add("shippingAddress", function (shippingAddress) {
	      shippingAddress.addFragment(spreads.MailingAddressFragment);
	    });
	    root.add("shippingLine", function (shippingLine) {
	      shippingLine.add("handle");
	      shippingLine.add("price");
	      shippingLine.add("title");
	    });
	    root.add("customAttributes", function (customAttributes) {
	      customAttributes.add("key");
	      customAttributes.add("value");
	    });
	    root.add("order", function (order) {
	      order.add("id");
	      order.add("processedAt");
	      order.add("orderNumber");
	      order.add("subtotalPrice");
	      order.add("subtotalPriceV2", function (subtotalPriceV2) {
	        subtotalPriceV2.add("amount");
	        subtotalPriceV2.add("currencyCode");
	      });
	      order.add("totalShippingPrice");
	      order.add("totalShippingPriceV2", function (totalShippingPriceV2) {
	        totalShippingPriceV2.add("amount");
	        totalShippingPriceV2.add("currencyCode");
	      });
	      order.add("totalTax");
	      order.add("totalTaxV2", function (totalTaxV2) {
	        totalTaxV2.add("amount");
	        totalTaxV2.add("currencyCode");
	      });
	      order.add("totalPrice");
	      order.add("totalPriceV2", function (totalPriceV2) {
	        totalPriceV2.add("amount");
	        totalPriceV2.add("currencyCode");
	      });
	      order.add("currencyCode");
	      order.add("totalRefunded");
	      order.add("totalRefundedV2", function (totalRefundedV2) {
	        totalRefundedV2.add("amount");
	        totalRefundedV2.add("currencyCode");
	      });
	      order.add("customerUrl");
	      order.add("shippingAddress", function (shippingAddress) {
	        shippingAddress.addFragment(spreads.MailingAddressFragment);
	      });
	      order.add("lineItems", {
	        args: {
	          first: 250
	        }
	      }, function (lineItems) {
	        lineItems.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        lineItems.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.add("title");
	            node.add("variant", function (variant) {
	              variant.addFragment(spreads.VariantWithProductFragment);
	            });
	            node.add("quantity");
	            node.add("customAttributes", function (customAttributes) {
	              customAttributes.add("key");
	              customAttributes.add("value");
	            });
	          });
	        });
	      });
	    });
	    root.add("lineItems", {
	      args: {
	        first: 250
	      }
	    }, function (lineItems) {
	      lineItems.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      lineItems.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("title");
	          node.add("variant", function (variant) {
	            variant.addFragment(spreads.VariantWithProductFragment);
	          });
	          node.add("quantity");
	          node.add("customAttributes", function (customAttributes) {
	            customAttributes.add("key");
	            customAttributes.add("value");
	          });
	          node.add("discountAllocations", function (discountAllocations) {
	            discountAllocations.add("allocatedAmount", function (allocatedAmount) {
	              allocatedAmount.add("amount");
	              allocatedAmount.add("currencyCode");
	            });
	            discountAllocations.add("discountApplication", function (discountApplication) {
	              discountApplication.addFragment(spreads.DiscountApplicationFragment);
	            });
	          });
	        });
	      });
	    });
	  });
	  document.addMutation([variables.__defaultOperation__.input], function (root) {
	    root.add("checkoutCreate", {
	      args: {
	        input: variables.__defaultOperation__.input
	      }
	    }, function (checkoutCreate) {
	      checkoutCreate.add("userErrors", function (userErrors) {
	        userErrors.addFragment(spreads.UserErrorFragment);
	      });
	      checkoutCreate.add("checkoutUserErrors", function (checkoutUserErrors) {
	        checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
	      });
	      checkoutCreate.add("checkout", function (checkout) {
	        checkout.addFragment(spreads.CheckoutFragment);
	      });
	    });
	  });
	  return document;
	}
	
	function query$13(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.checkoutId = client.variable("checkoutId", "ID!");
	  variables.__defaultOperation__.lineItems = client.variable("lineItems", "[CheckoutLineItemInput!]!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price");
	    root.add("priceV2", function (priceV2) {
	      priceV2.add("amount");
	      priceV2.add("currencyCode");
	    });
	    root.add("presentmentPrices", {
	      args: {
	        first: 20
	      }
	    }, function (presentmentPrices) {
	      presentmentPrices.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      presentmentPrices.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.add("price", function (price) {
	            price.add("amount");
	            price.add("currencyCode");
	          });
	        });
	      });
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice");
	    root.add("compareAtPriceV2", function (compareAtPriceV2) {
	      compareAtPriceV2.add("amount");
	      compareAtPriceV2.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	  });
	  spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
	    root.add("targetSelection");
	    root.add("allocationMethod");
	    root.add("targetType");
	    root.add("value", function (value) {
	      value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
	        MoneyV2.add("amount");
	        MoneyV2.add("currencyCode");
	      });
	      value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
	        PricingPercentageValue.add("percentage");
	      });
	    });
	    root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
	      ManualDiscountApplication.add("title");
	      ManualDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
	      DiscountCodeApplication.add("code");
	      DiscountCodeApplication.add("applicable");
	    });
	    root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
	      ScriptDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
	      AutomaticDiscountApplication.add("title");
	    });
	  });
	  spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
	    root.add("amountUsedV2", function (amountUsedV2) {
	      amountUsedV2.add("amount");
	      amountUsedV2.add("currencyCode");
	    });
	    root.add("balanceV2", function (balanceV2) {
	      balanceV2.add("amount");
	      balanceV2.add("currencyCode");
	    });
	    root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
	      presentmentAmountUsed.add("amount");
	      presentmentAmountUsed.add("currencyCode");
	    });
	    root.add("id");
	    root.add("lastCharacters");
	  });
	  spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
	    root.addFragment(spreads.VariantFragment);
	    root.add("product", function (product) {
	      product.add("id");
	      product.add("handle");
	    });
	  });
	  spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
	    root.add("field");
	    root.add("message");
	  });
	  spreads.CheckoutUserErrorFragment = document.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function (root) {
	    root.add("field");
	    root.add("message");
	    root.add("code");
	  });
	  spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
	    root.add("id");
	    root.add("address1");
	    root.add("address2");
	    root.add("city");
	    root.add("company");
	    root.add("country");
	    root.add("firstName");
	    root.add("formatted");
	    root.add("lastName");
	    root.add("latitude");
	    root.add("longitude");
	    root.add("phone");
	    root.add("province");
	    root.add("zip");
	    root.add("name");
	    root.add("countryCodeV2", {
	      alias: "countryCode"
	    });
	    root.add("provinceCode");
	  });
	  spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
	    root.add("id");
	    root.add("ready");
	    root.add("requiresShipping");
	    root.add("note");
	    root.add("paymentDue");
	    root.add("paymentDueV2", function (paymentDueV2) {
	      paymentDueV2.add("amount");
	      paymentDueV2.add("currencyCode");
	    });
	    root.add("webUrl");
	    root.add("orderStatusUrl");
	    root.add("taxExempt");
	    root.add("taxesIncluded");
	    root.add("currencyCode");
	    root.add("totalTax");
	    root.add("totalTaxV2", function (totalTaxV2) {
	      totalTaxV2.add("amount");
	      totalTaxV2.add("currencyCode");
	    });
	    root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
	      lineItemsSubtotalPrice.add("amount");
	      lineItemsSubtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice");
	    root.add("subtotalPriceV2", function (subtotalPriceV2) {
	      subtotalPriceV2.add("amount");
	      subtotalPriceV2.add("currencyCode");
	    });
	    root.add("totalPrice");
	    root.add("totalPriceV2", function (totalPriceV2) {
	      totalPriceV2.add("amount");
	      totalPriceV2.add("currencyCode");
	    });
	    root.add("completedAt");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("email");
	    root.add("discountApplications", {
	      args: {
	        first: 10
	      }
	    }, function (discountApplications) {
	      discountApplications.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      discountApplications.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.addFragment(spreads.DiscountApplicationFragment);
	        });
	      });
	    });
	    root.add("appliedGiftCards", function (appliedGiftCards) {
	      appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
	    });
	    root.add("shippingAddress", function (shippingAddress) {
	      shippingAddress.addFragment(spreads.MailingAddressFragment);
	    });
	    root.add("shippingLine", function (shippingLine) {
	      shippingLine.add("handle");
	      shippingLine.add("price");
	      shippingLine.add("title");
	    });
	    root.add("customAttributes", function (customAttributes) {
	      customAttributes.add("key");
	      customAttributes.add("value");
	    });
	    root.add("order", function (order) {
	      order.add("id");
	      order.add("processedAt");
	      order.add("orderNumber");
	      order.add("subtotalPrice");
	      order.add("subtotalPriceV2", function (subtotalPriceV2) {
	        subtotalPriceV2.add("amount");
	        subtotalPriceV2.add("currencyCode");
	      });
	      order.add("totalShippingPrice");
	      order.add("totalShippingPriceV2", function (totalShippingPriceV2) {
	        totalShippingPriceV2.add("amount");
	        totalShippingPriceV2.add("currencyCode");
	      });
	      order.add("totalTax");
	      order.add("totalTaxV2", function (totalTaxV2) {
	        totalTaxV2.add("amount");
	        totalTaxV2.add("currencyCode");
	      });
	      order.add("totalPrice");
	      order.add("totalPriceV2", function (totalPriceV2) {
	        totalPriceV2.add("amount");
	        totalPriceV2.add("currencyCode");
	      });
	      order.add("currencyCode");
	      order.add("totalRefunded");
	      order.add("totalRefundedV2", function (totalRefundedV2) {
	        totalRefundedV2.add("amount");
	        totalRefundedV2.add("currencyCode");
	      });
	      order.add("customerUrl");
	      order.add("shippingAddress", function (shippingAddress) {
	        shippingAddress.addFragment(spreads.MailingAddressFragment);
	      });
	      order.add("lineItems", {
	        args: {
	          first: 250
	        }
	      }, function (lineItems) {
	        lineItems.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        lineItems.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.add("title");
	            node.add("variant", function (variant) {
	              variant.addFragment(spreads.VariantWithProductFragment);
	            });
	            node.add("quantity");
	            node.add("customAttributes", function (customAttributes) {
	              customAttributes.add("key");
	              customAttributes.add("value");
	            });
	          });
	        });
	      });
	    });
	    root.add("lineItems", {
	      args: {
	        first: 250
	      }
	    }, function (lineItems) {
	      lineItems.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      lineItems.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("title");
	          node.add("variant", function (variant) {
	            variant.addFragment(spreads.VariantWithProductFragment);
	          });
	          node.add("quantity");
	          node.add("customAttributes", function (customAttributes) {
	            customAttributes.add("key");
	            customAttributes.add("value");
	          });
	          node.add("discountAllocations", function (discountAllocations) {
	            discountAllocations.add("allocatedAmount", function (allocatedAmount) {
	              allocatedAmount.add("amount");
	              allocatedAmount.add("currencyCode");
	            });
	            discountAllocations.add("discountApplication", function (discountApplication) {
	              discountApplication.addFragment(spreads.DiscountApplicationFragment);
	            });
	          });
	        });
	      });
	    });
	  });
	  document.addMutation([variables.__defaultOperation__.checkoutId, variables.__defaultOperation__.lineItems], function (root) {
	    root.add("checkoutLineItemsAdd", {
	      args: {
	        checkoutId: variables.__defaultOperation__.checkoutId,
	        lineItems: variables.__defaultOperation__.lineItems
	      }
	    }, function (checkoutLineItemsAdd) {
	      checkoutLineItemsAdd.add("userErrors", function (userErrors) {
	        userErrors.addFragment(spreads.UserErrorFragment);
	      });
	      checkoutLineItemsAdd.add("checkoutUserErrors", function (checkoutUserErrors) {
	        checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
	      });
	      checkoutLineItemsAdd.add("checkout", function (checkout) {
	        checkout.addFragment(spreads.CheckoutFragment);
	      });
	    });
	  });
	  return document;
	}
	
	function query$14(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.checkoutId = client.variable("checkoutId", "ID!");
	  variables.__defaultOperation__.lineItemIds = client.variable("lineItemIds", "[ID!]!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price");
	    root.add("priceV2", function (priceV2) {
	      priceV2.add("amount");
	      priceV2.add("currencyCode");
	    });
	    root.add("presentmentPrices", {
	      args: {
	        first: 20
	      }
	    }, function (presentmentPrices) {
	      presentmentPrices.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      presentmentPrices.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.add("price", function (price) {
	            price.add("amount");
	            price.add("currencyCode");
	          });
	        });
	      });
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice");
	    root.add("compareAtPriceV2", function (compareAtPriceV2) {
	      compareAtPriceV2.add("amount");
	      compareAtPriceV2.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	  });
	  spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
	    root.add("targetSelection");
	    root.add("allocationMethod");
	    root.add("targetType");
	    root.add("value", function (value) {
	      value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
	        MoneyV2.add("amount");
	        MoneyV2.add("currencyCode");
	      });
	      value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
	        PricingPercentageValue.add("percentage");
	      });
	    });
	    root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
	      ManualDiscountApplication.add("title");
	      ManualDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
	      DiscountCodeApplication.add("code");
	      DiscountCodeApplication.add("applicable");
	    });
	    root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
	      ScriptDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
	      AutomaticDiscountApplication.add("title");
	    });
	  });
	  spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
	    root.add("amountUsedV2", function (amountUsedV2) {
	      amountUsedV2.add("amount");
	      amountUsedV2.add("currencyCode");
	    });
	    root.add("balanceV2", function (balanceV2) {
	      balanceV2.add("amount");
	      balanceV2.add("currencyCode");
	    });
	    root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
	      presentmentAmountUsed.add("amount");
	      presentmentAmountUsed.add("currencyCode");
	    });
	    root.add("id");
	    root.add("lastCharacters");
	  });
	  spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
	    root.addFragment(spreads.VariantFragment);
	    root.add("product", function (product) {
	      product.add("id");
	      product.add("handle");
	    });
	  });
	  spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
	    root.add("field");
	    root.add("message");
	  });
	  spreads.CheckoutUserErrorFragment = document.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function (root) {
	    root.add("field");
	    root.add("message");
	    root.add("code");
	  });
	  spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
	    root.add("id");
	    root.add("address1");
	    root.add("address2");
	    root.add("city");
	    root.add("company");
	    root.add("country");
	    root.add("firstName");
	    root.add("formatted");
	    root.add("lastName");
	    root.add("latitude");
	    root.add("longitude");
	    root.add("phone");
	    root.add("province");
	    root.add("zip");
	    root.add("name");
	    root.add("countryCodeV2", {
	      alias: "countryCode"
	    });
	    root.add("provinceCode");
	  });
	  spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
	    root.add("id");
	    root.add("ready");
	    root.add("requiresShipping");
	    root.add("note");
	    root.add("paymentDue");
	    root.add("paymentDueV2", function (paymentDueV2) {
	      paymentDueV2.add("amount");
	      paymentDueV2.add("currencyCode");
	    });
	    root.add("webUrl");
	    root.add("orderStatusUrl");
	    root.add("taxExempt");
	    root.add("taxesIncluded");
	    root.add("currencyCode");
	    root.add("totalTax");
	    root.add("totalTaxV2", function (totalTaxV2) {
	      totalTaxV2.add("amount");
	      totalTaxV2.add("currencyCode");
	    });
	    root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
	      lineItemsSubtotalPrice.add("amount");
	      lineItemsSubtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice");
	    root.add("subtotalPriceV2", function (subtotalPriceV2) {
	      subtotalPriceV2.add("amount");
	      subtotalPriceV2.add("currencyCode");
	    });
	    root.add("totalPrice");
	    root.add("totalPriceV2", function (totalPriceV2) {
	      totalPriceV2.add("amount");
	      totalPriceV2.add("currencyCode");
	    });
	    root.add("completedAt");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("email");
	    root.add("discountApplications", {
	      args: {
	        first: 10
	      }
	    }, function (discountApplications) {
	      discountApplications.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      discountApplications.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.addFragment(spreads.DiscountApplicationFragment);
	        });
	      });
	    });
	    root.add("appliedGiftCards", function (appliedGiftCards) {
	      appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
	    });
	    root.add("shippingAddress", function (shippingAddress) {
	      shippingAddress.addFragment(spreads.MailingAddressFragment);
	    });
	    root.add("shippingLine", function (shippingLine) {
	      shippingLine.add("handle");
	      shippingLine.add("price");
	      shippingLine.add("title");
	    });
	    root.add("customAttributes", function (customAttributes) {
	      customAttributes.add("key");
	      customAttributes.add("value");
	    });
	    root.add("order", function (order) {
	      order.add("id");
	      order.add("processedAt");
	      order.add("orderNumber");
	      order.add("subtotalPrice");
	      order.add("subtotalPriceV2", function (subtotalPriceV2) {
	        subtotalPriceV2.add("amount");
	        subtotalPriceV2.add("currencyCode");
	      });
	      order.add("totalShippingPrice");
	      order.add("totalShippingPriceV2", function (totalShippingPriceV2) {
	        totalShippingPriceV2.add("amount");
	        totalShippingPriceV2.add("currencyCode");
	      });
	      order.add("totalTax");
	      order.add("totalTaxV2", function (totalTaxV2) {
	        totalTaxV2.add("amount");
	        totalTaxV2.add("currencyCode");
	      });
	      order.add("totalPrice");
	      order.add("totalPriceV2", function (totalPriceV2) {
	        totalPriceV2.add("amount");
	        totalPriceV2.add("currencyCode");
	      });
	      order.add("currencyCode");
	      order.add("totalRefunded");
	      order.add("totalRefundedV2", function (totalRefundedV2) {
	        totalRefundedV2.add("amount");
	        totalRefundedV2.add("currencyCode");
	      });
	      order.add("customerUrl");
	      order.add("shippingAddress", function (shippingAddress) {
	        shippingAddress.addFragment(spreads.MailingAddressFragment);
	      });
	      order.add("lineItems", {
	        args: {
	          first: 250
	        }
	      }, function (lineItems) {
	        lineItems.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        lineItems.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.add("title");
	            node.add("variant", function (variant) {
	              variant.addFragment(spreads.VariantWithProductFragment);
	            });
	            node.add("quantity");
	            node.add("customAttributes", function (customAttributes) {
	              customAttributes.add("key");
	              customAttributes.add("value");
	            });
	          });
	        });
	      });
	    });
	    root.add("lineItems", {
	      args: {
	        first: 250
	      }
	    }, function (lineItems) {
	      lineItems.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      lineItems.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("title");
	          node.add("variant", function (variant) {
	            variant.addFragment(spreads.VariantWithProductFragment);
	          });
	          node.add("quantity");
	          node.add("customAttributes", function (customAttributes) {
	            customAttributes.add("key");
	            customAttributes.add("value");
	          });
	          node.add("discountAllocations", function (discountAllocations) {
	            discountAllocations.add("allocatedAmount", function (allocatedAmount) {
	              allocatedAmount.add("amount");
	              allocatedAmount.add("currencyCode");
	            });
	            discountAllocations.add("discountApplication", function (discountApplication) {
	              discountApplication.addFragment(spreads.DiscountApplicationFragment);
	            });
	          });
	        });
	      });
	    });
	  });
	  document.addMutation([variables.__defaultOperation__.checkoutId, variables.__defaultOperation__.lineItemIds], function (root) {
	    root.add("checkoutLineItemsRemove", {
	      args: {
	        checkoutId: variables.__defaultOperation__.checkoutId,
	        lineItemIds: variables.__defaultOperation__.lineItemIds
	      }
	    }, function (checkoutLineItemsRemove) {
	      checkoutLineItemsRemove.add("userErrors", function (userErrors) {
	        userErrors.addFragment(spreads.UserErrorFragment);
	      });
	      checkoutLineItemsRemove.add("checkoutUserErrors", function (checkoutUserErrors) {
	        checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
	      });
	      checkoutLineItemsRemove.add("checkout", function (checkout) {
	        checkout.addFragment(spreads.CheckoutFragment);
	      });
	    });
	  });
	  return document;
	}
	
	function query$15(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.checkoutId = client.variable("checkoutId", "ID!");
	  variables.__defaultOperation__.lineItems = client.variable("lineItems", "[CheckoutLineItemInput!]!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price");
	    root.add("priceV2", function (priceV2) {
	      priceV2.add("amount");
	      priceV2.add("currencyCode");
	    });
	    root.add("presentmentPrices", {
	      args: {
	        first: 20
	      }
	    }, function (presentmentPrices) {
	      presentmentPrices.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      presentmentPrices.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.add("price", function (price) {
	            price.add("amount");
	            price.add("currencyCode");
	          });
	        });
	      });
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice");
	    root.add("compareAtPriceV2", function (compareAtPriceV2) {
	      compareAtPriceV2.add("amount");
	      compareAtPriceV2.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	  });
	  spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
	    root.add("targetSelection");
	    root.add("allocationMethod");
	    root.add("targetType");
	    root.add("value", function (value) {
	      value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
	        MoneyV2.add("amount");
	        MoneyV2.add("currencyCode");
	      });
	      value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
	        PricingPercentageValue.add("percentage");
	      });
	    });
	    root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
	      ManualDiscountApplication.add("title");
	      ManualDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
	      DiscountCodeApplication.add("code");
	      DiscountCodeApplication.add("applicable");
	    });
	    root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
	      ScriptDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
	      AutomaticDiscountApplication.add("title");
	    });
	  });
	  spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
	    root.add("amountUsedV2", function (amountUsedV2) {
	      amountUsedV2.add("amount");
	      amountUsedV2.add("currencyCode");
	    });
	    root.add("balanceV2", function (balanceV2) {
	      balanceV2.add("amount");
	      balanceV2.add("currencyCode");
	    });
	    root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
	      presentmentAmountUsed.add("amount");
	      presentmentAmountUsed.add("currencyCode");
	    });
	    root.add("id");
	    root.add("lastCharacters");
	  });
	  spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
	    root.addFragment(spreads.VariantFragment);
	    root.add("product", function (product) {
	      product.add("id");
	      product.add("handle");
	    });
	  });
	  spreads.CheckoutUserErrorFragment = document.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function (root) {
	    root.add("field");
	    root.add("message");
	    root.add("code");
	  });
	  spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
	    root.add("id");
	    root.add("address1");
	    root.add("address2");
	    root.add("city");
	    root.add("company");
	    root.add("country");
	    root.add("firstName");
	    root.add("formatted");
	    root.add("lastName");
	    root.add("latitude");
	    root.add("longitude");
	    root.add("phone");
	    root.add("province");
	    root.add("zip");
	    root.add("name");
	    root.add("countryCodeV2", {
	      alias: "countryCode"
	    });
	    root.add("provinceCode");
	  });
	  spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
	    root.add("id");
	    root.add("ready");
	    root.add("requiresShipping");
	    root.add("note");
	    root.add("paymentDue");
	    root.add("paymentDueV2", function (paymentDueV2) {
	      paymentDueV2.add("amount");
	      paymentDueV2.add("currencyCode");
	    });
	    root.add("webUrl");
	    root.add("orderStatusUrl");
	    root.add("taxExempt");
	    root.add("taxesIncluded");
	    root.add("currencyCode");
	    root.add("totalTax");
	    root.add("totalTaxV2", function (totalTaxV2) {
	      totalTaxV2.add("amount");
	      totalTaxV2.add("currencyCode");
	    });
	    root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
	      lineItemsSubtotalPrice.add("amount");
	      lineItemsSubtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice");
	    root.add("subtotalPriceV2", function (subtotalPriceV2) {
	      subtotalPriceV2.add("amount");
	      subtotalPriceV2.add("currencyCode");
	    });
	    root.add("totalPrice");
	    root.add("totalPriceV2", function (totalPriceV2) {
	      totalPriceV2.add("amount");
	      totalPriceV2.add("currencyCode");
	    });
	    root.add("completedAt");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("email");
	    root.add("discountApplications", {
	      args: {
	        first: 10
	      }
	    }, function (discountApplications) {
	      discountApplications.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      discountApplications.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.addFragment(spreads.DiscountApplicationFragment);
	        });
	      });
	    });
	    root.add("appliedGiftCards", function (appliedGiftCards) {
	      appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
	    });
	    root.add("shippingAddress", function (shippingAddress) {
	      shippingAddress.addFragment(spreads.MailingAddressFragment);
	    });
	    root.add("shippingLine", function (shippingLine) {
	      shippingLine.add("handle");
	      shippingLine.add("price");
	      shippingLine.add("title");
	    });
	    root.add("customAttributes", function (customAttributes) {
	      customAttributes.add("key");
	      customAttributes.add("value");
	    });
	    root.add("order", function (order) {
	      order.add("id");
	      order.add("processedAt");
	      order.add("orderNumber");
	      order.add("subtotalPrice");
	      order.add("subtotalPriceV2", function (subtotalPriceV2) {
	        subtotalPriceV2.add("amount");
	        subtotalPriceV2.add("currencyCode");
	      });
	      order.add("totalShippingPrice");
	      order.add("totalShippingPriceV2", function (totalShippingPriceV2) {
	        totalShippingPriceV2.add("amount");
	        totalShippingPriceV2.add("currencyCode");
	      });
	      order.add("totalTax");
	      order.add("totalTaxV2", function (totalTaxV2) {
	        totalTaxV2.add("amount");
	        totalTaxV2.add("currencyCode");
	      });
	      order.add("totalPrice");
	      order.add("totalPriceV2", function (totalPriceV2) {
	        totalPriceV2.add("amount");
	        totalPriceV2.add("currencyCode");
	      });
	      order.add("currencyCode");
	      order.add("totalRefunded");
	      order.add("totalRefundedV2", function (totalRefundedV2) {
	        totalRefundedV2.add("amount");
	        totalRefundedV2.add("currencyCode");
	      });
	      order.add("customerUrl");
	      order.add("shippingAddress", function (shippingAddress) {
	        shippingAddress.addFragment(spreads.MailingAddressFragment);
	      });
	      order.add("lineItems", {
	        args: {
	          first: 250
	        }
	      }, function (lineItems) {
	        lineItems.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        lineItems.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.add("title");
	            node.add("variant", function (variant) {
	              variant.addFragment(spreads.VariantWithProductFragment);
	            });
	            node.add("quantity");
	            node.add("customAttributes", function (customAttributes) {
	              customAttributes.add("key");
	              customAttributes.add("value");
	            });
	          });
	        });
	      });
	    });
	    root.add("lineItems", {
	      args: {
	        first: 250
	      }
	    }, function (lineItems) {
	      lineItems.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      lineItems.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("title");
	          node.add("variant", function (variant) {
	            variant.addFragment(spreads.VariantWithProductFragment);
	          });
	          node.add("quantity");
	          node.add("customAttributes", function (customAttributes) {
	            customAttributes.add("key");
	            customAttributes.add("value");
	          });
	          node.add("discountAllocations", function (discountAllocations) {
	            discountAllocations.add("allocatedAmount", function (allocatedAmount) {
	              allocatedAmount.add("amount");
	              allocatedAmount.add("currencyCode");
	            });
	            discountAllocations.add("discountApplication", function (discountApplication) {
	              discountApplication.addFragment(spreads.DiscountApplicationFragment);
	            });
	          });
	        });
	      });
	    });
	  });
	  document.addMutation([variables.__defaultOperation__.checkoutId, variables.__defaultOperation__.lineItems], function (root) {
	    root.add("checkoutLineItemsReplace", {
	      args: {
	        checkoutId: variables.__defaultOperation__.checkoutId,
	        lineItems: variables.__defaultOperation__.lineItems
	      }
	    }, function (checkoutLineItemsReplace) {
	      checkoutLineItemsReplace.add("userErrors", function (userErrors) {
	        userErrors.addFragment(spreads.CheckoutUserErrorFragment);
	      });
	      checkoutLineItemsReplace.add("checkout", function (checkout) {
	        checkout.addFragment(spreads.CheckoutFragment);
	      });
	    });
	  });
	  return document;
	}
	
	function query$16(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.checkoutId = client.variable("checkoutId", "ID!");
	  variables.__defaultOperation__.lineItems = client.variable("lineItems", "[CheckoutLineItemUpdateInput!]!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price");
	    root.add("priceV2", function (priceV2) {
	      priceV2.add("amount");
	      priceV2.add("currencyCode");
	    });
	    root.add("presentmentPrices", {
	      args: {
	        first: 20
	      }
	    }, function (presentmentPrices) {
	      presentmentPrices.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      presentmentPrices.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.add("price", function (price) {
	            price.add("amount");
	            price.add("currencyCode");
	          });
	        });
	      });
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice");
	    root.add("compareAtPriceV2", function (compareAtPriceV2) {
	      compareAtPriceV2.add("amount");
	      compareAtPriceV2.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	  });
	  spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
	    root.add("targetSelection");
	    root.add("allocationMethod");
	    root.add("targetType");
	    root.add("value", function (value) {
	      value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
	        MoneyV2.add("amount");
	        MoneyV2.add("currencyCode");
	      });
	      value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
	        PricingPercentageValue.add("percentage");
	      });
	    });
	    root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
	      ManualDiscountApplication.add("title");
	      ManualDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
	      DiscountCodeApplication.add("code");
	      DiscountCodeApplication.add("applicable");
	    });
	    root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
	      ScriptDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
	      AutomaticDiscountApplication.add("title");
	    });
	  });
	  spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
	    root.add("amountUsedV2", function (amountUsedV2) {
	      amountUsedV2.add("amount");
	      amountUsedV2.add("currencyCode");
	    });
	    root.add("balanceV2", function (balanceV2) {
	      balanceV2.add("amount");
	      balanceV2.add("currencyCode");
	    });
	    root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
	      presentmentAmountUsed.add("amount");
	      presentmentAmountUsed.add("currencyCode");
	    });
	    root.add("id");
	    root.add("lastCharacters");
	  });
	  spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
	    root.addFragment(spreads.VariantFragment);
	    root.add("product", function (product) {
	      product.add("id");
	      product.add("handle");
	    });
	  });
	  spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
	    root.add("field");
	    root.add("message");
	  });
	  spreads.CheckoutUserErrorFragment = document.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function (root) {
	    root.add("field");
	    root.add("message");
	    root.add("code");
	  });
	  spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
	    root.add("id");
	    root.add("address1");
	    root.add("address2");
	    root.add("city");
	    root.add("company");
	    root.add("country");
	    root.add("firstName");
	    root.add("formatted");
	    root.add("lastName");
	    root.add("latitude");
	    root.add("longitude");
	    root.add("phone");
	    root.add("province");
	    root.add("zip");
	    root.add("name");
	    root.add("countryCodeV2", {
	      alias: "countryCode"
	    });
	    root.add("provinceCode");
	  });
	  spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
	    root.add("id");
	    root.add("ready");
	    root.add("requiresShipping");
	    root.add("note");
	    root.add("paymentDue");
	    root.add("paymentDueV2", function (paymentDueV2) {
	      paymentDueV2.add("amount");
	      paymentDueV2.add("currencyCode");
	    });
	    root.add("webUrl");
	    root.add("orderStatusUrl");
	    root.add("taxExempt");
	    root.add("taxesIncluded");
	    root.add("currencyCode");
	    root.add("totalTax");
	    root.add("totalTaxV2", function (totalTaxV2) {
	      totalTaxV2.add("amount");
	      totalTaxV2.add("currencyCode");
	    });
	    root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
	      lineItemsSubtotalPrice.add("amount");
	      lineItemsSubtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice");
	    root.add("subtotalPriceV2", function (subtotalPriceV2) {
	      subtotalPriceV2.add("amount");
	      subtotalPriceV2.add("currencyCode");
	    });
	    root.add("totalPrice");
	    root.add("totalPriceV2", function (totalPriceV2) {
	      totalPriceV2.add("amount");
	      totalPriceV2.add("currencyCode");
	    });
	    root.add("completedAt");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("email");
	    root.add("discountApplications", {
	      args: {
	        first: 10
	      }
	    }, function (discountApplications) {
	      discountApplications.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      discountApplications.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.addFragment(spreads.DiscountApplicationFragment);
	        });
	      });
	    });
	    root.add("appliedGiftCards", function (appliedGiftCards) {
	      appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
	    });
	    root.add("shippingAddress", function (shippingAddress) {
	      shippingAddress.addFragment(spreads.MailingAddressFragment);
	    });
	    root.add("shippingLine", function (shippingLine) {
	      shippingLine.add("handle");
	      shippingLine.add("price");
	      shippingLine.add("title");
	    });
	    root.add("customAttributes", function (customAttributes) {
	      customAttributes.add("key");
	      customAttributes.add("value");
	    });
	    root.add("order", function (order) {
	      order.add("id");
	      order.add("processedAt");
	      order.add("orderNumber");
	      order.add("subtotalPrice");
	      order.add("subtotalPriceV2", function (subtotalPriceV2) {
	        subtotalPriceV2.add("amount");
	        subtotalPriceV2.add("currencyCode");
	      });
	      order.add("totalShippingPrice");
	      order.add("totalShippingPriceV2", function (totalShippingPriceV2) {
	        totalShippingPriceV2.add("amount");
	        totalShippingPriceV2.add("currencyCode");
	      });
	      order.add("totalTax");
	      order.add("totalTaxV2", function (totalTaxV2) {
	        totalTaxV2.add("amount");
	        totalTaxV2.add("currencyCode");
	      });
	      order.add("totalPrice");
	      order.add("totalPriceV2", function (totalPriceV2) {
	        totalPriceV2.add("amount");
	        totalPriceV2.add("currencyCode");
	      });
	      order.add("currencyCode");
	      order.add("totalRefunded");
	      order.add("totalRefundedV2", function (totalRefundedV2) {
	        totalRefundedV2.add("amount");
	        totalRefundedV2.add("currencyCode");
	      });
	      order.add("customerUrl");
	      order.add("shippingAddress", function (shippingAddress) {
	        shippingAddress.addFragment(spreads.MailingAddressFragment);
	      });
	      order.add("lineItems", {
	        args: {
	          first: 250
	        }
	      }, function (lineItems) {
	        lineItems.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        lineItems.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.add("title");
	            node.add("variant", function (variant) {
	              variant.addFragment(spreads.VariantWithProductFragment);
	            });
	            node.add("quantity");
	            node.add("customAttributes", function (customAttributes) {
	              customAttributes.add("key");
	              customAttributes.add("value");
	            });
	          });
	        });
	      });
	    });
	    root.add("lineItems", {
	      args: {
	        first: 250
	      }
	    }, function (lineItems) {
	      lineItems.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      lineItems.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("title");
	          node.add("variant", function (variant) {
	            variant.addFragment(spreads.VariantWithProductFragment);
	          });
	          node.add("quantity");
	          node.add("customAttributes", function (customAttributes) {
	            customAttributes.add("key");
	            customAttributes.add("value");
	          });
	          node.add("discountAllocations", function (discountAllocations) {
	            discountAllocations.add("allocatedAmount", function (allocatedAmount) {
	              allocatedAmount.add("amount");
	              allocatedAmount.add("currencyCode");
	            });
	            discountAllocations.add("discountApplication", function (discountApplication) {
	              discountApplication.addFragment(spreads.DiscountApplicationFragment);
	            });
	          });
	        });
	      });
	    });
	  });
	  document.addMutation([variables.__defaultOperation__.checkoutId, variables.__defaultOperation__.lineItems], function (root) {
	    root.add("checkoutLineItemsUpdate", {
	      args: {
	        checkoutId: variables.__defaultOperation__.checkoutId,
	        lineItems: variables.__defaultOperation__.lineItems
	      }
	    }, function (checkoutLineItemsUpdate) {
	      checkoutLineItemsUpdate.add("userErrors", function (userErrors) {
	        userErrors.addFragment(spreads.UserErrorFragment);
	      });
	      checkoutLineItemsUpdate.add("checkoutUserErrors", function (checkoutUserErrors) {
	        checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
	      });
	      checkoutLineItemsUpdate.add("checkout", function (checkout) {
	        checkout.addFragment(spreads.CheckoutFragment);
	      });
	    });
	  });
	  return document;
	}
	
	function query$17(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.checkoutAttributesUpdateV2 = {};
	  variables.checkoutAttributesUpdateV2.checkoutId = client.variable("checkoutId", "ID!");
	  variables.checkoutAttributesUpdateV2.input = client.variable("input", "CheckoutAttributesUpdateV2Input!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price");
	    root.add("priceV2", function (priceV2) {
	      priceV2.add("amount");
	      priceV2.add("currencyCode");
	    });
	    root.add("presentmentPrices", {
	      args: {
	        first: 20
	      }
	    }, function (presentmentPrices) {
	      presentmentPrices.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      presentmentPrices.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.add("price", function (price) {
	            price.add("amount");
	            price.add("currencyCode");
	          });
	        });
	      });
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice");
	    root.add("compareAtPriceV2", function (compareAtPriceV2) {
	      compareAtPriceV2.add("amount");
	      compareAtPriceV2.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	  });
	  spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
	    root.add("targetSelection");
	    root.add("allocationMethod");
	    root.add("targetType");
	    root.add("value", function (value) {
	      value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
	        MoneyV2.add("amount");
	        MoneyV2.add("currencyCode");
	      });
	      value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
	        PricingPercentageValue.add("percentage");
	      });
	    });
	    root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
	      ManualDiscountApplication.add("title");
	      ManualDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
	      DiscountCodeApplication.add("code");
	      DiscountCodeApplication.add("applicable");
	    });
	    root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
	      ScriptDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
	      AutomaticDiscountApplication.add("title");
	    });
	  });
	  spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
	    root.add("amountUsedV2", function (amountUsedV2) {
	      amountUsedV2.add("amount");
	      amountUsedV2.add("currencyCode");
	    });
	    root.add("balanceV2", function (balanceV2) {
	      balanceV2.add("amount");
	      balanceV2.add("currencyCode");
	    });
	    root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
	      presentmentAmountUsed.add("amount");
	      presentmentAmountUsed.add("currencyCode");
	    });
	    root.add("id");
	    root.add("lastCharacters");
	  });
	  spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
	    root.addFragment(spreads.VariantFragment);
	    root.add("product", function (product) {
	      product.add("id");
	      product.add("handle");
	    });
	  });
	  spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
	    root.add("field");
	    root.add("message");
	  });
	  spreads.CheckoutUserErrorFragment = document.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function (root) {
	    root.add("field");
	    root.add("message");
	    root.add("code");
	  });
	  spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
	    root.add("id");
	    root.add("address1");
	    root.add("address2");
	    root.add("city");
	    root.add("company");
	    root.add("country");
	    root.add("firstName");
	    root.add("formatted");
	    root.add("lastName");
	    root.add("latitude");
	    root.add("longitude");
	    root.add("phone");
	    root.add("province");
	    root.add("zip");
	    root.add("name");
	    root.add("countryCodeV2", {
	      alias: "countryCode"
	    });
	    root.add("provinceCode");
	  });
	  spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
	    root.add("id");
	    root.add("ready");
	    root.add("requiresShipping");
	    root.add("note");
	    root.add("paymentDue");
	    root.add("paymentDueV2", function (paymentDueV2) {
	      paymentDueV2.add("amount");
	      paymentDueV2.add("currencyCode");
	    });
	    root.add("webUrl");
	    root.add("orderStatusUrl");
	    root.add("taxExempt");
	    root.add("taxesIncluded");
	    root.add("currencyCode");
	    root.add("totalTax");
	    root.add("totalTaxV2", function (totalTaxV2) {
	      totalTaxV2.add("amount");
	      totalTaxV2.add("currencyCode");
	    });
	    root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
	      lineItemsSubtotalPrice.add("amount");
	      lineItemsSubtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice");
	    root.add("subtotalPriceV2", function (subtotalPriceV2) {
	      subtotalPriceV2.add("amount");
	      subtotalPriceV2.add("currencyCode");
	    });
	    root.add("totalPrice");
	    root.add("totalPriceV2", function (totalPriceV2) {
	      totalPriceV2.add("amount");
	      totalPriceV2.add("currencyCode");
	    });
	    root.add("completedAt");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("email");
	    root.add("discountApplications", {
	      args: {
	        first: 10
	      }
	    }, function (discountApplications) {
	      discountApplications.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      discountApplications.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.addFragment(spreads.DiscountApplicationFragment);
	        });
	      });
	    });
	    root.add("appliedGiftCards", function (appliedGiftCards) {
	      appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
	    });
	    root.add("shippingAddress", function (shippingAddress) {
	      shippingAddress.addFragment(spreads.MailingAddressFragment);
	    });
	    root.add("shippingLine", function (shippingLine) {
	      shippingLine.add("handle");
	      shippingLine.add("price");
	      shippingLine.add("title");
	    });
	    root.add("customAttributes", function (customAttributes) {
	      customAttributes.add("key");
	      customAttributes.add("value");
	    });
	    root.add("order", function (order) {
	      order.add("id");
	      order.add("processedAt");
	      order.add("orderNumber");
	      order.add("subtotalPrice");
	      order.add("subtotalPriceV2", function (subtotalPriceV2) {
	        subtotalPriceV2.add("amount");
	        subtotalPriceV2.add("currencyCode");
	      });
	      order.add("totalShippingPrice");
	      order.add("totalShippingPriceV2", function (totalShippingPriceV2) {
	        totalShippingPriceV2.add("amount");
	        totalShippingPriceV2.add("currencyCode");
	      });
	      order.add("totalTax");
	      order.add("totalTaxV2", function (totalTaxV2) {
	        totalTaxV2.add("amount");
	        totalTaxV2.add("currencyCode");
	      });
	      order.add("totalPrice");
	      order.add("totalPriceV2", function (totalPriceV2) {
	        totalPriceV2.add("amount");
	        totalPriceV2.add("currencyCode");
	      });
	      order.add("currencyCode");
	      order.add("totalRefunded");
	      order.add("totalRefundedV2", function (totalRefundedV2) {
	        totalRefundedV2.add("amount");
	        totalRefundedV2.add("currencyCode");
	      });
	      order.add("customerUrl");
	      order.add("shippingAddress", function (shippingAddress) {
	        shippingAddress.addFragment(spreads.MailingAddressFragment);
	      });
	      order.add("lineItems", {
	        args: {
	          first: 250
	        }
	      }, function (lineItems) {
	        lineItems.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        lineItems.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.add("title");
	            node.add("variant", function (variant) {
	              variant.addFragment(spreads.VariantWithProductFragment);
	            });
	            node.add("quantity");
	            node.add("customAttributes", function (customAttributes) {
	              customAttributes.add("key");
	              customAttributes.add("value");
	            });
	          });
	        });
	      });
	    });
	    root.add("lineItems", {
	      args: {
	        first: 250
	      }
	    }, function (lineItems) {
	      lineItems.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      lineItems.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("title");
	          node.add("variant", function (variant) {
	            variant.addFragment(spreads.VariantWithProductFragment);
	          });
	          node.add("quantity");
	          node.add("customAttributes", function (customAttributes) {
	            customAttributes.add("key");
	            customAttributes.add("value");
	          });
	          node.add("discountAllocations", function (discountAllocations) {
	            discountAllocations.add("allocatedAmount", function (allocatedAmount) {
	              allocatedAmount.add("amount");
	              allocatedAmount.add("currencyCode");
	            });
	            discountAllocations.add("discountApplication", function (discountApplication) {
	              discountApplication.addFragment(spreads.DiscountApplicationFragment);
	            });
	          });
	        });
	      });
	    });
	  });
	  document.addMutation("checkoutAttributesUpdateV2", [variables.checkoutAttributesUpdateV2.checkoutId, variables.checkoutAttributesUpdateV2.input], function (root) {
	    root.add("checkoutAttributesUpdateV2", {
	      args: {
	        checkoutId: variables.checkoutAttributesUpdateV2.checkoutId,
	        input: variables.checkoutAttributesUpdateV2.input
	      }
	    }, function (checkoutAttributesUpdateV2) {
	      checkoutAttributesUpdateV2.add("userErrors", function (userErrors) {
	        userErrors.addFragment(spreads.UserErrorFragment);
	      });
	      checkoutAttributesUpdateV2.add("checkoutUserErrors", function (checkoutUserErrors) {
	        checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
	      });
	      checkoutAttributesUpdateV2.add("checkout", function (checkout) {
	        checkout.addFragment(spreads.CheckoutFragment);
	      });
	    });
	  });
	  return document;
	}
	
	function query$18(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.checkoutDiscountCodeApplyV2 = {};
	  variables.checkoutDiscountCodeApplyV2.discountCode = client.variable("discountCode", "String!");
	  variables.checkoutDiscountCodeApplyV2.checkoutId = client.variable("checkoutId", "ID!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price");
	    root.add("priceV2", function (priceV2) {
	      priceV2.add("amount");
	      priceV2.add("currencyCode");
	    });
	    root.add("presentmentPrices", {
	      args: {
	        first: 20
	      }
	    }, function (presentmentPrices) {
	      presentmentPrices.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      presentmentPrices.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.add("price", function (price) {
	            price.add("amount");
	            price.add("currencyCode");
	          });
	        });
	      });
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice");
	    root.add("compareAtPriceV2", function (compareAtPriceV2) {
	      compareAtPriceV2.add("amount");
	      compareAtPriceV2.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	  });
	  spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
	    root.add("targetSelection");
	    root.add("allocationMethod");
	    root.add("targetType");
	    root.add("value", function (value) {
	      value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
	        MoneyV2.add("amount");
	        MoneyV2.add("currencyCode");
	      });
	      value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
	        PricingPercentageValue.add("percentage");
	      });
	    });
	    root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
	      ManualDiscountApplication.add("title");
	      ManualDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
	      DiscountCodeApplication.add("code");
	      DiscountCodeApplication.add("applicable");
	    });
	    root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
	      ScriptDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
	      AutomaticDiscountApplication.add("title");
	    });
	  });
	  spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
	    root.add("amountUsedV2", function (amountUsedV2) {
	      amountUsedV2.add("amount");
	      amountUsedV2.add("currencyCode");
	    });
	    root.add("balanceV2", function (balanceV2) {
	      balanceV2.add("amount");
	      balanceV2.add("currencyCode");
	    });
	    root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
	      presentmentAmountUsed.add("amount");
	      presentmentAmountUsed.add("currencyCode");
	    });
	    root.add("id");
	    root.add("lastCharacters");
	  });
	  spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
	    root.addFragment(spreads.VariantFragment);
	    root.add("product", function (product) {
	      product.add("id");
	      product.add("handle");
	    });
	  });
	  spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
	    root.add("field");
	    root.add("message");
	  });
	  spreads.CheckoutUserErrorFragment = document.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function (root) {
	    root.add("field");
	    root.add("message");
	    root.add("code");
	  });
	  spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
	    root.add("id");
	    root.add("address1");
	    root.add("address2");
	    root.add("city");
	    root.add("company");
	    root.add("country");
	    root.add("firstName");
	    root.add("formatted");
	    root.add("lastName");
	    root.add("latitude");
	    root.add("longitude");
	    root.add("phone");
	    root.add("province");
	    root.add("zip");
	    root.add("name");
	    root.add("countryCodeV2", {
	      alias: "countryCode"
	    });
	    root.add("provinceCode");
	  });
	  spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
	    root.add("id");
	    root.add("ready");
	    root.add("requiresShipping");
	    root.add("note");
	    root.add("paymentDue");
	    root.add("paymentDueV2", function (paymentDueV2) {
	      paymentDueV2.add("amount");
	      paymentDueV2.add("currencyCode");
	    });
	    root.add("webUrl");
	    root.add("orderStatusUrl");
	    root.add("taxExempt");
	    root.add("taxesIncluded");
	    root.add("currencyCode");
	    root.add("totalTax");
	    root.add("totalTaxV2", function (totalTaxV2) {
	      totalTaxV2.add("amount");
	      totalTaxV2.add("currencyCode");
	    });
	    root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
	      lineItemsSubtotalPrice.add("amount");
	      lineItemsSubtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice");
	    root.add("subtotalPriceV2", function (subtotalPriceV2) {
	      subtotalPriceV2.add("amount");
	      subtotalPriceV2.add("currencyCode");
	    });
	    root.add("totalPrice");
	    root.add("totalPriceV2", function (totalPriceV2) {
	      totalPriceV2.add("amount");
	      totalPriceV2.add("currencyCode");
	    });
	    root.add("completedAt");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("email");
	    root.add("discountApplications", {
	      args: {
	        first: 10
	      }
	    }, function (discountApplications) {
	      discountApplications.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      discountApplications.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.addFragment(spreads.DiscountApplicationFragment);
	        });
	      });
	    });
	    root.add("appliedGiftCards", function (appliedGiftCards) {
	      appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
	    });
	    root.add("shippingAddress", function (shippingAddress) {
	      shippingAddress.addFragment(spreads.MailingAddressFragment);
	    });
	    root.add("shippingLine", function (shippingLine) {
	      shippingLine.add("handle");
	      shippingLine.add("price");
	      shippingLine.add("title");
	    });
	    root.add("customAttributes", function (customAttributes) {
	      customAttributes.add("key");
	      customAttributes.add("value");
	    });
	    root.add("order", function (order) {
	      order.add("id");
	      order.add("processedAt");
	      order.add("orderNumber");
	      order.add("subtotalPrice");
	      order.add("subtotalPriceV2", function (subtotalPriceV2) {
	        subtotalPriceV2.add("amount");
	        subtotalPriceV2.add("currencyCode");
	      });
	      order.add("totalShippingPrice");
	      order.add("totalShippingPriceV2", function (totalShippingPriceV2) {
	        totalShippingPriceV2.add("amount");
	        totalShippingPriceV2.add("currencyCode");
	      });
	      order.add("totalTax");
	      order.add("totalTaxV2", function (totalTaxV2) {
	        totalTaxV2.add("amount");
	        totalTaxV2.add("currencyCode");
	      });
	      order.add("totalPrice");
	      order.add("totalPriceV2", function (totalPriceV2) {
	        totalPriceV2.add("amount");
	        totalPriceV2.add("currencyCode");
	      });
	      order.add("currencyCode");
	      order.add("totalRefunded");
	      order.add("totalRefundedV2", function (totalRefundedV2) {
	        totalRefundedV2.add("amount");
	        totalRefundedV2.add("currencyCode");
	      });
	      order.add("customerUrl");
	      order.add("shippingAddress", function (shippingAddress) {
	        shippingAddress.addFragment(spreads.MailingAddressFragment);
	      });
	      order.add("lineItems", {
	        args: {
	          first: 250
	        }
	      }, function (lineItems) {
	        lineItems.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        lineItems.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.add("title");
	            node.add("variant", function (variant) {
	              variant.addFragment(spreads.VariantWithProductFragment);
	            });
	            node.add("quantity");
	            node.add("customAttributes", function (customAttributes) {
	              customAttributes.add("key");
	              customAttributes.add("value");
	            });
	          });
	        });
	      });
	    });
	    root.add("lineItems", {
	      args: {
	        first: 250
	      }
	    }, function (lineItems) {
	      lineItems.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      lineItems.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("title");
	          node.add("variant", function (variant) {
	            variant.addFragment(spreads.VariantWithProductFragment);
	          });
	          node.add("quantity");
	          node.add("customAttributes", function (customAttributes) {
	            customAttributes.add("key");
	            customAttributes.add("value");
	          });
	          node.add("discountAllocations", function (discountAllocations) {
	            discountAllocations.add("allocatedAmount", function (allocatedAmount) {
	              allocatedAmount.add("amount");
	              allocatedAmount.add("currencyCode");
	            });
	            discountAllocations.add("discountApplication", function (discountApplication) {
	              discountApplication.addFragment(spreads.DiscountApplicationFragment);
	            });
	          });
	        });
	      });
	    });
	  });
	  document.addMutation("checkoutDiscountCodeApplyV2", [variables.checkoutDiscountCodeApplyV2.discountCode, variables.checkoutDiscountCodeApplyV2.checkoutId], function (root) {
	    root.add("checkoutDiscountCodeApplyV2", {
	      args: {
	        discountCode: variables.checkoutDiscountCodeApplyV2.discountCode,
	        checkoutId: variables.checkoutDiscountCodeApplyV2.checkoutId
	      }
	    }, function (checkoutDiscountCodeApplyV2) {
	      checkoutDiscountCodeApplyV2.add("userErrors", function (userErrors) {
	        userErrors.addFragment(spreads.UserErrorFragment);
	      });
	      checkoutDiscountCodeApplyV2.add("checkoutUserErrors", function (checkoutUserErrors) {
	        checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
	      });
	      checkoutDiscountCodeApplyV2.add("checkout", function (checkout) {
	        checkout.addFragment(spreads.CheckoutFragment);
	      });
	    });
	  });
	  return document;
	}
	
	function query$19(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.checkoutDiscountCodeRemove = {};
	  variables.checkoutDiscountCodeRemove.checkoutId = client.variable("checkoutId", "ID!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price");
	    root.add("priceV2", function (priceV2) {
	      priceV2.add("amount");
	      priceV2.add("currencyCode");
	    });
	    root.add("presentmentPrices", {
	      args: {
	        first: 20
	      }
	    }, function (presentmentPrices) {
	      presentmentPrices.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      presentmentPrices.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.add("price", function (price) {
	            price.add("amount");
	            price.add("currencyCode");
	          });
	        });
	      });
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice");
	    root.add("compareAtPriceV2", function (compareAtPriceV2) {
	      compareAtPriceV2.add("amount");
	      compareAtPriceV2.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	  });
	  spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
	    root.add("targetSelection");
	    root.add("allocationMethod");
	    root.add("targetType");
	    root.add("value", function (value) {
	      value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
	        MoneyV2.add("amount");
	        MoneyV2.add("currencyCode");
	      });
	      value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
	        PricingPercentageValue.add("percentage");
	      });
	    });
	    root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
	      ManualDiscountApplication.add("title");
	      ManualDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
	      DiscountCodeApplication.add("code");
	      DiscountCodeApplication.add("applicable");
	    });
	    root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
	      ScriptDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
	      AutomaticDiscountApplication.add("title");
	    });
	  });
	  spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
	    root.add("amountUsedV2", function (amountUsedV2) {
	      amountUsedV2.add("amount");
	      amountUsedV2.add("currencyCode");
	    });
	    root.add("balanceV2", function (balanceV2) {
	      balanceV2.add("amount");
	      balanceV2.add("currencyCode");
	    });
	    root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
	      presentmentAmountUsed.add("amount");
	      presentmentAmountUsed.add("currencyCode");
	    });
	    root.add("id");
	    root.add("lastCharacters");
	  });
	  spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
	    root.addFragment(spreads.VariantFragment);
	    root.add("product", function (product) {
	      product.add("id");
	      product.add("handle");
	    });
	  });
	  spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
	    root.add("field");
	    root.add("message");
	  });
	  spreads.CheckoutUserErrorFragment = document.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function (root) {
	    root.add("field");
	    root.add("message");
	    root.add("code");
	  });
	  spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
	    root.add("id");
	    root.add("address1");
	    root.add("address2");
	    root.add("city");
	    root.add("company");
	    root.add("country");
	    root.add("firstName");
	    root.add("formatted");
	    root.add("lastName");
	    root.add("latitude");
	    root.add("longitude");
	    root.add("phone");
	    root.add("province");
	    root.add("zip");
	    root.add("name");
	    root.add("countryCodeV2", {
	      alias: "countryCode"
	    });
	    root.add("provinceCode");
	  });
	  spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
	    root.add("id");
	    root.add("ready");
	    root.add("requiresShipping");
	    root.add("note");
	    root.add("paymentDue");
	    root.add("paymentDueV2", function (paymentDueV2) {
	      paymentDueV2.add("amount");
	      paymentDueV2.add("currencyCode");
	    });
	    root.add("webUrl");
	    root.add("orderStatusUrl");
	    root.add("taxExempt");
	    root.add("taxesIncluded");
	    root.add("currencyCode");
	    root.add("totalTax");
	    root.add("totalTaxV2", function (totalTaxV2) {
	      totalTaxV2.add("amount");
	      totalTaxV2.add("currencyCode");
	    });
	    root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
	      lineItemsSubtotalPrice.add("amount");
	      lineItemsSubtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice");
	    root.add("subtotalPriceV2", function (subtotalPriceV2) {
	      subtotalPriceV2.add("amount");
	      subtotalPriceV2.add("currencyCode");
	    });
	    root.add("totalPrice");
	    root.add("totalPriceV2", function (totalPriceV2) {
	      totalPriceV2.add("amount");
	      totalPriceV2.add("currencyCode");
	    });
	    root.add("completedAt");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("email");
	    root.add("discountApplications", {
	      args: {
	        first: 10
	      }
	    }, function (discountApplications) {
	      discountApplications.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      discountApplications.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.addFragment(spreads.DiscountApplicationFragment);
	        });
	      });
	    });
	    root.add("appliedGiftCards", function (appliedGiftCards) {
	      appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
	    });
	    root.add("shippingAddress", function (shippingAddress) {
	      shippingAddress.addFragment(spreads.MailingAddressFragment);
	    });
	    root.add("shippingLine", function (shippingLine) {
	      shippingLine.add("handle");
	      shippingLine.add("price");
	      shippingLine.add("title");
	    });
	    root.add("customAttributes", function (customAttributes) {
	      customAttributes.add("key");
	      customAttributes.add("value");
	    });
	    root.add("order", function (order) {
	      order.add("id");
	      order.add("processedAt");
	      order.add("orderNumber");
	      order.add("subtotalPrice");
	      order.add("subtotalPriceV2", function (subtotalPriceV2) {
	        subtotalPriceV2.add("amount");
	        subtotalPriceV2.add("currencyCode");
	      });
	      order.add("totalShippingPrice");
	      order.add("totalShippingPriceV2", function (totalShippingPriceV2) {
	        totalShippingPriceV2.add("amount");
	        totalShippingPriceV2.add("currencyCode");
	      });
	      order.add("totalTax");
	      order.add("totalTaxV2", function (totalTaxV2) {
	        totalTaxV2.add("amount");
	        totalTaxV2.add("currencyCode");
	      });
	      order.add("totalPrice");
	      order.add("totalPriceV2", function (totalPriceV2) {
	        totalPriceV2.add("amount");
	        totalPriceV2.add("currencyCode");
	      });
	      order.add("currencyCode");
	      order.add("totalRefunded");
	      order.add("totalRefundedV2", function (totalRefundedV2) {
	        totalRefundedV2.add("amount");
	        totalRefundedV2.add("currencyCode");
	      });
	      order.add("customerUrl");
	      order.add("shippingAddress", function (shippingAddress) {
	        shippingAddress.addFragment(spreads.MailingAddressFragment);
	      });
	      order.add("lineItems", {
	        args: {
	          first: 250
	        }
	      }, function (lineItems) {
	        lineItems.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        lineItems.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.add("title");
	            node.add("variant", function (variant) {
	              variant.addFragment(spreads.VariantWithProductFragment);
	            });
	            node.add("quantity");
	            node.add("customAttributes", function (customAttributes) {
	              customAttributes.add("key");
	              customAttributes.add("value");
	            });
	          });
	        });
	      });
	    });
	    root.add("lineItems", {
	      args: {
	        first: 250
	      }
	    }, function (lineItems) {
	      lineItems.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      lineItems.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("title");
	          node.add("variant", function (variant) {
	            variant.addFragment(spreads.VariantWithProductFragment);
	          });
	          node.add("quantity");
	          node.add("customAttributes", function (customAttributes) {
	            customAttributes.add("key");
	            customAttributes.add("value");
	          });
	          node.add("discountAllocations", function (discountAllocations) {
	            discountAllocations.add("allocatedAmount", function (allocatedAmount) {
	              allocatedAmount.add("amount");
	              allocatedAmount.add("currencyCode");
	            });
	            discountAllocations.add("discountApplication", function (discountApplication) {
	              discountApplication.addFragment(spreads.DiscountApplicationFragment);
	            });
	          });
	        });
	      });
	    });
	  });
	  document.addMutation("checkoutDiscountCodeRemove", [variables.checkoutDiscountCodeRemove.checkoutId], function (root) {
	    root.add("checkoutDiscountCodeRemove", {
	      args: {
	        checkoutId: variables.checkoutDiscountCodeRemove.checkoutId
	      }
	    }, function (checkoutDiscountCodeRemove) {
	      checkoutDiscountCodeRemove.add("userErrors", function (userErrors) {
	        userErrors.addFragment(spreads.UserErrorFragment);
	      });
	      checkoutDiscountCodeRemove.add("checkoutUserErrors", function (checkoutUserErrors) {
	        checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
	      });
	      checkoutDiscountCodeRemove.add("checkout", function (checkout) {
	        checkout.addFragment(spreads.CheckoutFragment);
	      });
	    });
	  });
	  return document;
	}
	
	function query$20(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.checkoutGiftCardsAppend = {};
	  variables.checkoutGiftCardsAppend.giftCardCodes = client.variable("giftCardCodes", "[String!]!");
	  variables.checkoutGiftCardsAppend.checkoutId = client.variable("checkoutId", "ID!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price");
	    root.add("priceV2", function (priceV2) {
	      priceV2.add("amount");
	      priceV2.add("currencyCode");
	    });
	    root.add("presentmentPrices", {
	      args: {
	        first: 20
	      }
	    }, function (presentmentPrices) {
	      presentmentPrices.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      presentmentPrices.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.add("price", function (price) {
	            price.add("amount");
	            price.add("currencyCode");
	          });
	        });
	      });
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice");
	    root.add("compareAtPriceV2", function (compareAtPriceV2) {
	      compareAtPriceV2.add("amount");
	      compareAtPriceV2.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	  });
	  spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
	    root.add("targetSelection");
	    root.add("allocationMethod");
	    root.add("targetType");
	    root.add("value", function (value) {
	      value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
	        MoneyV2.add("amount");
	        MoneyV2.add("currencyCode");
	      });
	      value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
	        PricingPercentageValue.add("percentage");
	      });
	    });
	    root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
	      ManualDiscountApplication.add("title");
	      ManualDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
	      DiscountCodeApplication.add("code");
	      DiscountCodeApplication.add("applicable");
	    });
	    root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
	      ScriptDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
	      AutomaticDiscountApplication.add("title");
	    });
	  });
	  spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
	    root.add("amountUsedV2", function (amountUsedV2) {
	      amountUsedV2.add("amount");
	      amountUsedV2.add("currencyCode");
	    });
	    root.add("balanceV2", function (balanceV2) {
	      balanceV2.add("amount");
	      balanceV2.add("currencyCode");
	    });
	    root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
	      presentmentAmountUsed.add("amount");
	      presentmentAmountUsed.add("currencyCode");
	    });
	    root.add("id");
	    root.add("lastCharacters");
	  });
	  spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
	    root.addFragment(spreads.VariantFragment);
	    root.add("product", function (product) {
	      product.add("id");
	      product.add("handle");
	    });
	  });
	  spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
	    root.add("field");
	    root.add("message");
	  });
	  spreads.CheckoutUserErrorFragment = document.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function (root) {
	    root.add("field");
	    root.add("message");
	    root.add("code");
	  });
	  spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
	    root.add("id");
	    root.add("address1");
	    root.add("address2");
	    root.add("city");
	    root.add("company");
	    root.add("country");
	    root.add("firstName");
	    root.add("formatted");
	    root.add("lastName");
	    root.add("latitude");
	    root.add("longitude");
	    root.add("phone");
	    root.add("province");
	    root.add("zip");
	    root.add("name");
	    root.add("countryCodeV2", {
	      alias: "countryCode"
	    });
	    root.add("provinceCode");
	  });
	  spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
	    root.add("id");
	    root.add("ready");
	    root.add("requiresShipping");
	    root.add("note");
	    root.add("paymentDue");
	    root.add("paymentDueV2", function (paymentDueV2) {
	      paymentDueV2.add("amount");
	      paymentDueV2.add("currencyCode");
	    });
	    root.add("webUrl");
	    root.add("orderStatusUrl");
	    root.add("taxExempt");
	    root.add("taxesIncluded");
	    root.add("currencyCode");
	    root.add("totalTax");
	    root.add("totalTaxV2", function (totalTaxV2) {
	      totalTaxV2.add("amount");
	      totalTaxV2.add("currencyCode");
	    });
	    root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
	      lineItemsSubtotalPrice.add("amount");
	      lineItemsSubtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice");
	    root.add("subtotalPriceV2", function (subtotalPriceV2) {
	      subtotalPriceV2.add("amount");
	      subtotalPriceV2.add("currencyCode");
	    });
	    root.add("totalPrice");
	    root.add("totalPriceV2", function (totalPriceV2) {
	      totalPriceV2.add("amount");
	      totalPriceV2.add("currencyCode");
	    });
	    root.add("completedAt");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("email");
	    root.add("discountApplications", {
	      args: {
	        first: 10
	      }
	    }, function (discountApplications) {
	      discountApplications.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      discountApplications.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.addFragment(spreads.DiscountApplicationFragment);
	        });
	      });
	    });
	    root.add("appliedGiftCards", function (appliedGiftCards) {
	      appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
	    });
	    root.add("shippingAddress", function (shippingAddress) {
	      shippingAddress.addFragment(spreads.MailingAddressFragment);
	    });
	    root.add("shippingLine", function (shippingLine) {
	      shippingLine.add("handle");
	      shippingLine.add("price");
	      shippingLine.add("title");
	    });
	    root.add("customAttributes", function (customAttributes) {
	      customAttributes.add("key");
	      customAttributes.add("value");
	    });
	    root.add("order", function (order) {
	      order.add("id");
	      order.add("processedAt");
	      order.add("orderNumber");
	      order.add("subtotalPrice");
	      order.add("subtotalPriceV2", function (subtotalPriceV2) {
	        subtotalPriceV2.add("amount");
	        subtotalPriceV2.add("currencyCode");
	      });
	      order.add("totalShippingPrice");
	      order.add("totalShippingPriceV2", function (totalShippingPriceV2) {
	        totalShippingPriceV2.add("amount");
	        totalShippingPriceV2.add("currencyCode");
	      });
	      order.add("totalTax");
	      order.add("totalTaxV2", function (totalTaxV2) {
	        totalTaxV2.add("amount");
	        totalTaxV2.add("currencyCode");
	      });
	      order.add("totalPrice");
	      order.add("totalPriceV2", function (totalPriceV2) {
	        totalPriceV2.add("amount");
	        totalPriceV2.add("currencyCode");
	      });
	      order.add("currencyCode");
	      order.add("totalRefunded");
	      order.add("totalRefundedV2", function (totalRefundedV2) {
	        totalRefundedV2.add("amount");
	        totalRefundedV2.add("currencyCode");
	      });
	      order.add("customerUrl");
	      order.add("shippingAddress", function (shippingAddress) {
	        shippingAddress.addFragment(spreads.MailingAddressFragment);
	      });
	      order.add("lineItems", {
	        args: {
	          first: 250
	        }
	      }, function (lineItems) {
	        lineItems.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        lineItems.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.add("title");
	            node.add("variant", function (variant) {
	              variant.addFragment(spreads.VariantWithProductFragment);
	            });
	            node.add("quantity");
	            node.add("customAttributes", function (customAttributes) {
	              customAttributes.add("key");
	              customAttributes.add("value");
	            });
	          });
	        });
	      });
	    });
	    root.add("lineItems", {
	      args: {
	        first: 250
	      }
	    }, function (lineItems) {
	      lineItems.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      lineItems.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("title");
	          node.add("variant", function (variant) {
	            variant.addFragment(spreads.VariantWithProductFragment);
	          });
	          node.add("quantity");
	          node.add("customAttributes", function (customAttributes) {
	            customAttributes.add("key");
	            customAttributes.add("value");
	          });
	          node.add("discountAllocations", function (discountAllocations) {
	            discountAllocations.add("allocatedAmount", function (allocatedAmount) {
	              allocatedAmount.add("amount");
	              allocatedAmount.add("currencyCode");
	            });
	            discountAllocations.add("discountApplication", function (discountApplication) {
	              discountApplication.addFragment(spreads.DiscountApplicationFragment);
	            });
	          });
	        });
	      });
	    });
	  });
	  document.addMutation("checkoutGiftCardsAppend", [variables.checkoutGiftCardsAppend.giftCardCodes, variables.checkoutGiftCardsAppend.checkoutId], function (root) {
	    root.add("checkoutGiftCardsAppend", {
	      args: {
	        giftCardCodes: variables.checkoutGiftCardsAppend.giftCardCodes,
	        checkoutId: variables.checkoutGiftCardsAppend.checkoutId
	      }
	    }, function (checkoutGiftCardsAppend) {
	      checkoutGiftCardsAppend.add("userErrors", function (userErrors) {
	        userErrors.addFragment(spreads.UserErrorFragment);
	      });
	      checkoutGiftCardsAppend.add("checkoutUserErrors", function (checkoutUserErrors) {
	        checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
	      });
	      checkoutGiftCardsAppend.add("checkout", function (checkout) {
	        checkout.addFragment(spreads.CheckoutFragment);
	      });
	    });
	  });
	  return document;
	}
	
	function query$21(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.checkoutGiftCardRemoveV2 = {};
	  variables.checkoutGiftCardRemoveV2.appliedGiftCardId = client.variable("appliedGiftCardId", "ID!");
	  variables.checkoutGiftCardRemoveV2.checkoutId = client.variable("checkoutId", "ID!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price");
	    root.add("priceV2", function (priceV2) {
	      priceV2.add("amount");
	      priceV2.add("currencyCode");
	    });
	    root.add("presentmentPrices", {
	      args: {
	        first: 20
	      }
	    }, function (presentmentPrices) {
	      presentmentPrices.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      presentmentPrices.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.add("price", function (price) {
	            price.add("amount");
	            price.add("currencyCode");
	          });
	        });
	      });
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice");
	    root.add("compareAtPriceV2", function (compareAtPriceV2) {
	      compareAtPriceV2.add("amount");
	      compareAtPriceV2.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	  });
	  spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
	    root.add("targetSelection");
	    root.add("allocationMethod");
	    root.add("targetType");
	    root.add("value", function (value) {
	      value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
	        MoneyV2.add("amount");
	        MoneyV2.add("currencyCode");
	      });
	      value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
	        PricingPercentageValue.add("percentage");
	      });
	    });
	    root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
	      ManualDiscountApplication.add("title");
	      ManualDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
	      DiscountCodeApplication.add("code");
	      DiscountCodeApplication.add("applicable");
	    });
	    root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
	      ScriptDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
	      AutomaticDiscountApplication.add("title");
	    });
	  });
	  spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
	    root.add("amountUsedV2", function (amountUsedV2) {
	      amountUsedV2.add("amount");
	      amountUsedV2.add("currencyCode");
	    });
	    root.add("balanceV2", function (balanceV2) {
	      balanceV2.add("amount");
	      balanceV2.add("currencyCode");
	    });
	    root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
	      presentmentAmountUsed.add("amount");
	      presentmentAmountUsed.add("currencyCode");
	    });
	    root.add("id");
	    root.add("lastCharacters");
	  });
	  spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
	    root.addFragment(spreads.VariantFragment);
	    root.add("product", function (product) {
	      product.add("id");
	      product.add("handle");
	    });
	  });
	  spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
	    root.add("field");
	    root.add("message");
	  });
	  spreads.CheckoutUserErrorFragment = document.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function (root) {
	    root.add("field");
	    root.add("message");
	    root.add("code");
	  });
	  spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
	    root.add("id");
	    root.add("address1");
	    root.add("address2");
	    root.add("city");
	    root.add("company");
	    root.add("country");
	    root.add("firstName");
	    root.add("formatted");
	    root.add("lastName");
	    root.add("latitude");
	    root.add("longitude");
	    root.add("phone");
	    root.add("province");
	    root.add("zip");
	    root.add("name");
	    root.add("countryCodeV2", {
	      alias: "countryCode"
	    });
	    root.add("provinceCode");
	  });
	  spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
	    root.add("id");
	    root.add("ready");
	    root.add("requiresShipping");
	    root.add("note");
	    root.add("paymentDue");
	    root.add("paymentDueV2", function (paymentDueV2) {
	      paymentDueV2.add("amount");
	      paymentDueV2.add("currencyCode");
	    });
	    root.add("webUrl");
	    root.add("orderStatusUrl");
	    root.add("taxExempt");
	    root.add("taxesIncluded");
	    root.add("currencyCode");
	    root.add("totalTax");
	    root.add("totalTaxV2", function (totalTaxV2) {
	      totalTaxV2.add("amount");
	      totalTaxV2.add("currencyCode");
	    });
	    root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
	      lineItemsSubtotalPrice.add("amount");
	      lineItemsSubtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice");
	    root.add("subtotalPriceV2", function (subtotalPriceV2) {
	      subtotalPriceV2.add("amount");
	      subtotalPriceV2.add("currencyCode");
	    });
	    root.add("totalPrice");
	    root.add("totalPriceV2", function (totalPriceV2) {
	      totalPriceV2.add("amount");
	      totalPriceV2.add("currencyCode");
	    });
	    root.add("completedAt");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("email");
	    root.add("discountApplications", {
	      args: {
	        first: 10
	      }
	    }, function (discountApplications) {
	      discountApplications.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      discountApplications.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.addFragment(spreads.DiscountApplicationFragment);
	        });
	      });
	    });
	    root.add("appliedGiftCards", function (appliedGiftCards) {
	      appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
	    });
	    root.add("shippingAddress", function (shippingAddress) {
	      shippingAddress.addFragment(spreads.MailingAddressFragment);
	    });
	    root.add("shippingLine", function (shippingLine) {
	      shippingLine.add("handle");
	      shippingLine.add("price");
	      shippingLine.add("title");
	    });
	    root.add("customAttributes", function (customAttributes) {
	      customAttributes.add("key");
	      customAttributes.add("value");
	    });
	    root.add("order", function (order) {
	      order.add("id");
	      order.add("processedAt");
	      order.add("orderNumber");
	      order.add("subtotalPrice");
	      order.add("subtotalPriceV2", function (subtotalPriceV2) {
	        subtotalPriceV2.add("amount");
	        subtotalPriceV2.add("currencyCode");
	      });
	      order.add("totalShippingPrice");
	      order.add("totalShippingPriceV2", function (totalShippingPriceV2) {
	        totalShippingPriceV2.add("amount");
	        totalShippingPriceV2.add("currencyCode");
	      });
	      order.add("totalTax");
	      order.add("totalTaxV2", function (totalTaxV2) {
	        totalTaxV2.add("amount");
	        totalTaxV2.add("currencyCode");
	      });
	      order.add("totalPrice");
	      order.add("totalPriceV2", function (totalPriceV2) {
	        totalPriceV2.add("amount");
	        totalPriceV2.add("currencyCode");
	      });
	      order.add("currencyCode");
	      order.add("totalRefunded");
	      order.add("totalRefundedV2", function (totalRefundedV2) {
	        totalRefundedV2.add("amount");
	        totalRefundedV2.add("currencyCode");
	      });
	      order.add("customerUrl");
	      order.add("shippingAddress", function (shippingAddress) {
	        shippingAddress.addFragment(spreads.MailingAddressFragment);
	      });
	      order.add("lineItems", {
	        args: {
	          first: 250
	        }
	      }, function (lineItems) {
	        lineItems.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        lineItems.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.add("title");
	            node.add("variant", function (variant) {
	              variant.addFragment(spreads.VariantWithProductFragment);
	            });
	            node.add("quantity");
	            node.add("customAttributes", function (customAttributes) {
	              customAttributes.add("key");
	              customAttributes.add("value");
	            });
	          });
	        });
	      });
	    });
	    root.add("lineItems", {
	      args: {
	        first: 250
	      }
	    }, function (lineItems) {
	      lineItems.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      lineItems.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("title");
	          node.add("variant", function (variant) {
	            variant.addFragment(spreads.VariantWithProductFragment);
	          });
	          node.add("quantity");
	          node.add("customAttributes", function (customAttributes) {
	            customAttributes.add("key");
	            customAttributes.add("value");
	          });
	          node.add("discountAllocations", function (discountAllocations) {
	            discountAllocations.add("allocatedAmount", function (allocatedAmount) {
	              allocatedAmount.add("amount");
	              allocatedAmount.add("currencyCode");
	            });
	            discountAllocations.add("discountApplication", function (discountApplication) {
	              discountApplication.addFragment(spreads.DiscountApplicationFragment);
	            });
	          });
	        });
	      });
	    });
	  });
	  document.addMutation("checkoutGiftCardRemoveV2", [variables.checkoutGiftCardRemoveV2.appliedGiftCardId, variables.checkoutGiftCardRemoveV2.checkoutId], function (root) {
	    root.add("checkoutGiftCardRemoveV2", {
	      args: {
	        appliedGiftCardId: variables.checkoutGiftCardRemoveV2.appliedGiftCardId,
	        checkoutId: variables.checkoutGiftCardRemoveV2.checkoutId
	      }
	    }, function (checkoutGiftCardRemoveV2) {
	      checkoutGiftCardRemoveV2.add("userErrors", function (userErrors) {
	        userErrors.addFragment(spreads.UserErrorFragment);
	      });
	      checkoutGiftCardRemoveV2.add("checkoutUserErrors", function (checkoutUserErrors) {
	        checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
	      });
	      checkoutGiftCardRemoveV2.add("checkout", function (checkout) {
	        checkout.addFragment(spreads.CheckoutFragment);
	      });
	    });
	  });
	  return document;
	}
	
	function query$22(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.checkoutEmailUpdateV2 = {};
	  variables.checkoutEmailUpdateV2.checkoutId = client.variable("checkoutId", "ID!");
	  variables.checkoutEmailUpdateV2.email = client.variable("email", "String!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price");
	    root.add("priceV2", function (priceV2) {
	      priceV2.add("amount");
	      priceV2.add("currencyCode");
	    });
	    root.add("presentmentPrices", {
	      args: {
	        first: 20
	      }
	    }, function (presentmentPrices) {
	      presentmentPrices.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      presentmentPrices.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.add("price", function (price) {
	            price.add("amount");
	            price.add("currencyCode");
	          });
	        });
	      });
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice");
	    root.add("compareAtPriceV2", function (compareAtPriceV2) {
	      compareAtPriceV2.add("amount");
	      compareAtPriceV2.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	  });
	  spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
	    root.add("targetSelection");
	    root.add("allocationMethod");
	    root.add("targetType");
	    root.add("value", function (value) {
	      value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
	        MoneyV2.add("amount");
	        MoneyV2.add("currencyCode");
	      });
	      value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
	        PricingPercentageValue.add("percentage");
	      });
	    });
	    root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
	      ManualDiscountApplication.add("title");
	      ManualDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
	      DiscountCodeApplication.add("code");
	      DiscountCodeApplication.add("applicable");
	    });
	    root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
	      ScriptDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
	      AutomaticDiscountApplication.add("title");
	    });
	  });
	  spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
	    root.add("amountUsedV2", function (amountUsedV2) {
	      amountUsedV2.add("amount");
	      amountUsedV2.add("currencyCode");
	    });
	    root.add("balanceV2", function (balanceV2) {
	      balanceV2.add("amount");
	      balanceV2.add("currencyCode");
	    });
	    root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
	      presentmentAmountUsed.add("amount");
	      presentmentAmountUsed.add("currencyCode");
	    });
	    root.add("id");
	    root.add("lastCharacters");
	  });
	  spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
	    root.addFragment(spreads.VariantFragment);
	    root.add("product", function (product) {
	      product.add("id");
	      product.add("handle");
	    });
	  });
	  spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
	    root.add("field");
	    root.add("message");
	  });
	  spreads.CheckoutUserErrorFragment = document.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function (root) {
	    root.add("field");
	    root.add("message");
	    root.add("code");
	  });
	  spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
	    root.add("id");
	    root.add("address1");
	    root.add("address2");
	    root.add("city");
	    root.add("company");
	    root.add("country");
	    root.add("firstName");
	    root.add("formatted");
	    root.add("lastName");
	    root.add("latitude");
	    root.add("longitude");
	    root.add("phone");
	    root.add("province");
	    root.add("zip");
	    root.add("name");
	    root.add("countryCodeV2", {
	      alias: "countryCode"
	    });
	    root.add("provinceCode");
	  });
	  spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
	    root.add("id");
	    root.add("ready");
	    root.add("requiresShipping");
	    root.add("note");
	    root.add("paymentDue");
	    root.add("paymentDueV2", function (paymentDueV2) {
	      paymentDueV2.add("amount");
	      paymentDueV2.add("currencyCode");
	    });
	    root.add("webUrl");
	    root.add("orderStatusUrl");
	    root.add("taxExempt");
	    root.add("taxesIncluded");
	    root.add("currencyCode");
	    root.add("totalTax");
	    root.add("totalTaxV2", function (totalTaxV2) {
	      totalTaxV2.add("amount");
	      totalTaxV2.add("currencyCode");
	    });
	    root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
	      lineItemsSubtotalPrice.add("amount");
	      lineItemsSubtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice");
	    root.add("subtotalPriceV2", function (subtotalPriceV2) {
	      subtotalPriceV2.add("amount");
	      subtotalPriceV2.add("currencyCode");
	    });
	    root.add("totalPrice");
	    root.add("totalPriceV2", function (totalPriceV2) {
	      totalPriceV2.add("amount");
	      totalPriceV2.add("currencyCode");
	    });
	    root.add("completedAt");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("email");
	    root.add("discountApplications", {
	      args: {
	        first: 10
	      }
	    }, function (discountApplications) {
	      discountApplications.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      discountApplications.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.addFragment(spreads.DiscountApplicationFragment);
	        });
	      });
	    });
	    root.add("appliedGiftCards", function (appliedGiftCards) {
	      appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
	    });
	    root.add("shippingAddress", function (shippingAddress) {
	      shippingAddress.addFragment(spreads.MailingAddressFragment);
	    });
	    root.add("shippingLine", function (shippingLine) {
	      shippingLine.add("handle");
	      shippingLine.add("price");
	      shippingLine.add("title");
	    });
	    root.add("customAttributes", function (customAttributes) {
	      customAttributes.add("key");
	      customAttributes.add("value");
	    });
	    root.add("order", function (order) {
	      order.add("id");
	      order.add("processedAt");
	      order.add("orderNumber");
	      order.add("subtotalPrice");
	      order.add("subtotalPriceV2", function (subtotalPriceV2) {
	        subtotalPriceV2.add("amount");
	        subtotalPriceV2.add("currencyCode");
	      });
	      order.add("totalShippingPrice");
	      order.add("totalShippingPriceV2", function (totalShippingPriceV2) {
	        totalShippingPriceV2.add("amount");
	        totalShippingPriceV2.add("currencyCode");
	      });
	      order.add("totalTax");
	      order.add("totalTaxV2", function (totalTaxV2) {
	        totalTaxV2.add("amount");
	        totalTaxV2.add("currencyCode");
	      });
	      order.add("totalPrice");
	      order.add("totalPriceV2", function (totalPriceV2) {
	        totalPriceV2.add("amount");
	        totalPriceV2.add("currencyCode");
	      });
	      order.add("currencyCode");
	      order.add("totalRefunded");
	      order.add("totalRefundedV2", function (totalRefundedV2) {
	        totalRefundedV2.add("amount");
	        totalRefundedV2.add("currencyCode");
	      });
	      order.add("customerUrl");
	      order.add("shippingAddress", function (shippingAddress) {
	        shippingAddress.addFragment(spreads.MailingAddressFragment);
	      });
	      order.add("lineItems", {
	        args: {
	          first: 250
	        }
	      }, function (lineItems) {
	        lineItems.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        lineItems.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.add("title");
	            node.add("variant", function (variant) {
	              variant.addFragment(spreads.VariantWithProductFragment);
	            });
	            node.add("quantity");
	            node.add("customAttributes", function (customAttributes) {
	              customAttributes.add("key");
	              customAttributes.add("value");
	            });
	          });
	        });
	      });
	    });
	    root.add("lineItems", {
	      args: {
	        first: 250
	      }
	    }, function (lineItems) {
	      lineItems.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      lineItems.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("title");
	          node.add("variant", function (variant) {
	            variant.addFragment(spreads.VariantWithProductFragment);
	          });
	          node.add("quantity");
	          node.add("customAttributes", function (customAttributes) {
	            customAttributes.add("key");
	            customAttributes.add("value");
	          });
	          node.add("discountAllocations", function (discountAllocations) {
	            discountAllocations.add("allocatedAmount", function (allocatedAmount) {
	              allocatedAmount.add("amount");
	              allocatedAmount.add("currencyCode");
	            });
	            discountAllocations.add("discountApplication", function (discountApplication) {
	              discountApplication.addFragment(spreads.DiscountApplicationFragment);
	            });
	          });
	        });
	      });
	    });
	  });
	  document.addMutation("checkoutEmailUpdateV2", [variables.checkoutEmailUpdateV2.checkoutId, variables.checkoutEmailUpdateV2.email], function (root) {
	    root.add("checkoutEmailUpdateV2", {
	      args: {
	        checkoutId: variables.checkoutEmailUpdateV2.checkoutId,
	        email: variables.checkoutEmailUpdateV2.email
	      }
	    }, function (checkoutEmailUpdateV2) {
	      checkoutEmailUpdateV2.add("userErrors", function (userErrors) {
	        userErrors.addFragment(spreads.UserErrorFragment);
	      });
	      checkoutEmailUpdateV2.add("checkoutUserErrors", function (checkoutUserErrors) {
	        checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
	      });
	      checkoutEmailUpdateV2.add("checkout", function (checkout) {
	        checkout.addFragment(spreads.CheckoutFragment);
	      });
	    });
	  });
	  return document;
	}
	
	function query$23(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.checkoutShippingAddressUpdateV2 = {};
	  variables.checkoutShippingAddressUpdateV2.shippingAddress = client.variable("shippingAddress", "MailingAddressInput!");
	  variables.checkoutShippingAddressUpdateV2.checkoutId = client.variable("checkoutId", "ID!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price");
	    root.add("priceV2", function (priceV2) {
	      priceV2.add("amount");
	      priceV2.add("currencyCode");
	    });
	    root.add("presentmentPrices", {
	      args: {
	        first: 20
	      }
	    }, function (presentmentPrices) {
	      presentmentPrices.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      presentmentPrices.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.add("price", function (price) {
	            price.add("amount");
	            price.add("currencyCode");
	          });
	        });
	      });
	    });
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice");
	    root.add("compareAtPriceV2", function (compareAtPriceV2) {
	      compareAtPriceV2.add("amount");
	      compareAtPriceV2.add("currencyCode");
	    });
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	  });
	  spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
	    root.add("targetSelection");
	    root.add("allocationMethod");
	    root.add("targetType");
	    root.add("value", function (value) {
	      value.addInlineFragmentOn("MoneyV2", function (MoneyV2) {
	        MoneyV2.add("amount");
	        MoneyV2.add("currencyCode");
	      });
	      value.addInlineFragmentOn("PricingPercentageValue", function (PricingPercentageValue) {
	        PricingPercentageValue.add("percentage");
	      });
	    });
	    root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
	      ManualDiscountApplication.add("title");
	      ManualDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
	      DiscountCodeApplication.add("code");
	      DiscountCodeApplication.add("applicable");
	    });
	    root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
	      ScriptDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("AutomaticDiscountApplication", function (AutomaticDiscountApplication) {
	      AutomaticDiscountApplication.add("title");
	    });
	  });
	  spreads.AppliedGiftCardFragment = document.defineFragment("AppliedGiftCardFragment", "AppliedGiftCard", function (root) {
	    root.add("amountUsedV2", function (amountUsedV2) {
	      amountUsedV2.add("amount");
	      amountUsedV2.add("currencyCode");
	    });
	    root.add("balanceV2", function (balanceV2) {
	      balanceV2.add("amount");
	      balanceV2.add("currencyCode");
	    });
	    root.add("presentmentAmountUsed", function (presentmentAmountUsed) {
	      presentmentAmountUsed.add("amount");
	      presentmentAmountUsed.add("currencyCode");
	    });
	    root.add("id");
	    root.add("lastCharacters");
	  });
	  spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
	    root.addFragment(spreads.VariantFragment);
	    root.add("product", function (product) {
	      product.add("id");
	      product.add("handle");
	    });
	  });
	  spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
	    root.add("field");
	    root.add("message");
	  });
	  spreads.CheckoutUserErrorFragment = document.defineFragment("CheckoutUserErrorFragment", "CheckoutUserError", function (root) {
	    root.add("field");
	    root.add("message");
	    root.add("code");
	  });
	  spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
	    root.add("id");
	    root.add("address1");
	    root.add("address2");
	    root.add("city");
	    root.add("company");
	    root.add("country");
	    root.add("firstName");
	    root.add("formatted");
	    root.add("lastName");
	    root.add("latitude");
	    root.add("longitude");
	    root.add("phone");
	    root.add("province");
	    root.add("zip");
	    root.add("name");
	    root.add("countryCodeV2", {
	      alias: "countryCode"
	    });
	    root.add("provinceCode");
	  });
	  spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
	    root.add("id");
	    root.add("ready");
	    root.add("requiresShipping");
	    root.add("note");
	    root.add("paymentDue");
	    root.add("paymentDueV2", function (paymentDueV2) {
	      paymentDueV2.add("amount");
	      paymentDueV2.add("currencyCode");
	    });
	    root.add("webUrl");
	    root.add("orderStatusUrl");
	    root.add("taxExempt");
	    root.add("taxesIncluded");
	    root.add("currencyCode");
	    root.add("totalTax");
	    root.add("totalTaxV2", function (totalTaxV2) {
	      totalTaxV2.add("amount");
	      totalTaxV2.add("currencyCode");
	    });
	    root.add("lineItemsSubtotalPrice", function (lineItemsSubtotalPrice) {
	      lineItemsSubtotalPrice.add("amount");
	      lineItemsSubtotalPrice.add("currencyCode");
	    });
	    root.add("subtotalPrice");
	    root.add("subtotalPriceV2", function (subtotalPriceV2) {
	      subtotalPriceV2.add("amount");
	      subtotalPriceV2.add("currencyCode");
	    });
	    root.add("totalPrice");
	    root.add("totalPriceV2", function (totalPriceV2) {
	      totalPriceV2.add("amount");
	      totalPriceV2.add("currencyCode");
	    });
	    root.add("completedAt");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("email");
	    root.add("discountApplications", {
	      args: {
	        first: 10
	      }
	    }, function (discountApplications) {
	      discountApplications.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      discountApplications.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.addFragment(spreads.DiscountApplicationFragment);
	        });
	      });
	    });
	    root.add("appliedGiftCards", function (appliedGiftCards) {
	      appliedGiftCards.addFragment(spreads.AppliedGiftCardFragment);
	    });
	    root.add("shippingAddress", function (shippingAddress) {
	      shippingAddress.addFragment(spreads.MailingAddressFragment);
	    });
	    root.add("shippingLine", function (shippingLine) {
	      shippingLine.add("handle");
	      shippingLine.add("price");
	      shippingLine.add("title");
	    });
	    root.add("customAttributes", function (customAttributes) {
	      customAttributes.add("key");
	      customAttributes.add("value");
	    });
	    root.add("order", function (order) {
	      order.add("id");
	      order.add("processedAt");
	      order.add("orderNumber");
	      order.add("subtotalPrice");
	      order.add("subtotalPriceV2", function (subtotalPriceV2) {
	        subtotalPriceV2.add("amount");
	        subtotalPriceV2.add("currencyCode");
	      });
	      order.add("totalShippingPrice");
	      order.add("totalShippingPriceV2", function (totalShippingPriceV2) {
	        totalShippingPriceV2.add("amount");
	        totalShippingPriceV2.add("currencyCode");
	      });
	      order.add("totalTax");
	      order.add("totalTaxV2", function (totalTaxV2) {
	        totalTaxV2.add("amount");
	        totalTaxV2.add("currencyCode");
	      });
	      order.add("totalPrice");
	      order.add("totalPriceV2", function (totalPriceV2) {
	        totalPriceV2.add("amount");
	        totalPriceV2.add("currencyCode");
	      });
	      order.add("currencyCode");
	      order.add("totalRefunded");
	      order.add("totalRefundedV2", function (totalRefundedV2) {
	        totalRefundedV2.add("amount");
	        totalRefundedV2.add("currencyCode");
	      });
	      order.add("customerUrl");
	      order.add("shippingAddress", function (shippingAddress) {
	        shippingAddress.addFragment(spreads.MailingAddressFragment);
	      });
	      order.add("lineItems", {
	        args: {
	          first: 250
	        }
	      }, function (lineItems) {
	        lineItems.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        lineItems.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.add("title");
	            node.add("variant", function (variant) {
	              variant.addFragment(spreads.VariantWithProductFragment);
	            });
	            node.add("quantity");
	            node.add("customAttributes", function (customAttributes) {
	              customAttributes.add("key");
	              customAttributes.add("value");
	            });
	          });
	        });
	      });
	    });
	    root.add("lineItems", {
	      args: {
	        first: 250
	      }
	    }, function (lineItems) {
	      lineItems.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      lineItems.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("title");
	          node.add("variant", function (variant) {
	            variant.addFragment(spreads.VariantWithProductFragment);
	          });
	          node.add("quantity");
	          node.add("customAttributes", function (customAttributes) {
	            customAttributes.add("key");
	            customAttributes.add("value");
	          });
	          node.add("discountAllocations", function (discountAllocations) {
	            discountAllocations.add("allocatedAmount", function (allocatedAmount) {
	              allocatedAmount.add("amount");
	              allocatedAmount.add("currencyCode");
	            });
	            discountAllocations.add("discountApplication", function (discountApplication) {
	              discountApplication.addFragment(spreads.DiscountApplicationFragment);
	            });
	          });
	        });
	      });
	    });
	  });
	  document.addMutation("checkoutShippingAddressUpdateV2", [variables.checkoutShippingAddressUpdateV2.shippingAddress, variables.checkoutShippingAddressUpdateV2.checkoutId], function (root) {
	    root.add("checkoutShippingAddressUpdateV2", {
	      args: {
	        shippingAddress: variables.checkoutShippingAddressUpdateV2.shippingAddress,
	        checkoutId: variables.checkoutShippingAddressUpdateV2.checkoutId
	      }
	    }, function (checkoutShippingAddressUpdateV2) {
	      checkoutShippingAddressUpdateV2.add("userErrors", function (userErrors) {
	        userErrors.addFragment(spreads.UserErrorFragment);
	      });
	      checkoutShippingAddressUpdateV2.add("checkoutUserErrors", function (checkoutUserErrors) {
	        checkoutUserErrors.addFragment(spreads.CheckoutUserErrorFragment);
	      });
	      checkoutShippingAddressUpdateV2.add("checkout", function (checkout) {
	        checkout.addFragment(spreads.CheckoutFragment);
	      });
	    });
	  });
	  return document;
	}
	
	// GraphQL
	/**
	 * The JS Buy SDK checkout resource
	 * @class
	 */
	
	var CheckoutResource = function (_Resource) {
	  inherits$1(CheckoutResource, _Resource);
	
	  function CheckoutResource() {
	    classCallCheck$1(this, CheckoutResource);
	    return possibleConstructorReturn$1(this, (CheckoutResource.__proto__ || Object.getPrototypeOf(CheckoutResource)).apply(this, arguments));
	  }
	
	  createClass$1(CheckoutResource, [{
	    key: 'fetch',
	
	
	    /**
	     * Fetches a checkout by ID.
	     *
	     * @example
	     * client.checkout.fetch('FlZj9rZXlN5MDY4ZDFiZTUyZTUwNTE2MDNhZjg=').then((checkout) => {
	     *   // Do something with the checkout
	     * });
	     *
	     * @param {String} id The id of the checkout to fetch.
	     * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the checkout.
	     */
	    value: function fetch(id) {
	      var _this2 = this;
	
	      return this.graphQLClient.send(query$11, { id: id }).then(defaultResolver('node')).then(function (checkout) {
	        if (!checkout) {
	          return null;
	        }
	
	        return _this2.graphQLClient.fetchAllPages(checkout.lineItems, { pageSize: 250 }).then(function (lineItems) {
	          checkout.attrs.lineItems = lineItems;
	
	          return checkout;
	        });
	      });
	    }
	
	    /**
	     * Creates a checkout.
	     *
	     * @example
	     * const input = {
	     *   lineItems: [
	     *     {variantId: 'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8yOTEwNjAyMjc5Mg==', quantity: 5}
	     *   ]
	     * };
	     *
	     * client.checkout.create(input).then((checkout) => {
	     *   // Do something with the newly created checkout
	     * });
	     *
	     * @param {Object} [input] An input object containing zero or more of:
	     *   @param {String} [input.email] An email connected to the checkout.
	     *   @param {Object[]} [input.lineItems] A list of line items in the checkout. See the {@link https://help.shopify.com/api/storefront-api/reference/input-object/checkoutlineiteminput|Storefront API reference} for valid input fields for each line item.
	     *   @param {Object} [input.shippingAddress] A shipping address. See the {@link https://help.shopify.com/api/storefront-api/reference/input-object/mailingaddressinput|Storefront API reference} for valid input fields.
	     *   @param {String} [input.note] A note for the checkout.
	     *   @param {Object[]} [input.customAttributes] A list of custom attributes for the checkout. See the {@link https://help.shopify.com/api/storefront-api/reference/input-object/attributeinput|Storefront API reference} for valid input fields.
	     *   @param {String} [input.presentmentCurrencyCode ] A presentment currency code. See the {@link https://help.shopify.com/en/api/storefront-api/reference/enum/currencycode|Storefront API reference} for valid currency code values.
	     * @return {Promise|GraphModel} A promise resolving with the created checkout.
	     */
	
	  }, {
	    key: 'create',
	    value: function create() {
	      var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      return this.graphQLClient.send(query$12, { input: input }).then(handleCheckoutMutation('checkoutCreate', this.graphQLClient));
	    }
	
	    /**
	     * Replaces the value of checkout's custom attributes and/or note with values defined in the input
	     *
	     * @example
	     * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
	     * const input = {customAttributes: [{key: "MyKey", value: "MyValue"}]};
	     *
	     * client.checkout.updateAttributes(checkoutId, input).then((checkout) => {
	     *   // Do something with the updated checkout
	     * });
	     *
	     * @param {String} checkoutId The ID of the checkout to update.
	     * @param {Object} [input] An input object containing zero or more of:
	     *   @param {Boolean} [input.allowPartialAddresses] An email connected to the checkout.
	     *   @param {Object[]} [input.customAttributes] A list of custom attributes for the checkout. See the {@link https://help.shopify.com/api/storefront-api/reference/input-object/attributeinput|Storefront API reference} for valid input fields.
	     *   @param {String} [input.note] A note for the checkout.
	     * @return {Promise|GraphModel} A promise resolving with the updated checkout.
	     */
	
	  }, {
	    key: 'updateAttributes',
	    value: function updateAttributes(checkoutId) {
	      var input = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return this.graphQLClient.send(query$17, { checkoutId: checkoutId, input: input }).then(handleCheckoutMutation('checkoutAttributesUpdateV2', this.graphQLClient));
	    }
	
	    /**
	     * Replaces the value of checkout's email address
	     *
	     * @example
	     * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
	     * const email = 'user@example.com';
	     *
	     * client.checkout.updateEmail(checkoutId, email).then((checkout) => {
	     *   // Do something with the updated checkout
	     * });
	     *
	     * @param {String} checkoutId The ID of the checkout to update.
	     * @param {String} email The email address to apply to the checkout.
	     * @return {Promise|GraphModel} A promise resolving with the updated checkout.
	     */
	
	  }, {
	    key: 'updateEmail',
	    value: function updateEmail(checkoutId, email) {
	      return this.graphQLClient.send(query$22, { checkoutId: checkoutId, email: email }).then(handleCheckoutMutation('checkoutEmailUpdateV2', this.graphQLClient));
	    }
	
	    /**
	     * Adds line items to an existing checkout.
	     *
	     * @example
	     * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
	     * const lineItems = [{variantId: 'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8yOTEwNjAyMjc5Mg==', quantity: 5}];
	     *
	     * client.checkout.addLineItems(checkoutId, lineItems).then((checkout) => {
	     *   // Do something with the updated checkout
	     * });
	     *
	     * @param {String} checkoutId The ID of the checkout to add line items to.
	     * @param {Object[]} lineItems A list of line items to add to the checkout. See the {@link https://help.shopify.com/api/storefront-api/reference/input-object/checkoutlineiteminput|Storefront API reference} for valid input fields for each line item.
	     * @return {Promise|GraphModel} A promise resolving with the updated checkout.
	     */
	
	  }, {
	    key: 'addLineItems',
	    value: function addLineItems(checkoutId, lineItems) {
	      return this.graphQLClient.send(query$13, { checkoutId: checkoutId, lineItems: lineItems }).then(handleCheckoutMutation('checkoutLineItemsAdd', this.graphQLClient));
	    }
	
	    /**
	     * Applies a discount to an existing checkout using a discount code.
	     *
	     * @example
	     * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
	     * const discountCode = 'best-discount-ever';
	     *
	     * client.checkout.addDiscount(checkoutId, discountCode).then((checkout) => {
	     *   // Do something with the updated checkout
	     * });
	     *
	     * @param {String} checkoutId The ID of the checkout to add discount to.
	     * @param {String} discountCode The discount code to apply to the checkout.
	     * @return {Promise|GraphModel} A promise resolving with the updated checkout.
	     */
	
	  }, {
	    key: 'addDiscount',
	    value: function addDiscount(checkoutId, discountCode) {
	      return this.graphQLClient.send(query$18, { checkoutId: checkoutId, discountCode: discountCode }).then(handleCheckoutMutation('checkoutDiscountCodeApplyV2', this.graphQLClient));
	    }
	
	    /**
	     * Removes the applied discount from an existing checkout.
	     *
	     * @example
	     * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
	     *
	     * client.checkout.removeDiscount(checkoutId).then((checkout) => {
	     *   // Do something with the updated checkout
	     * });
	     *
	     * @param {String} checkoutId The ID of the checkout to remove the discount from.
	     * @return {Promise|GraphModel} A promise resolving with the updated checkout.
	     */
	
	  }, {
	    key: 'removeDiscount',
	    value: function removeDiscount(checkoutId) {
	      return this.graphQLClient.send(query$19, { checkoutId: checkoutId }).then(handleCheckoutMutation('checkoutDiscountCodeRemove', this.graphQLClient));
	    }
	
	    /**
	     * Applies gift cards to an existing checkout using a list of gift card codes
	     *
	     * @example
	     * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
	     * const giftCardCodes = ['6FD8853DAGAA949F'];
	     *
	     * client.checkout.addGiftCards(checkoutId, giftCardCodes).then((checkout) => {
	     *   // Do something with the updated checkout
	     * });
	     *
	     * @param {String} checkoutId The ID of the checkout to add gift cards to.
	     * @param {String[]} giftCardCodes The gift card codes to apply to the checkout.
	     * @return {Promise|GraphModel} A promise resolving with the updated checkout.
	     */
	
	  }, {
	    key: 'addGiftCards',
	    value: function addGiftCards(checkoutId, giftCardCodes) {
	      return this.graphQLClient.send(query$20, { checkoutId: checkoutId, giftCardCodes: giftCardCodes }).then(handleCheckoutMutation('checkoutGiftCardsAppend', this.graphQLClient));
	    }
	
	    /**
	     * Remove a gift card from an existing checkout
	     *
	     * @example
	     * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
	     * const appliedGiftCardId = 'Z2lkOi8vc2hvcGlmeS9BcHBsaWVkR2lmdENhcmQvNDI4NTQ1ODAzMTI=';
	     *
	     * client.checkout.removeGiftCard(checkoutId, appliedGiftCardId).then((checkout) => {
	     *   // Do something with the updated checkout
	     * });
	     *
	     * @param {String} checkoutId The ID of the checkout to add gift cards to.
	     * @param {String} appliedGiftCardId The gift card id to remove from the checkout.
	     * @return {Promise|GraphModel} A promise resolving with the updated checkout.
	     */
	
	  }, {
	    key: 'removeGiftCard',
	    value: function removeGiftCard(checkoutId, appliedGiftCardId) {
	      return this.graphQLClient.send(query$21, { checkoutId: checkoutId, appliedGiftCardId: appliedGiftCardId }).then(handleCheckoutMutation('checkoutGiftCardRemoveV2', this.graphQLClient));
	    }
	
	    /**
	     * Removes line items from an existing checkout.
	     *
	     * @example
	     * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
	     * const lineItemIds = ['TViZGE5Y2U1ZDFhY2FiMmM2YT9rZXk9NTc2YjBhODcwNWIxYzg0YjE5ZjRmZGQ5NjczNGVkZGU='];
	     *
	     * client.checkout.removeLineItems(checkoutId, lineItemIds).then((checkout) => {
	     *   // Do something with the updated checkout
	     * });
	     *
	     * @param {String} checkoutId The ID of the checkout to remove line items from.
	     * @param {String[]} lineItemIds A list of the ids of line items to remove from the checkout.
	     * @return {Promise|GraphModel} A promise resolving with the updated checkout.
	     */
	
	  }, {
	    key: 'removeLineItems',
	    value: function removeLineItems(checkoutId, lineItemIds) {
	      return this.graphQLClient.send(query$14, { checkoutId: checkoutId, lineItemIds: lineItemIds }).then(handleCheckoutMutation('checkoutLineItemsRemove', this.graphQLClient));
	    }
	
	    /**
	     * Replace line items on an existing checkout.
	     *
	     * @example
	     * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
	     * const lineItems = [{variantId: 'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8yOTEwNjAyMjc5Mg==', quantity: 5}];
	     *
	     * client.checkout.replaceLineItems(checkoutId, lineItems).then((checkout) => {
	     *   // Do something with the updated checkout
	     * });
	     *
	     * @param {String} checkoutId The ID of the checkout to add line items to.
	     * @param {Object[]} lineItems A list of line items to set on the checkout. See the {@link https://help.shopify.com/api/storefront-api/reference/input-object/checkoutlineiteminput|Storefront API reference} for valid input fields for each line item.
	     * @return {Promise|GraphModel} A promise resolving with the updated checkout.
	     */
	
	  }, {
	    key: 'replaceLineItems',
	    value: function replaceLineItems(checkoutId, lineItems) {
	      return this.graphQLClient.send(query$15, { checkoutId: checkoutId, lineItems: lineItems }).then(handleCheckoutMutation('checkoutLineItemsReplace', this.graphQLClient));
	    }
	
	    /**
	     * Updates line items on an existing checkout.
	     *
	     * @example
	     * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
	     * const lineItems = [
	     *   {
	     *     id: 'TViZGE5Y2U1ZDFhY2FiMmM2YT9rZXk9NTc2YjBhODcwNWIxYzg0YjE5ZjRmZGQ5NjczNGVkZGU=',
	     *     quantity: 5,
	     *     variantId: 'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8yOTEwNjAyMjc5Mg=='
	     *   }
	     * ];
	     *
	     * client.checkout.updateLineItems(checkoutId, lineItems).then(checkout => {
	     *   // Do something with the updated checkout
	     * });
	     *
	     * @param {String} checkoutId The ID of the checkout to update a line item on.
	     * @param {Object[]} lineItems A list of line item information to update. See the {@link https://help.shopify.com/api/storefront-api/reference/input-object/checkoutlineitemupdateinput|Storefront API reference} for valid input fields for each line item.
	     * @return {Promise|GraphModel} A promise resolving with the updated checkout.
	     */
	
	  }, {
	    key: 'updateLineItems',
	    value: function updateLineItems(checkoutId, lineItems) {
	      return this.graphQLClient.send(query$16, { checkoutId: checkoutId, lineItems: lineItems }).then(handleCheckoutMutation('checkoutLineItemsUpdate', this.graphQLClient));
	    }
	
	    /**
	     * Updates shipping address on an existing checkout.
	     *
	     * @example
	     * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
	     * const shippingAddress = {
	     *    address1: 'Chestnut Street 92',
	     *    address2: 'Apartment 2',
	     *    city: 'Louisville',
	     *    company: null,
	     *    country: 'United States',
	     *    firstName: 'Bob',
	     *    lastName: 'Norman',
	     *    phone: '555-625-1199',
	     *    province: 'Kentucky',
	     *    zip: '40202'
	     *  };
	     *
	     * client.checkout.updateShippingAddress(checkoutId, shippingAddress).then(checkout => {
	     *   // Do something with the updated checkout
	     * });
	     *
	     * @param  {String} checkoutId The ID of the checkout to update shipping address.
	     * @param  {Object} shippingAddress A shipping address.
	     * @return {Promise|GraphModel} A promise resolving with the updated checkout.
	     */
	
	  }, {
	    key: 'updateShippingAddress',
	    value: function updateShippingAddress(checkoutId, shippingAddress) {
	      return this.graphQLClient.send(query$23, { checkoutId: checkoutId, shippingAddress: shippingAddress }).then(handleCheckoutMutation('checkoutShippingAddressUpdateV2', this.graphQLClient));
	    }
	  }]);
	  return CheckoutResource;
	}(Resource);
	
	/**
	 * @namespace ImageHelpers
	 */
	var imageHelpers = {
	
	  /**
	   * Generates the image src for a resized image with maximum dimensions `maxWidth` and `maxHeight`.
	   * Images do not scale up.
	   *
	   * @example
	   * const url = client.image.helpers.imageForSize(product.variants[0].image, {maxWidth: 50, maxHeight: 50});
	   *
	   * @memberof ImageHelpers
	   * @method imageForSize
	   * @param {Object} image The original image model to generate the image src for.
	   * @param {Object} options An options object containing:
	   *  @param {Integer} options.maxWidth The maximum width for the image.
	   *  @param {Integer} options.maxHeight The maximum height for the image.
	   * @return {String} The image src for the resized image.
	   */
	  imageForSize: function imageForSize(image, _ref) {
	    var maxWidth = _ref.maxWidth,
	        maxHeight = _ref.maxHeight;
	
	    var splitUrl = image.src.split('?');
	    var notQuery = splitUrl[0];
	    var query = splitUrl[1] ? '?' + splitUrl[1] : '';
	
	    // Use the section before the query
	    var imageTokens = notQuery.split('.');
	
	    // Take the token before the file extension and append the dimensions
	    var imagePathIndex = imageTokens.length - 2;
	
	    imageTokens[imagePathIndex] = imageTokens[imagePathIndex] + '_' + maxWidth + 'x' + maxHeight;
	
	    return '' + imageTokens.join('.') + query;
	  }
	};
	
	/**
	 * The JS Buy SDK image resource
	 * @class
	 */
	
	var ImageResource = function (_Resource) {
	  inherits$1(ImageResource, _Resource);
	
	  function ImageResource() {
	    classCallCheck$1(this, ImageResource);
	    return possibleConstructorReturn$1(this, (ImageResource.__proto__ || Object.getPrototypeOf(ImageResource)).apply(this, arguments));
	  }
	
	  createClass$1(ImageResource, [{
	    key: 'helpers',
	    get: function get$$1() {
	      return imageHelpers;
	    }
	  }]);
	  return ImageResource;
	}(Resource);
	
	var version = "2.8.0";
	
	var Boolean$1 = {
	  "name": "Boolean",
	  "kind": "SCALAR"
	};
	
	var String$1 = {
	  "name": "String",
	  "kind": "SCALAR"
	};
	
	var QueryRoot = {
	  "name": "QueryRoot",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "collectionByHandle": "Collection",
	    "collections": "CollectionConnection",
	    "node": "Node",
	    "nodes": "Node",
	    "productByHandle": "Product",
	    "products": "ProductConnection",
	    "shop": "Shop"
	  },
	  "implementsNode": false
	};
	
	var Node = {
	  "name": "Node",
	  "kind": "INTERFACE",
	  "fieldBaseTypes": {},
	  "possibleTypes": ["AppliedGiftCard", "Article", "Blog", "Checkout", "CheckoutLineItem", "Collection", "Comment", "MailingAddress", "Metafield", "Order", "Page", "Payment", "Product", "ProductOption", "ProductVariant", "ShopPolicy"]
	};
	
	var ID = {
	  "name": "ID",
	  "kind": "SCALAR"
	};
	
	var DateTime = {
	  "name": "DateTime",
	  "kind": "SCALAR"
	};
	
	var MailingAddress = {
	  "name": "MailingAddress",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "address1": "String",
	    "address2": "String",
	    "city": "String",
	    "company": "String",
	    "country": "String",
	    "countryCodeV2": "CountryCode",
	    "firstName": "String",
	    "formatted": "String",
	    "id": "ID",
	    "lastName": "String",
	    "latitude": "Float",
	    "longitude": "Float",
	    "name": "String",
	    "phone": "String",
	    "province": "String",
	    "provinceCode": "String",
	    "zip": "String"
	  },
	  "implementsNode": true
	};
	
	var Float = {
	  "name": "Float",
	  "kind": "SCALAR"
	};
	
	var CountryCode = {
	  "name": "CountryCode",
	  "kind": "ENUM"
	};
	
	var PageInfo = {
	  "name": "PageInfo",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "hasNextPage": "Boolean",
	    "hasPreviousPage": "Boolean"
	  },
	  "implementsNode": false
	};
	
	var Int = {
	  "name": "Int",
	  "kind": "SCALAR"
	};
	
	var Order = {
	  "name": "Order",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "currencyCode": "CurrencyCode",
	    "customerUrl": "URL",
	    "id": "ID",
	    "lineItems": "OrderLineItemConnection",
	    "orderNumber": "Int",
	    "processedAt": "DateTime",
	    "shippingAddress": "MailingAddress",
	    "subtotalPrice": "Money",
	    "subtotalPriceV2": "MoneyV2",
	    "totalPrice": "Money",
	    "totalPriceV2": "MoneyV2",
	    "totalRefunded": "Money",
	    "totalRefundedV2": "MoneyV2",
	    "totalShippingPrice": "Money",
	    "totalShippingPriceV2": "MoneyV2",
	    "totalTax": "Money",
	    "totalTaxV2": "MoneyV2"
	  },
	  "implementsNode": true
	};
	
	var Money = {
	  "name": "Money",
	  "kind": "SCALAR"
	};
	
	var MoneyV2 = {
	  "name": "MoneyV2",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "amount": "Decimal",
	    "currencyCode": "CurrencyCode"
	  },
	  "implementsNode": false
	};
	
	var Decimal = {
	  "name": "Decimal",
	  "kind": "SCALAR"
	};
	
	var CurrencyCode = {
	  "name": "CurrencyCode",
	  "kind": "ENUM"
	};
	
	var URL = {
	  "name": "URL",
	  "kind": "SCALAR"
	};
	
	var DiscountAllocation = {
	  "name": "DiscountAllocation",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "allocatedAmount": "MoneyV2",
	    "discountApplication": "DiscountApplication"
	  },
	  "implementsNode": false
	};
	
	var DiscountApplication = {
	  "name": "DiscountApplication",
	  "kind": "INTERFACE",
	  "fieldBaseTypes": {
	    "allocationMethod": "DiscountApplicationAllocationMethod",
	    "targetSelection": "DiscountApplicationTargetSelection",
	    "targetType": "DiscountApplicationTargetType",
	    "value": "PricingValue"
	  },
	  "possibleTypes": ["AutomaticDiscountApplication", "DiscountCodeApplication", "ManualDiscountApplication", "ScriptDiscountApplication"]
	};
	
	var DiscountApplicationAllocationMethod = {
	  "name": "DiscountApplicationAllocationMethod",
	  "kind": "ENUM"
	};
	
	var DiscountApplicationTargetSelection = {
	  "name": "DiscountApplicationTargetSelection",
	  "kind": "ENUM"
	};
	
	var DiscountApplicationTargetType = {
	  "name": "DiscountApplicationTargetType",
	  "kind": "ENUM"
	};
	
	var PricingValue = {
	  "name": "PricingValue",
	  "kind": "UNION"
	};
	
	var PricingPercentageValue = {
	  "name": "PricingPercentageValue",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "percentage": "Float"
	  },
	  "implementsNode": false
	};
	
	var OrderLineItemConnection = {
	  "name": "OrderLineItemConnection",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "edges": "OrderLineItemEdge",
	    "pageInfo": "PageInfo"
	  },
	  "implementsNode": false
	};
	
	var OrderLineItemEdge = {
	  "name": "OrderLineItemEdge",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "cursor": "String",
	    "node": "OrderLineItem"
	  },
	  "implementsNode": false
	};
	
	var OrderLineItem = {
	  "name": "OrderLineItem",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "customAttributes": "Attribute",
	    "quantity": "Int",
	    "title": "String",
	    "variant": "ProductVariant"
	  },
	  "implementsNode": false
	};
	
	var ProductVariant = {
	  "name": "ProductVariant",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "availableForSale": "Boolean",
	    "compareAtPrice": "Money",
	    "compareAtPriceV2": "MoneyV2",
	    "id": "ID",
	    "image": "Image",
	    "presentmentPrices": "ProductVariantPricePairConnection",
	    "price": "Money",
	    "priceV2": "MoneyV2",
	    "product": "Product",
	    "selectedOptions": "SelectedOption",
	    "sku": "String",
	    "title": "String",
	    "weight": "Float"
	  },
	  "implementsNode": true
	};
	
	var Product = {
	  "name": "Product",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "availableForSale": "Boolean",
	    "createdAt": "DateTime",
	    "description": "String",
	    "descriptionHtml": "HTML",
	    "handle": "String",
	    "id": "ID",
	    "images": "ImageConnection",
	    "onlineStoreUrl": "URL",
	    "options": "ProductOption",
	    "productType": "String",
	    "publishedAt": "DateTime",
	    "title": "String",
	    "updatedAt": "DateTime",
	    "variants": "ProductVariantConnection",
	    "vendor": "String"
	  },
	  "implementsNode": true
	};
	
	var CollectionConnection = {
	  "name": "CollectionConnection",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "edges": "CollectionEdge",
	    "pageInfo": "PageInfo"
	  },
	  "implementsNode": false
	};
	
	var CollectionEdge = {
	  "name": "CollectionEdge",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "cursor": "String",
	    "node": "Collection"
	  },
	  "implementsNode": false
	};
	
	var Collection = {
	  "name": "Collection",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "description": "String",
	    "descriptionHtml": "HTML",
	    "handle": "String",
	    "id": "ID",
	    "image": "Image",
	    "products": "ProductConnection",
	    "title": "String",
	    "updatedAt": "DateTime"
	  },
	  "implementsNode": true
	};
	
	var HTML = {
	  "name": "HTML",
	  "kind": "SCALAR"
	};
	
	var Image = {
	  "name": "Image",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "altText": "String",
	    "id": "ID",
	    "originalSrc": "URL",
	    "src": "URL"
	  },
	  "implementsNode": false
	};
	
	var ProductConnection = {
	  "name": "ProductConnection",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "edges": "ProductEdge",
	    "pageInfo": "PageInfo"
	  },
	  "implementsNode": false
	};
	
	var ProductEdge = {
	  "name": "ProductEdge",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "cursor": "String",
	    "node": "Product"
	  },
	  "implementsNode": false
	};
	
	var ImageConnection = {
	  "name": "ImageConnection",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "edges": "ImageEdge",
	    "pageInfo": "PageInfo"
	  },
	  "implementsNode": false
	};
	
	var ImageEdge = {
	  "name": "ImageEdge",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "cursor": "String",
	    "node": "Image"
	  },
	  "implementsNode": false
	};
	
	var ProductOption = {
	  "name": "ProductOption",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "name": "String",
	    "values": "String"
	  },
	  "implementsNode": true
	};
	
	var ProductVariantConnection = {
	  "name": "ProductVariantConnection",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "edges": "ProductVariantEdge",
	    "pageInfo": "PageInfo"
	  },
	  "implementsNode": false
	};
	
	var ProductVariantEdge = {
	  "name": "ProductVariantEdge",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "cursor": "String",
	    "node": "ProductVariant"
	  },
	  "implementsNode": false
	};
	
	var ProductVariantPricePairConnection = {
	  "name": "ProductVariantPricePairConnection",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "edges": "ProductVariantPricePairEdge",
	    "pageInfo": "PageInfo"
	  },
	  "implementsNode": false
	};
	
	var ProductVariantPricePairEdge = {
	  "name": "ProductVariantPricePairEdge",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "node": "ProductVariantPricePair"
	  },
	  "implementsNode": false
	};
	
	var ProductVariantPricePair = {
	  "name": "ProductVariantPricePair",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "price": "MoneyV2"
	  },
	  "implementsNode": false
	};
	
	var SelectedOption = {
	  "name": "SelectedOption",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "name": "String",
	    "value": "String"
	  },
	  "implementsNode": false
	};
	
	var Attribute = {
	  "name": "Attribute",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "key": "String",
	    "value": "String"
	  },
	  "implementsNode": false
	};
	
	var DiscountApplicationConnection = {
	  "name": "DiscountApplicationConnection",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "edges": "DiscountApplicationEdge",
	    "pageInfo": "PageInfo"
	  },
	  "implementsNode": false
	};
	
	var DiscountApplicationEdge = {
	  "name": "DiscountApplicationEdge",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "node": "DiscountApplication"
	  },
	  "implementsNode": false
	};
	
	var Checkout = {
	  "name": "Checkout",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "appliedGiftCards": "AppliedGiftCard",
	    "completedAt": "DateTime",
	    "createdAt": "DateTime",
	    "currencyCode": "CurrencyCode",
	    "customAttributes": "Attribute",
	    "discountApplications": "DiscountApplicationConnection",
	    "email": "String",
	    "id": "ID",
	    "lineItems": "CheckoutLineItemConnection",
	    "lineItemsSubtotalPrice": "MoneyV2",
	    "note": "String",
	    "order": "Order",
	    "orderStatusUrl": "URL",
	    "paymentDue": "Money",
	    "paymentDueV2": "MoneyV2",
	    "ready": "Boolean",
	    "requiresShipping": "Boolean",
	    "shippingAddress": "MailingAddress",
	    "shippingLine": "ShippingRate",
	    "subtotalPrice": "Money",
	    "subtotalPriceV2": "MoneyV2",
	    "taxExempt": "Boolean",
	    "taxesIncluded": "Boolean",
	    "totalPrice": "Money",
	    "totalPriceV2": "MoneyV2",
	    "totalTax": "Money",
	    "totalTaxV2": "MoneyV2",
	    "updatedAt": "DateTime",
	    "webUrl": "URL"
	  },
	  "implementsNode": true
	};
	
	var CheckoutLineItemConnection = {
	  "name": "CheckoutLineItemConnection",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "edges": "CheckoutLineItemEdge",
	    "pageInfo": "PageInfo"
	  },
	  "implementsNode": false
	};
	
	var CheckoutLineItemEdge = {
	  "name": "CheckoutLineItemEdge",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "cursor": "String",
	    "node": "CheckoutLineItem"
	  },
	  "implementsNode": false
	};
	
	var CheckoutLineItem = {
	  "name": "CheckoutLineItem",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "customAttributes": "Attribute",
	    "discountAllocations": "DiscountAllocation",
	    "id": "ID",
	    "quantity": "Int",
	    "title": "String",
	    "variant": "ProductVariant"
	  },
	  "implementsNode": true
	};
	
	var ShippingRate = {
	  "name": "ShippingRate",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "handle": "String",
	    "price": "Money",
	    "title": "String"
	  },
	  "implementsNode": false
	};
	
	var AppliedGiftCard = {
	  "name": "AppliedGiftCard",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "amountUsedV2": "MoneyV2",
	    "balanceV2": "MoneyV2",
	    "id": "ID",
	    "lastCharacters": "String",
	    "presentmentAmountUsed": "MoneyV2"
	  },
	  "implementsNode": true
	};
	
	var Shop = {
	  "name": "Shop",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "currencyCode": "CurrencyCode",
	    "description": "String",
	    "moneyFormat": "String",
	    "name": "String",
	    "paymentSettings": "PaymentSettings",
	    "primaryDomain": "Domain",
	    "privacyPolicy": "ShopPolicy",
	    "refundPolicy": "ShopPolicy",
	    "termsOfService": "ShopPolicy"
	  },
	  "implementsNode": false
	};
	
	var PaymentSettings = {
	  "name": "PaymentSettings",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "enabledPresentmentCurrencies": "CurrencyCode"
	  },
	  "implementsNode": false
	};
	
	var Domain = {
	  "name": "Domain",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "host": "String",
	    "sslEnabled": "Boolean",
	    "url": "URL"
	  },
	  "implementsNode": false
	};
	
	var ShopPolicy = {
	  "name": "ShopPolicy",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "body": "String",
	    "id": "ID",
	    "title": "String",
	    "url": "URL"
	  },
	  "implementsNode": true
	};
	
	var Mutation$1 = {
	  "name": "Mutation",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "checkoutAttributesUpdateV2": "CheckoutAttributesUpdateV2Payload",
	    "checkoutCreate": "CheckoutCreatePayload",
	    "checkoutDiscountCodeApplyV2": "CheckoutDiscountCodeApplyV2Payload",
	    "checkoutDiscountCodeRemove": "CheckoutDiscountCodeRemovePayload",
	    "checkoutEmailUpdateV2": "CheckoutEmailUpdateV2Payload",
	    "checkoutGiftCardRemoveV2": "CheckoutGiftCardRemoveV2Payload",
	    "checkoutGiftCardsAppend": "CheckoutGiftCardsAppendPayload",
	    "checkoutLineItemsAdd": "CheckoutLineItemsAddPayload",
	    "checkoutLineItemsRemove": "CheckoutLineItemsRemovePayload",
	    "checkoutLineItemsReplace": "CheckoutLineItemsReplacePayload",
	    "checkoutLineItemsUpdate": "CheckoutLineItemsUpdatePayload",
	    "checkoutShippingAddressUpdateV2": "CheckoutShippingAddressUpdateV2Payload"
	  },
	  "implementsNode": false,
	  "relayInputObjectBaseTypes": {
	    "checkoutAttributesUpdate": "CheckoutAttributesUpdateInput",
	    "checkoutAttributesUpdateV2": "CheckoutAttributesUpdateV2Input",
	    "checkoutCreate": "CheckoutCreateInput",
	    "customerAccessTokenCreate": "CustomerAccessTokenCreateInput",
	    "customerActivate": "CustomerActivateInput",
	    "customerCreate": "CustomerCreateInput",
	    "customerReset": "CustomerResetInput"
	  }
	};
	
	var UserError = {
	  "name": "UserError",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "field": "String",
	    "message": "String"
	  },
	  "implementsNode": false
	};
	
	var CheckoutUserError = {
	  "name": "CheckoutUserError",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "code": "CheckoutErrorCode",
	    "field": "String",
	    "message": "String"
	  },
	  "implementsNode": false
	};
	
	var CheckoutErrorCode = {
	  "name": "CheckoutErrorCode",
	  "kind": "ENUM"
	};
	
	var CheckoutAttributesUpdateV2Payload = {
	  "name": "CheckoutAttributesUpdateV2Payload",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "checkout": "Checkout",
	    "checkoutUserErrors": "CheckoutUserError",
	    "userErrors": "UserError"
	  },
	  "implementsNode": false
	};
	
	var CheckoutDiscountCodeApplyV2Payload = {
	  "name": "CheckoutDiscountCodeApplyV2Payload",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "checkout": "Checkout",
	    "checkoutUserErrors": "CheckoutUserError",
	    "userErrors": "UserError"
	  },
	  "implementsNode": false
	};
	
	var CheckoutCreatePayload = {
	  "name": "CheckoutCreatePayload",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "checkout": "Checkout",
	    "checkoutUserErrors": "CheckoutUserError",
	    "userErrors": "UserError"
	  },
	  "implementsNode": false
	};
	
	var CheckoutEmailUpdateV2Payload = {
	  "name": "CheckoutEmailUpdateV2Payload",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "checkout": "Checkout",
	    "checkoutUserErrors": "CheckoutUserError",
	    "userErrors": "UserError"
	  },
	  "implementsNode": false
	};
	
	var CheckoutDiscountCodeRemovePayload = {
	  "name": "CheckoutDiscountCodeRemovePayload",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "checkout": "Checkout",
	    "checkoutUserErrors": "CheckoutUserError",
	    "userErrors": "UserError"
	  },
	  "implementsNode": false
	};
	
	var CheckoutGiftCardsAppendPayload = {
	  "name": "CheckoutGiftCardsAppendPayload",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "checkout": "Checkout",
	    "checkoutUserErrors": "CheckoutUserError",
	    "userErrors": "UserError"
	  },
	  "implementsNode": false
	};
	
	var CheckoutGiftCardRemoveV2Payload = {
	  "name": "CheckoutGiftCardRemoveV2Payload",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "checkout": "Checkout",
	    "checkoutUserErrors": "CheckoutUserError",
	    "userErrors": "UserError"
	  },
	  "implementsNode": false
	};
	
	var CheckoutLineItemsAddPayload = {
	  "name": "CheckoutLineItemsAddPayload",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "checkout": "Checkout",
	    "checkoutUserErrors": "CheckoutUserError",
	    "userErrors": "UserError"
	  },
	  "implementsNode": false
	};
	
	var CheckoutLineItemsRemovePayload = {
	  "name": "CheckoutLineItemsRemovePayload",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "checkout": "Checkout",
	    "checkoutUserErrors": "CheckoutUserError",
	    "userErrors": "UserError"
	  },
	  "implementsNode": false
	};
	
	var CheckoutLineItemsUpdatePayload = {
	  "name": "CheckoutLineItemsUpdatePayload",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "checkout": "Checkout",
	    "checkoutUserErrors": "CheckoutUserError",
	    "userErrors": "UserError"
	  },
	  "implementsNode": false
	};
	
	var CheckoutLineItemsReplacePayload = {
	  "name": "CheckoutLineItemsReplacePayload",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "checkout": "Checkout",
	    "userErrors": "CheckoutUserError"
	  },
	  "implementsNode": false
	};
	
	var CheckoutShippingAddressUpdateV2Payload = {
	  "name": "CheckoutShippingAddressUpdateV2Payload",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "checkout": "Checkout",
	    "checkoutUserErrors": "CheckoutUserError",
	    "userErrors": "UserError"
	  },
	  "implementsNode": false
	};
	
	var DiscountCodeApplication = {
	  "name": "DiscountCodeApplication",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "applicable": "Boolean",
	    "code": "String"
	  },
	  "implementsNode": false
	};
	
	var ManualDiscountApplication = {
	  "name": "ManualDiscountApplication",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "description": "String",
	    "title": "String"
	  },
	  "implementsNode": false
	};
	
	var ScriptDiscountApplication = {
	  "name": "ScriptDiscountApplication",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "description": "String"
	  },
	  "implementsNode": false
	};
	
	var AutomaticDiscountApplication = {
	  "name": "AutomaticDiscountApplication",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "title": "String"
	  },
	  "implementsNode": false
	};
	
	var Types = {
	  types: {}
	};
	Types.types["Boolean"] = Boolean$1;
	Types.types["String"] = String$1;
	Types.types["QueryRoot"] = QueryRoot;
	Types.types["Node"] = Node;
	Types.types["ID"] = ID;
	Types.types["DateTime"] = DateTime;
	Types.types["MailingAddress"] = MailingAddress;
	Types.types["Float"] = Float;
	Types.types["CountryCode"] = CountryCode;
	Types.types["PageInfo"] = PageInfo;
	Types.types["Int"] = Int;
	Types.types["Order"] = Order;
	Types.types["Money"] = Money;
	Types.types["MoneyV2"] = MoneyV2;
	Types.types["Decimal"] = Decimal;
	Types.types["CurrencyCode"] = CurrencyCode;
	Types.types["URL"] = URL;
	Types.types["DiscountAllocation"] = DiscountAllocation;
	Types.types["DiscountApplication"] = DiscountApplication;
	Types.types["DiscountApplicationAllocationMethod"] = DiscountApplicationAllocationMethod;
	Types.types["DiscountApplicationTargetSelection"] = DiscountApplicationTargetSelection;
	Types.types["DiscountApplicationTargetType"] = DiscountApplicationTargetType;
	Types.types["PricingValue"] = PricingValue;
	Types.types["PricingPercentageValue"] = PricingPercentageValue;
	Types.types["OrderLineItemConnection"] = OrderLineItemConnection;
	Types.types["OrderLineItemEdge"] = OrderLineItemEdge;
	Types.types["OrderLineItem"] = OrderLineItem;
	Types.types["ProductVariant"] = ProductVariant;
	Types.types["Product"] = Product;
	Types.types["CollectionConnection"] = CollectionConnection;
	Types.types["CollectionEdge"] = CollectionEdge;
	Types.types["Collection"] = Collection;
	Types.types["HTML"] = HTML;
	Types.types["Image"] = Image;
	Types.types["ProductConnection"] = ProductConnection;
	Types.types["ProductEdge"] = ProductEdge;
	Types.types["ImageConnection"] = ImageConnection;
	Types.types["ImageEdge"] = ImageEdge;
	Types.types["ProductOption"] = ProductOption;
	Types.types["ProductVariantConnection"] = ProductVariantConnection;
	Types.types["ProductVariantEdge"] = ProductVariantEdge;
	Types.types["ProductVariantPricePairConnection"] = ProductVariantPricePairConnection;
	Types.types["ProductVariantPricePairEdge"] = ProductVariantPricePairEdge;
	Types.types["ProductVariantPricePair"] = ProductVariantPricePair;
	Types.types["SelectedOption"] = SelectedOption;
	Types.types["Attribute"] = Attribute;
	Types.types["DiscountApplicationConnection"] = DiscountApplicationConnection;
	Types.types["DiscountApplicationEdge"] = DiscountApplicationEdge;
	Types.types["Checkout"] = Checkout;
	Types.types["CheckoutLineItemConnection"] = CheckoutLineItemConnection;
	Types.types["CheckoutLineItemEdge"] = CheckoutLineItemEdge;
	Types.types["CheckoutLineItem"] = CheckoutLineItem;
	Types.types["ShippingRate"] = ShippingRate;
	Types.types["AppliedGiftCard"] = AppliedGiftCard;
	Types.types["Shop"] = Shop;
	Types.types["PaymentSettings"] = PaymentSettings;
	Types.types["Domain"] = Domain;
	Types.types["ShopPolicy"] = ShopPolicy;
	Types.types["Mutation"] = Mutation$1;
	Types.types["UserError"] = UserError;
	Types.types["CheckoutUserError"] = CheckoutUserError;
	Types.types["CheckoutErrorCode"] = CheckoutErrorCode;
	Types.types["CheckoutAttributesUpdateV2Payload"] = CheckoutAttributesUpdateV2Payload;
	Types.types["CheckoutDiscountCodeApplyV2Payload"] = CheckoutDiscountCodeApplyV2Payload;
	Types.types["CheckoutCreatePayload"] = CheckoutCreatePayload;
	Types.types["CheckoutEmailUpdateV2Payload"] = CheckoutEmailUpdateV2Payload;
	Types.types["CheckoutDiscountCodeRemovePayload"] = CheckoutDiscountCodeRemovePayload;
	Types.types["CheckoutGiftCardsAppendPayload"] = CheckoutGiftCardsAppendPayload;
	Types.types["CheckoutGiftCardRemoveV2Payload"] = CheckoutGiftCardRemoveV2Payload;
	Types.types["CheckoutLineItemsAddPayload"] = CheckoutLineItemsAddPayload;
	Types.types["CheckoutLineItemsRemovePayload"] = CheckoutLineItemsRemovePayload;
	Types.types["CheckoutLineItemsUpdatePayload"] = CheckoutLineItemsUpdatePayload;
	Types.types["CheckoutLineItemsReplacePayload"] = CheckoutLineItemsReplacePayload;
	Types.types["CheckoutShippingAddressUpdateV2Payload"] = CheckoutShippingAddressUpdateV2Payload;
	Types.types["DiscountCodeApplication"] = DiscountCodeApplication;
	Types.types["ManualDiscountApplication"] = ManualDiscountApplication;
	Types.types["ScriptDiscountApplication"] = ScriptDiscountApplication;
	Types.types["AutomaticDiscountApplication"] = AutomaticDiscountApplication;
	Types.queryType = "QueryRoot";
	Types.mutationType = "Mutation";
	Types.subscriptionType = null;
	
	function recursivelyFreezeObject(structure) {
	  Object.getOwnPropertyNames(structure).forEach(function (key) {
	    var value = structure[key];
	    if (value && (typeof value === "undefined" ? "undefined" : _typeof(value)) === 'object') {
	      recursivelyFreezeObject(value);
	    }
	  });
	  Object.freeze(structure);
	  return structure;
	}
	
	var types = recursivelyFreezeObject(Types);
	
	// GraphQL
	/**
	 * The JS Buy SDK Client.
	 * @class
	 *
	 * @property {ProductResource} product The property under which product fetching methods live.
	 * @property {CollectionResource} collection The property under which collection fetching methods live.
	 * @property {ShopResource} shop The property under which shop fetching methods live.
	 * @property {CheckoutResource} checkout The property under which shop fetching and mutating methods live.
	 * @property {ImageResource} image The property under which image helper methods live.
	 */
	
	var Client = function () {
	  createClass$1(Client, null, [{
	    key: 'buildClient',
	
	
	    /**
	     * Primary entry point for building a new Client.
	     */
	    value: function buildClient(config, fetchFunction) {
	      var newConfig = new Config(config);
	      var client = new Client(newConfig, Client$2, fetchFunction);
	
	      client.config = newConfig;
	
	      return client;
	    }
	
	    /**
	     * @constructs Client
	     * @param {Config} config An instance of {@link Config} used to configure the Client.
	     */
	
	  }]);
	
	  function Client(config) {
	    var GraphQLClientClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Client$2;
	    var fetchFunction = arguments[2];
	    classCallCheck$1(this, Client);
	
	    var url = 'https://' + config.domain + '/api/' + config.apiVersion + '/graphql';
	
	    var headers = {
	      'X-SDK-Variant': 'javascript',
	      'X-SDK-Version': version,
	      'X-Shopify-Storefront-Access-Token': config.storefrontAccessToken
	    };
	
	    if (config.source) {
	      headers['X-SDK-Variant-Source'] = config.source;
	    }
	
	    if (fetchFunction) {
	      headers['Content-Type'] = 'application/json';
	      headers.Accept = 'application/json';
	
	      this.graphQLClient = new GraphQLClientClass(types, {
	        fetcher: function fetcher(graphQLParams) {
	          return fetchFunction(url, {
	            body: JSON.stringify(graphQLParams),
	            method: 'POST',
	            mode: 'cors',
	            headers: headers
	          }).then(function (response) {
	            return response.json();
	          });
	        }
	      });
	    } else {
	      this.graphQLClient = new GraphQLClientClass(types, {
	        url: url,
	        fetcherOptions: { headers: headers }
	      });
	    }
	
	    this.product = new ProductResource(this.graphQLClient);
	    this.collection = new CollectionResource(this.graphQLClient);
	    this.shop = new ShopResource(this.graphQLClient);
	    this.checkout = new CheckoutResource(this.graphQLClient);
	    this.image = new ImageResource(this.graphQLClient);
	  }
	
	  /**
	   * Fetches the next page of models
	   *
	   * @example
	   * client.fetchNextPage(products).then((nextProducts) => {
	   *   // Do something with the products
	   * });
	   *
	   * @param {models} [Array] The paginated set to fetch the next page of
	   * @return {Promise|GraphModel[]} A promise resolving with an array of `GraphModel`s of the type provided.
	   */
	
	
	  createClass$1(Client, [{
	    key: 'fetchNextPage',
	    value: function fetchNextPage(models) {
	      return this.graphQLClient.fetchNextPage(models);
	    }
	  }]);
	  return Client;
	}();
	
	module.exports = Client;
	//# sourceMappingURL=index.js.map


/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductBadges = function (_React$Component) {
	  _inherits(ProductBadges, _React$Component);
	
	  function ProductBadges(props) {
	    _classCallCheck(this, ProductBadges);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  ProductBadges.prototype.render = function render() {
	    var data = this.props.data;
	
	    return _react2.default.createElement(
	      "div",
	      { className: "Badges" },
	      _react2.default.createElement(
	        "h2",
	        null,
	        "Yoga Flow is"
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "product-badges" },
	        _react2.default.createElement(
	          "div",
	          { className: "item" },
	          _react2.default.createElement(
	            "div",
	            { className: "shape" },
	            _react2.default.createElement(
	              "div",
	              { className: "vertplacer" },
	              _react2.default.createElement(
	                "p",
	                null,
	                "DAIRY",
	                _react2.default.createElement("br", null),
	                "FREE"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "item" },
	          _react2.default.createElement(
	            "div",
	            { className: "shape" },
	            _react2.default.createElement(
	              "div",
	              { className: "vertplacer" },
	              _react2.default.createElement(
	                "p",
	                null,
	                "GLUTEN",
	                _react2.default.createElement("br", null),
	                "FREE"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "item" },
	          _react2.default.createElement(
	            "div",
	            { className: "shape" },
	            _react2.default.createElement(
	              "div",
	              { className: "vertplacer" },
	              _react2.default.createElement(
	                "p",
	                null,
	                "VEGAN",
	                _react2.default.createElement("br", null),
	                "FRIENDLY"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "item" },
	          _react2.default.createElement(
	            "div",
	            { className: "shape" },
	            _react2.default.createElement(
	              "div",
	              { className: "vertplacer" },
	              _react2.default.createElement(
	                "p",
	                null,
	                "1G ",
	                _react2.default.createElement("br", null),
	                "SUGAR"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "item" },
	          _react2.default.createElement(
	            "div",
	            { className: "shape" },
	            _react2.default.createElement(
	              "div",
	              { className: "vertplacer" },
	              _react2.default.createElement(
	                "p",
	                null,
	                "MADE IN",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "THE USA"
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return ProductBadges;
	}(_react2.default.Component);
	
	exports.default = ProductBadges;
	module.exports = exports["default"];

/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import ClassNames from 'classnames'
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header(props) {
	    _classCallCheck(this, Header);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Header.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "Header" },
	      _react2.default.createElement(
	        "h1",
	        null,
	        "Clear Your Mind and Supercharge Your Yoga Session with Yoga Flow"
	      )
	    );
	  };
	
	  return Header;
	}(_react2.default.Component);
	
	exports.default = Header;
	module.exports = exports["default"];

/***/ }),

/***/ 329:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HighlightedReviews = function (_React$Component) {
	  _inherits(HighlightedReviews, _React$Component);
	
	  function HighlightedReviews(props) {
	    _classCallCheck(this, HighlightedReviews);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  HighlightedReviews.prototype.render = function render() {
	    var data = this.props.data;
	
	    return _react2.default.createElement(
	      "div",
	      { className: "HighlightedReviews" },
	      _react2.default.createElement(
	        "div",
	        { className: "expertreviews" },
	        _react2.default.createElement(
	          "h2",
	          null,
	          "Word on the Street"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "item" },
	          _react2.default.createElement(
	            "div",
	            { className: "photo" },
	            _react2.default.createElement("img", { src: "https://www.datocms-assets.com/6493/1562011536-dani-drasin-profile-picture.jpg?w=140", alt: "Dani Drasin" })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "content" },
	            _react2.default.createElement(
	              "p",
	              null,
	              "\"Would recommend to anyone who goes to yoga after work. I\u2019m a teacher so I don\u2019t have time to go to yoga in the morning (wake up at 4am? no thank you!!). So my only option is after work when all I want to do is lay down. That\u2019s why I bought Yoga Flow. It\u2019s a fantastic little pick me up that doesn\u2019t leave you thirsty or mess with your stomach like coffee or espresso. You can get right into class because you\u2019re more awake and less sluggish.\" ",
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Dani Drasin",
	                _react2.default.createElement(
	                  "em",
	                  null,
	                  "@danidrasin"
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "item" },
	          _react2.default.createElement(
	            "div",
	            { className: "photo" },
	            _react2.default.createElement("img", { src: "https://www.datocms-assets.com/6493/1562011533-linnea-jamtin-profile-picture.jpg?w=140", alt: "Linnea Jamtin" })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "content" },
	            _react2.default.createElement(
	              "p",
	              null,
	              "\"I didn\u2019t get what the big deal was about electrolytes and things like ayurvedic herbs until I tried Yoga Flow. This stuff really works! I used to get that dehydrated, kind of nauseous, dizzy feeling during my evening class but not anymore! Great buy\" ",
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Linnea Jamtin",
	                _react2.default.createElement(
	                  "em",
	                  null,
	                  "@linnea.jamtin"
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "item" },
	          _react2.default.createElement(
	            "div",
	            { className: "photo" },
	            _react2.default.createElement("img", { src: "https://www.datocms-assets.com/6493/1562011538-kyle-armour-profile-picture.jpg?w=140", alt: "Kyle Armour" })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "content" },
	            _react2.default.createElement(
	              "p",
	              null,
	              "\"I\u2019m trying to be more committed to yoga (at least 3x a week) so I thought, what could help me on my mission? I asked two people from my class and they told me about Yoga Flow. Not gonna lie, I LOVE it. For me, it\u2019s mostly bc of the cardamom and turmeric. Your body becomes lighter, more flexible and just more awake. If you want to stick to a yoga routine, this is for you.\"",
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Kyle Armour",
	                _react2.default.createElement(
	                  "em",
	                  null,
	                  "@kwarmour"
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "item" },
	          _react2.default.createElement(
	            "div",
	            { className: "photo" },
	            _react2.default.createElement("img", { src: "https://www.datocms-assets.com/6493/1562011535-brooke-welty-profile-picture.jpg?w=140", alt: "Brooke Welty" })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "content" },
	            _react2.default.createElement(
	              "p",
	              null,
	              "\"I started using Yoga Flow because I\u2019m not one of those people who can just go to yoga at any time. But Yoga Flow wakes me up, tastes great and keeps me hydrated so I don\u2019t lose steam. Now I\u2019m obsessed! Would definitely recommend for anyone who finds getting to yoga class to be a struggle.\"",
	              _react2.default.createElement(
	                "strong",
	                null,
	                "Brooke Welty",
	                _react2.default.createElement(
	                  "em",
	                  null,
	                  "@brooke.welty.9"
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return HighlightedReviews;
	}(_react2.default.Component);
	
	exports.default = HighlightedReviews;
	module.exports = exports["default"];

/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _renderHtml = __webpack_require__(24);
	
	var _renderHtml2 = _interopRequireDefault(_renderHtml);
	
	var _modal = __webpack_require__(153);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _bus = __webpack_require__(9);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BUS = new _bus2.default();
	
	var Intro = function (_React$Component) {
	  _inherits(Intro, _React$Component);
	
	  function Intro(props) {
	    _classCallCheck(this, Intro);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Intro.prototype.render = function render() {
	    var ingredients = this.props.ingredients;
	    return _react2.default.createElement(
	      "div",
	      { className: "BuyIngredients2-outer" },
	      _react2.default.createElement(
	        "div",
	        { className: "BuyIngredients2" },
	        _react2.default.createElement(
	          "h2",
	          { id: "Ingredients" },
	          "Ingredients that Make the Difference in Your Yoga Session"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "items" },
	          ingredients.map(function (_ref, i) {
	            var node = _ref.node;
	
	            return _react2.default.createElement(
	              "div",
	              { id: node.name.replace(/\W+/g, '-').toLowerCase(), className: "item", key: i },
	              _react2.default.createElement(
	                "div",
	                { className: "info" },
	                _react2.default.createElement("img", { src: node.image.fluid.src }),
	                _react2.default.createElement(
	                  "h3",
	                  null,
	                  node.name
	                ),
	                _react2.default.createElement(
	                  "h4",
	                  null,
	                  node.subName
	                ),
	                _react2.default.createElement("div", {
	                  className: "description",
	                  dangerouslySetInnerHTML: _renderHtml2.default.go(node.shortDescription)
	                }),
	                _react2.default.createElement(
	                  "span",
	                  { onClick: function onClick() {
	                      BUS.trigger("OPEN_INGREDIENTMODAL", {
	                        content: node.descriptionExtended
	                      });
	                    } },
	                  "LEARN MORE"
	                )
	              )
	            );
	          })
	        )
	      ),
	      _react2.default.createElement(_modal2.default, null)
	    );
	  };
	
	  return Intro;
	}(_react2.default.Component);
	
	exports.default = Intro;
	module.exports = exports["default"];

/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _gatsbyPluginSmoothscroll = __webpack_require__(139);
	
	var _gatsbyPluginSmoothscroll2 = _interopRequireDefault(_gatsbyPluginSmoothscroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Intro = function (_React$Component) {
	  _inherits(Intro, _React$Component);
	
	  function Intro(props) {
	    _classCallCheck(this, Intro);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Intro.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'Buy-Intro' },
	      _react2.default.createElement(
	        'div',
	        { className: 'internal' },
	        _react2.default.createElement(
	          'p',
	          null,
	          'It\u2019s the only tablet that transforms water into a fitness drink that warms up your body and mind for yoga. So you have a more relaxing and invigorating practice.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Yoga Flow will give you:'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'more stamina - do more poses, even the tough ones'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'better focus - leave yoga feeling fully recharged'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'less joint stiffness and more flexibility - go deeper into poses without needing extra practice time'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'full hydration - feel restored and refreshed after sweaty and powerful sessions'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'It removes the obstacles that keep you from getting full value out of every session.',
	          _react2.default.createElement('br', null),
	          ' (We dedicate it to Patanjali \uD83E\uDDD8\uD83C\uDFFD)'
	        ),
	        _react2.default.createElement(
	          'a',
	          { onClick: function onClick() {
	              return (0, _gatsbyPluginSmoothscroll2.default)('#BuyNow');
	            }, className: 'Btn orange-white' },
	          this.props.callToAction
	        )
	      )
	    );
	  };
	
	  return Intro;
	}(_react2.default.Component);
	
	exports.default = Intro;
	module.exports = exports['default'];

/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LessStress = function (_React$Component) {
	  _inherits(LessStress, _React$Component);
	
	  function LessStress(props) {
	    _classCallCheck(this, LessStress);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  LessStress.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "LessStress" },
	      _react2.default.createElement(
	        "h2",
	        null,
	        "You\u2019re 16 Ounces Away From Less Stress"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "You can continue to follow the teachers who preach \u201Cpractice longer to feel better.\u201D In the process, you\u2019ll try giving up other workouts like biking, hiking, running or weights."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "You\u2019ll hope that\u2019ll give you the extra time and energy to do more poses, feel calmer or have less pain. But you\u2019ll probably resent missing out on things you love."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Or you\u2019ll cut out social events with friends and family for more practice time. They\u2019ll feel sad that you\u2019re not around and you\u2019ll feel guilty for blowing them off."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Because adding more practice time to a busy life isn\u2019t sustainable, you\u2019ll give up more often than you\u2019ll want to admit. You\u2019ll continue to be stressed by juggling way too many balls daily."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Life\u2019s too short to live it like this..."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "...when a drink is all it takes to have more effective yoga sessions and keep the yoga buzz lingering longer."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "With Yoga Flow, you\u2019ll begin yoga in a mindset most people only feel at the end of their session. Calm, present, and psyched to get on your mat."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "You\u2019ll focus better and be more in tune with your body and mind. You\u2019ll feel yoga\u2019s sweet benefits\u2013like suppleness and happiness\u2013hours after the bell brings you out of savasana."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "You\u2019ll feel less guilty about eating-on-the-run because your body will get wholesome Ayurvedic supplements. Without the hassle of taking extra tablets or mixing up powders."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "You\u2019ll nourish your skin, cells and digestion by drinking extra water (that\u2019s not bland and boring)."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "You\u2019ll feel proud of treating your ONE and only body to a daily dose of wellness."
	      )
	    );
	  };
	
	  return LessStress;
	}(_react2.default.Component);
	
	exports.default = LessStress;
	module.exports = exports["default"];

/***/ }),

/***/ 216:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = {
	  ONE_TIME: "PURCHASE_OPTIONS.ONE_TIME",
	  SUBSCRIPTION: "PURCHASE_OPTIONS.SUBSCRIPTION"
	};
	module.exports = exports["default"];

/***/ }),

/***/ 333:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _purchaseOptions = __webpack_require__(216);
	
	var _purchaseOptions2 = _interopRequireDefault(_purchaseOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Purchase = function (_React$Component) {
	  _inherits(Purchase, _React$Component);
	
	  function Purchase(props) {
	    _classCallCheck(this, Purchase);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Purchase.prototype.calculateDiscount = function calculateDiscount() {
	    var product_price = Number(this.props.product.variants[this.props.selectedVariantIndex].price);
	    var subscription_price = Number(this.props.subscription.variants[this.props.selectedVariantIndex].price);
	    var difference = product_price - subscription_price;
	    difference = Math.round(difference);
	    var discount = difference / product_price * 100;
	    return Math.round(discount);
	  };
	
	  Purchase.prototype.render = function render() {
	    var _this2 = this;
	
	    var price = this.props.variant.price;
	    var discount = this.calculateDiscount();
	
	    var discountPrice = this.props.subscription.variants[this.props.selectedVariantIndex].price;
	
	    return _react2.default.createElement(
	      "div",
	      { className: "Purchase" },
	      _react2.default.createElement(
	        "div",
	        {
	          className: (0, _classnames2.default)("one-time", {
	            active: this.props.selected === _purchaseOptions2.default.ONE_TIME
	          }),
	          onClick: function onClick() {
	            _this2.props.update(_purchaseOptions2.default.ONE_TIME);
	          }
	        },
	        _react2.default.createElement("div", { className: "radio" }),
	        _react2.default.createElement(
	          "div",
	          { className: "info" },
	          _react2.default.createElement(
	            "span",
	            { className: "label" },
	            "One time purchase"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "price" },
	            new Intl.NumberFormat("en-EN", {
	              style: "currency",
	              currency: "USD"
	            }).format(price)
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        {
	          className: (0, _classnames2.default)("subscription", {
	            active: this.props.selected === _purchaseOptions2.default.SUBSCRIPTION
	          }),
	          onClick: function onClick() {
	            _this2.props.update(_purchaseOptions2.default.SUBSCRIPTION);
	          }
	        },
	        _react2.default.createElement("div", { className: "radio" }),
	        _react2.default.createElement(
	          "div",
	          { className: "info" },
	          _react2.default.createElement(
	            "span",
	            { className: "label" },
	            "Subscribe & Save \u2013 ",
	            discount,
	            "% Off"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "price" },
	            new Intl.NumberFormat("en-EN", {
	              style: "currency",
	              currency: "USD"
	            }).format(discountPrice)
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "save" },
	            "Save",
	            " ",
	            new Intl.NumberFormat("en-EN", {
	              style: "currency",
	              currency: "USD"
	            }).format(price - discountPrice)
	          ),
	          _react2.default.createElement(
	            "a",
	            { className: "learn", onClick: this.props.handleMoreInfo },
	            "Learn More"
	          )
	        )
	      )
	    );
	  };
	
	  return Purchase;
	}(_react2.default.Component);
	
	exports.default = Purchase;
	module.exports = exports["default"];

/***/ }),

/***/ 334:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import ClassNames from 'classnames'
	
	var Reviews = function (_React$Component) {
	  _inherits(Reviews, _React$Component);
	
	  function Reviews(props) {
	    _classCallCheck(this, Reviews);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Reviews.prototype.componentDidMount = function componentDidMount() {
	    if (window.Yotpo) {
	      var api = new Yotpo.API(yotpo);
	      api.refreshWidgets();
	    } else {
	      var e = document.createElement("script");
	      e.type = "text/javascript", e.async = true, e.src = "//staticw2.yotpo.com/vZxrWB8nlZlNXL078cEM8dC3RU4OWEaVZDPYT1wX/widget.js";
	      var t = document.getElementsByTagName("script")[0];
	      t.parentNode.insertBefore(e, t);
	    }
	  };
	
	  Reviews.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "Reviews" },
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { id: "Reviews", className: "header" },
	          _react2.default.createElement(
	            "h3",
	            null,
	            "Customer Reviews"
	          )
	        ),
	        _react2.default.createElement("div", {
	          className: "yotpo yotpo-main-widget",
	          "data-product-id": this.props.sku,
	          "data-price": this.props.product.price,
	          "data-currency": "USD",
	          "data-name": this.props.product.title,
	          "data-url": this.props.url,
	          "data-image-url": this.props.product.images[0].originalSrc,
	          "data-description": this.props.product.description
	        })
	      )
	    );
	  };
	
	  return Reviews;
	}(_react2.default.Component);
	
	exports.default = Reviews;
	module.exports = exports["default"];

/***/ }),

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _variant = __webpack_require__(336);
	
	var _variant2 = _interopRequireDefault(_variant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import ClassNames from 'classnames'
	
	var Selector = function (_React$Component) {
	  _inherits(Selector, _React$Component);
	
	  function Selector(props) {
	    _classCallCheck(this, Selector);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      selectedVariant: 1
	    };
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    return _this;
	  }
	
	  Selector.prototype.handleSelect = function handleSelect(n) {
	    this.setState({ selectedVariant: n });
	    this.props.onSelectVariant(n);
	  };
	
	  Selector.prototype.appendToFilename = function appendToFilename(filename, string) {
	    var dotIndex = filename.lastIndexOf(".");
	    if (dotIndex === -1) {
	      return filename + string;
	    } else {
	      return filename.substring(0, dotIndex) + string + filename.substring(dotIndex);
	    }
	  };
	
	  Selector.prototype.render = function render() {
	    var _this2 = this;
	
	    var sku = "749353336876";
	    var url = "https://www.drinkyogaflow.com";
	
	    return _react2.default.createElement(
	      "div",
	      { className: "Selector" },
	      _react2.default.createElement(
	        "ul",
	        { id: "BuyNow", className: "steps" },
	        _react2.default.createElement(
	          "li",
	          { className: "active" },
	          _react2.default.createElement(
	            "span",
	            { className: "number" },
	            "1"
	          ),
	          "Select Package"
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            "span",
	            { className: "number" },
	            "2"
	          ),
	          "Payment Info"
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            "span",
	            { className: "number" },
	            "3"
	          ),
	          "Thank You"
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "variants" },
	        _react2.default.createElement(
	          "h4",
	          null,
	          "Select quantity"
	        ),
	        _react2.default.createElement(
	          "ul",
	          null,
	          this.props.product.variants.map(function (variant, i) {
	            return _react2.default.createElement(_variant2.default, {
	              selected: i === _this2.state.selectedVariant,
	              data: variant,
	              key: i,
	              n: i,
	              handleSelect: _this2.handleSelect,
	              originalPerBoxPrice: _this2.props.product.variants[0].price
	            });
	          })
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "image" },
	        _react2.default.createElement("div", {
	          className: "yotpo bottomLine",
	          "data-product-id": sku,
	          "data-url": url
	        }),
	        _react2.default.createElement("img", { src: this.props.product.images[0].originalSrc })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "intro-testimonial" },
	        _react2.default.createElement(
	          "div",
	          { className: "profile" },
	          _react2.default.createElement("img", { className: "profile__image", src: "/images/buy/anne-lane-salice.png" }),
	          _react2.default.createElement(
	            "div",
	            { className: "profile__container" },
	            _react2.default.createElement(
	              "span",
	              { className: "name" },
	              "Anne Salice"
	            ),
	            _react2.default.createElement(
	              "span",
	              { className: "quote" },
	              "Worth Every Penny"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "text" },
	          _react2.default.createElement(
	            "p",
	            null,
	            "I didn\u2019t know if it would be worth trying Yoga Flow, but I liked the ingredients. They are simple and beneficial for me. I don't like eating processed stuff with chemicals that need to be detoxed from my body."
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "And then I thought, well, it's more like, am I worth it? So I decided that I was, and I gave it a try. Well, I love it."
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "It tastes a lot better than I thought it would. It\u2019s not sugary sweet but not bland, so it\u2019s something I drink regularly. And Ashwagandha is great for stress relief."
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "benefits" },
	        _react2.default.createElement(
	          "ul",
	          null,
	          _react2.default.createElement(
	            "li",
	            { onClick: this.props.handleFreeShippingInfo },
	            "Free Shipping"
	          ),
	          _react2.default.createElement(
	            "li",
	            { onClick: this.props.handleRefundPolicyInfo },
	            "100% Satisfaction Guarantee"
	          ),
	          _react2.default.createElement(
	            "li",
	            { onClick: this.props.handleNutritionalInfo },
	            "Nutritional Info"
	          )
	        )
	      )
	    );
	  };
	
	  return Selector;
	}(_react2.default.Component);
	
	exports.default = Selector;
	module.exports = exports["default"];

/***/ }),

/***/ 336:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Terms = function (_React$Component) {
	  _inherits(Terms, _React$Component);
	
	  function Terms(props) {
	    _classCallCheck(this, Terms);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    var title = _this.props.data.title;
	    var bracketsRe = /\((.*)\)/;
	    var hint = title.match(bracketsRe)[0];
	    title = title.replace(" " + hint, "");
	    var quantity = parseInt(title.replace(/^\D+/g, ""));
	    var price = parseFloat(_this.props.data.price.replace(",", "."));
	    var perBoxPrice = price / quantity;
	    var amountSaved = Math.ceil(parseFloat(_this.props.originalPerBoxPrice) - perBoxPrice);
	
	    _this.state = {
	      title: title,
	      hint: hint,
	      quantity: quantity,
	      price: price,
	      perBoxPrice: perBoxPrice,
	      amountSaved: amountSaved
	    };
	
	    _this.select = _this.select.bind(_this);
	    return _this;
	  }
	
	  Terms.prototype.select = function select(event) {
	    event.preventDefault();
	    this.props.handleSelect(this.props.n);
	  };
	
	  Terms.prototype.renderSaveAmount = function renderSaveAmount(amountSaved) {
	    // Return empty string if difference is 0, no amount to be saved from this purchase
	    if (amountSaved === 0) {
	      return '';
	    }
	
	    return [_react2.default.createElement(
	      "span",
	      { key: 0 },
	      "\xA0-\xA0"
	    ), _react2.default.createElement(
	      "span",
	      { key: 1, className: "save" },
	      "Save ",
	      new Intl.NumberFormat("en-EN", {
	        style: "currency",
	        currency: "USD"
	      }).format(amountSaved)
	    )];
	  };
	
	  Terms.prototype.renderTag = function renderTag(text, key, matchkey) {
	    if (key !== matchkey) {
	      return '';
	    }
	
	    return [_react2.default.createElement(
	      "div",
	      { key: 0, className: "badge" },
	      _react2.default.createElement(
	        "span",
	        null,
	        text
	      )
	    )];
	  };
	
	  Terms.prototype.render = function render() {
	    var title = this.props.data.title;
	
	    return _react2.default.createElement(
	      "li",
	      {
	        className: (0, _classnames2.default)({
	          Variant: true,
	          active: this.props.selected
	        }),
	        onClick: this.select
	      },
	      this.renderTag('Best Seller', this.props.n, 1),
	      this.renderTag('Best Value', this.props.n, 2),
	      _react2.default.createElement("div", { className: "radio" }),
	      _react2.default.createElement(
	        "div",
	        { className: "info" },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "span",
	            { className: "title" },
	            this.state.title
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "hint" },
	            this.state.hint
	          )
	        ),
	        _react2.default.createElement(
	          "span",
	          { className: "price" },
	          new Intl.NumberFormat("en-EN", {
	            style: "currency",
	            currency: "USD"
	          }).format(this.state.perBoxPrice),
	          " ",
	          "/ box"
	        ),
	        this.renderSaveAmount(this.state.amountSaved)
	      )
	    );
	  };
	
	  return Terms;
	}(_react2.default.Component);
	
	exports.default = Terms;
	module.exports = exports["default"];

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _renderHtml = __webpack_require__(24);
	
	var _renderHtml2 = _interopRequireDefault(_renderHtml);
	
	var _bus = __webpack_require__(9);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BUS = new _bus2.default();
	
	var IngredientsModal = function (_React$Component) {
	  _inherits(IngredientsModal, _React$Component);
	
	  function IngredientsModal(props) {
	    _classCallCheck(this, IngredientsModal);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      open: false
	    };
	    _this.open = _this.open.bind(_this);
	    _this.close = _this.close.bind(_this);
	    return _this;
	  }
	
	  IngredientsModal.prototype.componentDidMount = function componentDidMount() {
	    BUS.listen("OPEN_INGREDIENTMODAL", this.open);
	  };
	
	  IngredientsModal.prototype.componentWillUnmount = function componentWillUnmount() {
	    BUS.stopListening("OPEN_INGREDIENTMODAL", this.open);
	  };
	
	  IngredientsModal.prototype.open = function open(event) {
	    console.log(event);
	    this.setState({
	      open: true,
	      content: event.detail.content
	    });
	  };
	
	  IngredientsModal.prototype.close = function close() {
	    this.setState({
	      open: false
	    });
	  };
	
	  IngredientsModal.prototype.render = function render() {
	    if (!this.state.open) {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      "div",
	      { className: "TextModal" },
	      _react2.default.createElement("div", { className: "bg", onClick: this.close }),
	      _react2.default.createElement(
	        "div",
	        { className: "content" },
	        _react2.default.createElement("div", {
	          className: "TextContent",
	          dangerouslySetInnerHTML: _renderHtml2.default.go(this.state.content)
	        })
	      ),
	      _react2.default.createElement(
	        "button",
	        { className: "close", onClick: this.close },
	        _react2.default.createElement(
	          "span",
	          null,
	          "\xD7"
	        )
	      )
	    );
	  };
	
	  return IngredientsModal;
	}(_react2.default.Component);
	
	exports.default = IngredientsModal;
	module.exports = exports["default"];

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _shopifyBuy = __webpack_require__(27);
	
	var _shopifyBuy2 = _interopRequireDefault(_shopifyBuy);
	
	var _bus = __webpack_require__(9);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BUS = new _bus2.default();
	
	var NutritionalModal = function (_React$Component) {
	  _inherits(NutritionalModal, _React$Component);
	
	  function NutritionalModal(props) {
	    _classCallCheck(this, NutritionalModal);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      open: false
	    };
	    _this.open = _this.open.bind(_this);
	    _this.close = _this.close.bind(_this);
	    return _this;
	  }
	
	  NutritionalModal.prototype.componentDidMount = function componentDidMount() {
	    if (window.location.hash === "#nutritional-facts") {
	      this.setState({ open: true });
	    }
	    BUS.listen("OPEN_NUTRITIONAL", this.open);
	  };
	
	  NutritionalModal.prototype.componentWillUnmount = function componentWillUnmount() {
	    BUS.stopListening("OPEN_NUTRITIONAL", this.open);
	  };
	
	  NutritionalModal.prototype.open = function open() {
	    this.setState({
	      open: true
	    });
	  };
	
	  NutritionalModal.prototype.close = function close() {
	    this.setState({
	      open: false
	    });
	  };
	
	  NutritionalModal.prototype.render = function render() {
	    var data = this.props.data;
	
	    if (!this.state.open) {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      "div",
	      { className: "NutritionalModal" },
	      _react2.default.createElement("div", { className: "bg", onClick: this.close }),
	      _react2.default.createElement(
	        "a",
	        { className: "close", onClick: this.close },
	        _react2.default.createElement(
	          "span",
	          null,
	          "\xD7"
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "image" },
	        _react2.default.createElement("img", { src: data.fluid.src })
	      )
	    );
	  };
	
	  return NutritionalModal;
	}(_react2.default.Component);
	
	exports.default = NutritionalModal;
	module.exports = exports["default"];

/***/ }),

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyPluginSmoothscroll = __webpack_require__(139);
	
	var _gatsbyPluginSmoothscroll2 = _interopRequireDefault(_gatsbyPluginSmoothscroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Supercharge = function (_React$Component) {
	  _inherits(Supercharge, _React$Component);
	
	  function Supercharge(props) {
	    _classCallCheck(this, Supercharge);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Supercharge.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'Supercharge' },
	      _react2.default.createElement(
	        'div',
	        { className: 'internal' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          this.props.title
	        ),
	        _react2.default.createElement(
	          'a',
	          { onClick: function onClick() {
	              return (0, _gatsbyPluginSmoothscroll2.default)('#BuyNow');
	            }, className: 'Btn orange-white' },
	          this.props.callToAction
	        )
	      )
	    );
	  };
	
	  return Supercharge;
	}(_react2.default.Component);
	
	exports.default = Supercharge;
	module.exports = exports['default'];

/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(10);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(113);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _shopifyBuy = __webpack_require__(27);
	
	var _shopifyBuy2 = _interopRequireDefault(_shopifyBuy);
	
	var _discount = __webpack_require__(126);
	
	var _discount2 = _interopRequireDefault(_discount);
	
	var _header = __webpack_require__(328);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _intro = __webpack_require__(331);
	
	var _intro2 = _interopRequireDefault(_intro);
	
	var _reviews = __webpack_require__(334);
	
	var _reviews2 = _interopRequireDefault(_reviews);
	
	var _selector = __webpack_require__(335);
	
	var _selector2 = _interopRequireDefault(_selector);
	
	var _purchase = __webpack_require__(333);
	
	var _purchase2 = _interopRequireDefault(_purchase);
	
	var _lessStress = __webpack_require__(332);
	
	var _lessStress2 = _interopRequireDefault(_lessStress);
	
	var _superchargeCta = __webpack_require__(368);
	
	var _superchargeCta2 = _interopRequireDefault(_superchargeCta);
	
	var _purchaseOptions = __webpack_require__(216);
	
	var _purchaseOptions2 = _interopRequireDefault(_purchaseOptions);
	
	var _bus = __webpack_require__(9);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _ingredients = __webpack_require__(330);
	
	var _ingredients2 = _interopRequireDefault(_ingredients);
	
	var _nutritionalModal = __webpack_require__(69);
	
	var _nutritionalModal2 = _interopRequireDefault(_nutritionalModal);
	
	var _badges = __webpack_require__(327);
	
	var _badges2 = _interopRequireDefault(_badges);
	
	var _highlightedReviews = __webpack_require__(329);
	
	var _highlightedReviews2 = _interopRequireDefault(_highlightedReviews);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DISCOUNT = new _discount2.default();
	
	var client = _shopifyBuy2.default.buildClient({
	  domain: "store.drinkyogaflow.com",
	  storefrontAccessToken: "50ad06d768e2ba0eadfce5bda1608413"
	});
	
	var BUS = new _bus2.default();
	
	var BuyPage = function (_React$Component) {
	  _inherits(BuyPage, _React$Component);
	
	  function BuyPage(props) {
	    _classCallCheck(this, BuyPage);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      selectedVariantIndex: 1,
	      selectedPurchaseOption: _purchaseOptions2.default.ONE_TIME,
	      instructor: ""
	    };
	    _this.changeSelection = _this.changeSelection.bind(_this);
	    _this.purchaseProduct = _this.purchaseProduct.bind(_this);
	    _this.applyPromoCode = _this.applyPromoCode.bind(_this);
	    _this.changePurchaseType = _this.changePurchaseType.bind(_this);
	    _this.openFreeShippingInfo = _this.openFreeShippingInfo.bind(_this);
	    _this.openRefundPolicyInfo = _this.openRefundPolicyInfo.bind(_this);
	    _this.openDeliveryInfo = _this.openDeliveryInfo.bind(_this);
	    _this.handlePurchase = _this.handlePurchase.bind(_this);
	    return _this;
	  }
	
	  BuyPage.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    if (client) {
	      client.checkout.create().then(function (checkout) {
	        _this2.setState({
	          checkout: checkout
	        });
	      });
	    }
	    var _learnq = _learnq || [];
	    var product = this.props.data.product;
	    var item = {
	      Name: product.title,
	      ProductID: product.id,
	      ImageURL: product.images[0].originalSrc,
	      URL: "https://www.drinkyogaflow.com/",
	      Brand: "Weekday Warriors",
	      Price: product.price
	    };
	    _learnq.push(["track", "Viewed Product", item]);
	    _learnq.push(["trackViewedItem", {
	      Title: item.Name,
	      ItemId: item.ProductID,
	      Categories: item.Categories,
	      ImageUrl: item.ImageURL,
	      Url: item.URL,
	      Metadata: {
	        Brand: item.Brand,
	        Price: item.Price
	      }
	    }]);
	
	    // FB Pixel event
	    if (typeof window !== "undefined") {
	      if (window.fbq != null) {
	        window.fbq('track', 'ViewContent');
	      }
	    }
	  };
	
	  BuyPage.prototype.applyPromoCode = function applyPromoCode(code) {
	    this.setState({
	      instructor: code
	    });
	  };
	
	  BuyPage.prototype.handlePurchase = function handlePurchase() {
	    var product = this.props.data.product;
	    var variant = product.variants[this.state.selectedVariantIndex];
	    switch (this.state.selectedPurchaseOption) {
	      case _purchaseOptions2.default.ONE_TIME:
	        this.purchaseProduct(variant.shopifyId);
	        break;
	      case _purchaseOptions2.default.SUBSCRIPTION:
	        product = this.props.data.subscription;
	        var return_url = window.location.origin + "/purchase-subscription";
	        var url = "https://store.drinkyogaflow.com/products/" + product.handle + "?variant_index=" + this.state.selectedVariantIndex + "&return_url=" + encodeURI(return_url) + "&to_sub=true&instructor=" + this.state.instructor;
	        window.location.href = url;
	        break;
	      default:
	        return;
	    }
	  };
	
	  BuyPage.prototype.changePurchaseType = function changePurchaseType(type) {
	    this.setState({
	      selectedPurchaseOption: type
	    });
	  };
	
	  BuyPage.prototype.learnMore = function learnMore(event) {
	    event.preventDefault();
	    BUS.trigger("show-text-modal", {
	      html: this.props.data.collection.descriptionHtml
	    });
	  };
	
	  BuyPage.prototype.purchaseProduct = function purchaseProduct(variantId) {
	    var _this3 = this;
	
	    if (this.state.checkout) {
	      var checkoutId = this.state.checkout.id;
	      var lineItemsToAdd = [{
	        variantId: variantId,
	        quantity: 1
	      }];
	
	      var note = "Instructor not specified";
	      if (this.state.instructor !== "") {
	        note = "Instructor: " + this.state.instructor;
	      }
	
	      client.checkout.create({
	        lineItems: lineItemsToAdd,
	        note: note
	      }).then(function (checkout) {
	        _this3.setState({
	          checkout: checkout,
	          canInteract: true
	        });
	        var webUrl = checkout.webUrl;
	        if (window.ga && ga.create) {
	          var client_id = ga.getAll()[0].get('linkerParam');
	          if (client_id.length > 0) {
	            webUrl += '&' + client_id;
	          }
	        }
	        window.location.href = webUrl;
	      }).catch(function (error) {
	        console.log("addToCart error", error);
	      });
	    }
	  };
	
	  BuyPage.prototype.openFreeShippingInfo = function openFreeShippingInfo() {
	    var data = this.props.data;
	
	    BUS.trigger("show-text-modal", {
	      html: data.freeShippingInfo.content
	    });
	  };
	
	  BuyPage.prototype.openRefundPolicyInfo = function openRefundPolicyInfo() {
	    var data = this.props.data;
	
	    BUS.trigger("show-text-modal", {
	      html: data.refundPolicyInfo.content
	    });
	  };
	
	  BuyPage.prototype.openNutritionalInfo = function openNutritionalInfo() {
	    BUS.trigger("OPEN_NUTRITIONAL");
	  };
	
	  BuyPage.prototype.openDeliveryInfo = function openDeliveryInfo() {
	    BUS.trigger("show-text-modal", {
	      html: this.props.data.deliveryInfo.content
	    });
	  };
	
	  BuyPage.prototype.changeSelection = function changeSelection(i) {
	    this.setState({
	      selectedVariantIndex: i
	    });
	  };
	
	  BuyPage.prototype.render = function render() {
	    var data = this.props.data;
	    var domain = "https://www.drinkyogaflow.com";
	    var sku = "749353336876";
	    var url = "https://www.drinkyogaflow.com";
	    var homepage = this.props.data.homepage.edges[0].node;
	    var ingredients = this.props.data.ingredients.edges;
	
	    return _react2.default.createElement(
	      "div",
	      { className: "Buy" },
	      _react2.default.createElement(_selector2.default, {
	        product: data.product,
	        onSelectVariant: this.changeSelection,
	        handleFreeShippingInfo: this.openFreeShippingInfo,
	        handleRefundPolicyInfo: this.openRefundPolicyInfo,
	        handleNutritionalInfo: this.openNutritionalInfo
	      }),
	      _react2.default.createElement(_purchase2.default, {
	        update: this.changePurchaseType,
	        options: _purchaseOptions2.default,
	        product: data.product,
	        subscription: data.subscription,
	        selected: this.state.selectedPurchaseOption,
	        selectedVariantIndex: this.state.selectedVariantIndex,
	        variant: data.product.variants[this.state.selectedVariantIndex],
	        handleMoreInfo: this.openDeliveryInfo
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "btn-container" },
	        _react2.default.createElement(
	          "button",
	          { onClick: this.handlePurchase, className: "Btn btn-lg orange-white" },
	          "Buy now"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "guarantee-text" },
	          "100% NO-RISK MONEY BACK GUARANTEE"
	        ),
	        _react2.default.createElement("img", { className: "secure-payment-logos", src: "/images/buy/safe-checkout-logos.png", alt: "Secure Checkout" })
	      ),
	      _react2.default.createElement(_badges2.default, null),
	      _react2.default.createElement(_reviews2.default, { url: url, sku: sku, product: data.product }),
	      _react2.default.createElement(_nutritionalModal2.default, { data: homepage.nutritionalInfo })
	    );
	  };
	
	  return BuyPage;
	}(_react2.default.Component);
	
	exports.default = BuyPage;
	
	
	BuyPage.propTypes = {
	  data: _propTypes2.default.shape({
	    collection: _propTypes2.default.object.isRequired,
	    product: _propTypes2.default.object.isRequired
	  }).isRequired
	};
	
	/* eslint no-undef: "off" */
	var query = exports.query = "** extracted graphql fragment **";

/***/ }),

/***/ 78:
/***/ (function(module, exports) {

	module.exports = {"discount_cookie":"ww_discount_final3","cart_id":"ww_cart_id_4"}

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _jsCookie = __webpack_require__(77);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	var _queryParse = __webpack_require__(61);
	
	var _queryParse2 = _interopRequireDefault(_queryParse);
	
	var _cookie = __webpack_require__(78);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	var _bus = __webpack_require__(9);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BUS = new _bus2.default();
	
	var instance = null;
	
	var Discount = function () {
	  function Discount() {
	    _classCallCheck(this, Discount);
	
	    if (!instance) {
	      this.discount = 0;
	      this.checkForDiscount();
	      instance = this;
	    }
	    return instance;
	  }
	
	  Discount.prototype.amount = function amount() {
	    return this.discount;
	  };
	
	  Discount.prototype.checkForDiscount = function checkForDiscount() {
	    if (typeof window === "undefined") {
	      return;
	    }
	    var search = window.location.search.slice(1);
	    var queryObj = _queryParse2.default.toObject(search);
	    if (queryObj.discount === "20OFF") {
	      BUS.trigger("DISCOUNT_APPLIED");
	      this.discount = 0.2;
	      _jsCookie2.default.get(_cookie2.default.discount_cookie) === undefined ? _jsCookie2.default.set(_cookie2.default.discount_cookie, true, { expires: 1 }) : _jsCookie2.default.get(_cookie2.default.discount_cookie);
	    }
	    if (_jsCookie2.default.get(_cookie2.default.discount_cookie) !== undefined) {
	      this.discount = 0.2;
	      BUS.trigger("DISCOUNT_APPLIED");
	    }
	  };
	
	  return Discount;
	}();
	
	exports.default = Discount;
	module.exports = exports["default"];

/***/ }),

/***/ 24:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = {
	  convert: function convert(content) {
	    content = content.replace("Yoga Flow", "Yoga Flow<span class='special'>➁</span>");
	    content = content.replace("Protein Joe", "Protein Joe<span class='special'>➁</span>");
	    return content;
	  },
	  go: function go(content) {
	    return {
	      __html: this.convert(content)
	    };
	  }
	};
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-buy-js-c0ac91b1456ba76bad85.js